import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { 
    Search, Wallet, Plus, RefreshCw, TrendingUp, TrendingDown, 
    DollarSign, FileText, X, Save, Edit, Trash2, Filter, 
    Download, Printer, Eye, CheckCircle, XCircle, ArrowRight,
    Building, Phone, Copy, User, Calendar, AlertCircle, Clock, BarChart2,
    CreditCard, Info, Share2, Zap, Clipboard, Settings, Package,FileSpreadsheet, Briefcase,
    Check, CreditCard as BankIcon
} from 'lucide-react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import config from '../config';
import usePermissions from './usePermissions';
const API_BASE = `${config.API_BASE_URL}/api/client-accounts`;


// مكون البحث عن العملاء
const SearchClientBox = ({ 
    onSearch, 
    onSelect, 
    isSearching, 
    searchResults, 
    selectedClient, 
    onClearSelection 
}) => {
    const [searchTerm, setSearchTerm] = useState('');
    const clientSearchTimerRef = useRef(null);

    useEffect(() => {
        return () => {
            if (clientSearchTimerRef.current) {
                clearTimeout(clientSearchTimerRef.current);
            }
        };
    }, []);

    return (
        <div className="mb-6">
            <div className="relative">
                <input
                    type="text"
                    value={searchTerm}
                    onChange={(e) => {
                        const value = e.target.value;
                        setSearchTerm(value);

                        if (clientSearchTimerRef.current) {
                            clearTimeout(clientSearchTimerRef.current);
                        }

                        clientSearchTimerRef.current = setTimeout(() => {
                            onSearch(value);
                        }, 500);
                    }}
                    placeholder="ابحث عن عميل برقم الملف، الاسم، رقم الجواز، أو رقم الهاتف..."
                    className="w-full border border-gray-300 rounded-lg px-4 py-3 
                             focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    autoFocus
                />
                {isSearching && (
                    <div className="absolute left-3 top-1/2 -translate-y-1/2">
                        <div className="animate-spin rounded-full h-5 w-5 
                                    border-2 border-blue-600 border-t-transparent">
                        </div>
                    </div>
                )}
            </div>

            {searchResults.length > 0 && (
                <div className="mt-2 border rounded-lg shadow-lg max-h-64 
                             overflow-y-auto bg-white divide-y divide-gray-100">
                    {searchResults.map(client => (
                        <div
                            key={client.PassportID}
                            className="p-4 hover:bg-blue-50 cursor-pointer 
                                     transition-colors duration-200"
                            onClick={() => {
                                if (clientSearchTimerRef.current) {
                                    clearTimeout(clientSearchTimerRef.current);
                                }
                                onSelect(client);
                                setSearchTerm('');
                            }}
                        >
                            <div className="flex justify-between items-start">
                                <div>
                                    <div className="font-medium text-gray-900 flex items-center gap-2">
                                        <User size={16} className="text-blue-500" />
                                        {client.NameArabic}
                                    </div>
                                    <div className="text-sm text-gray-500 mt-1 flex items-center gap-2">
                                        <CreditCard size={14} className="text-gray-400" />
                                        معرف العميل: {client.PassportID}
                                    </div>
                                    <div className="text-sm text-gray-500 flex items-center gap-2">
                                        <Clipboard size={14} className="text-gray-400" />
                                        الرقم القومي: {client.NationalID} {/* تغيير من PassportNumber إلى NationalID */}
                                    </div>
                                    {client.CompanyName && (
                                        <div className="text-sm text-gray-500 flex items-center gap-2">
                                            <Building size={14} className="text-gray-400" />
                                            الشركة: {client.CompanyName}
                                        </div>
                                    )}
                                    {client.DelegateName && (
                                        <div className="text-sm text-gray-500 flex items-center gap-2">
                                            <Share2 size={14} className="text-gray-400" />
                                            المندوب: {client.DelegateName}
                                        </div>
                                    )}
                                </div>
                                <div className="text-left">
                                    <div className="text-sm font-medium ${
                                    client.CurrentBalance >= 0 ? 'text-green-600' : 'text-red-600'
                                    } flex items-center gap-1 justify-end">
                                    <DollarSign size={14} />
                                    الرصيد النشط: {client.CurrentBalance?.toLocaleString()} ج.م
                                    </div>
                                    {Array.isArray(client.PhoneNumbers) && client.PhoneNumbers[0] && (
                                        <div className="text-sm text-gray-500 mt-1 text-left flex items-center gap-1 justify-end">
                                            <Phone size={14} className="text-gray-400" />
                                            {client.PhoneNumbers[0]}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

{selectedClient && !searchResults.length && !isSearching && (
    <div className="mt-3 p-4 bg-blue-50 rounded-lg">
        <div className="flex justify-between items-start">
            <div>
                <div className="font-medium flex items-center gap-2">
                    <Info size={16} className="text-blue-600" />
                    العميل المحدد:
                </div>
                <div className="text-sm mt-1 flex items-center gap-2">
                    <User size={14} className="text-gray-600" />
                    {selectedClient.NameArabic} - {selectedClient.PassportNumber}
                </div>
                <div className="text-sm text-gray-500 flex items-center gap-2">
                    <CreditCard size={14} className="text-gray-600" />
                    معرف العميل: {selectedClient.PassportID}
                </div>
                {/* إضافة الرقم القومي */}
                <div className="text-sm text-gray-500 flex items-center gap-2">
                    <Clipboard size={14} className="text-gray-600" />
                    الرقم القومي: {selectedClient.NationalID || "-"}
                </div>
                {/* إضافة رقم الجواز */}
                <div className="text-sm text-gray-500 flex items-center gap-2">
                    <FileText size={14} className="text-gray-600" />
                    رقم الجواز: {selectedClient.PassportNumber || "-"}
                </div>
                {/* إضافة معلومات المندوب */}
                <div className="text-sm text-gray-500 flex items-center gap-2">
                    <Briefcase size={14} className="text-gray-600" />
                    المندوب: {selectedClient.DelegateName || "-"}
                </div>
                {selectedClient.CompanyName && (
                    <div className="text-sm text-gray-500 flex items-center gap-2">
                        <Building size={14} className="text-gray-600" />
                        الشركة: {selectedClient.CompanyName}
                    </div>
                )}
            </div>
            <button
                onClick={onClearSelection}
                className="text-gray-500 hover:text-gray-700"
            >
                <X size={20} />
            </button>
        </div>
    </div>
)}
        </div>
    );
};

// المكون الرئيسي
const ClientAccounts = () => {
       const EDIT_ENABLED = true;
    const { hasPermission } = usePermissions();

    // دالة مساعدة للتحقق من صلاحيات حسابات العملاء
    const canDo = (permission) => hasPermission('حسابات العملاء - الصلاحيات', permission);

    // جلب اسم المستخدم الحالي
    const getCurrentUser = () => {
        try {
            const user = JSON.parse(localStorage.getItem('user'));
            return user?.Username || 'System';
        } catch { return 'System'; }
    };

    // States
   const [recentTransactions, setRecentTransactions] = useState([]);
   const [loading, setLoading] = useState(true);

   const [paymentMethods, setPaymentMethods] = useState([]);
   const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);


   const [showRequiredPaymentManager, setShowRequiredPaymentManager] = useState(false);
   const [showDebtManager, setShowDebtManager] = useState(false);
const [allClients, setAllClients] = useState([]);
const [allCompanies, setAllCompanies] = useState([]);


   const [showTransactionForm, setShowTransactionForm] = useState(false);
   const [showDeactivateDialog, setShowDeactivateDialog] = useState(false);
const [securityCode, setSecurityCode] = useState('');
const [deactivationFilter, setDeactivationFilter] = useState({
    clientName: '',
    dateFrom: '',
    dateTo: ''
});
   const [showAccountDetails, setShowAccountDetails] = useState(false);
   const [selectedClient, setSelectedClient] = useState(null);
   const [searchQuery, setSearchQuery] = useState('');
   const transactionSearchTimerRef = useRef(null);
   const [clientSearchResults, setClientSearchResults] = useState([]);
   const [isTransactionSearching, setIsTransactionSearching] = useState(false);
   const [isClientSearching, setIsClientSearching] = useState(false);
   const [filterVisible, setFilterVisible] = useState(false);
   const [isEditMode, setIsEditMode] = useState(false);
   const [editingTransaction, setEditingTransaction] = useState(null);
   const [toast, setToast] = useState(null);
   const [chartData, setChartData] = useState(null);
   const [showStats, setShowStats] = useState(false);
   const [initialLoad, setInitialLoad] = useState(true);
   const [dateRange, setDateRange] = useState('last10days');

   const [clientSearchQuery, setClientSearchQuery] = useState('');
   const [showActiveOnly, setShowActiveOnly] = useState(true); // للتحكم في عرض المعاملات النشطة فقط
     const [isProcessing, setIsProcessing] = useState(false); // لعرض حالة المعالجة عند تغيير نشاط المعاملات
     const [paymentHistory, setPaymentHistory] = useState([]);
const [showPaymentHistory, setShowPaymentHistory] = useState(false);
// حالات نظام الصفحات
const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage, setItemsPerPage] = useState(30);


// إضافة هذه الحالات مع باقي الحالات في بداية المكون
const [showSettingsMenu, setShowSettingsMenu] = useState(false);
const [showActivateDialog, setShowActivateDialog] = useState(false);
const [showScheduleDialog, setShowScheduleDialog] = useState(false);
// حالات التصدير المتقدم
const [isExportModalOpen, setIsExportModalOpen] = useState(false);
const [showAdvancedPrintModal, setShowAdvancedPrintModal] = useState(false);
const [printOptions, setPrintOptions] = useState({
  dateRange: 'all',
  customStartDate: '',
  customEndDate: '',
  includeInactive: true,
  selectedTypes: ['إيداع', 'سحب']
});
const [exportOptions, setExportOptions] = useState({
    format: 'excel',
    includeFilters: true,
    includeSummary: true,
    dateRange: 'current-page',
  customStartDate: '',
  customEndDate: '',
  selectedTypes: ['إيداع', 'سحب']
});

const [scheduledDeactivation, setScheduledDeactivation] = useState({
    isActive: false,
    frequency: 'daily', // يومي، أسبوعي، شهري، إلخ
    interval: 1, // كل كم (1 يوم، 2 أسبوع، إلخ)
    lastRun: null
});


     const [showPaymentForm, setShowPaymentForm] = useState(false);
const [paymentForm, setPaymentForm] = useState({
  RequiredPayment: '',
  Notes: ''
});


   const [stats, setStats] = useState({
       TotalTransactions: 0,
       TotalDeposits: 0,
       TotalWithdrawals: 0,
       CurrentBalance: 0
   });

   const [filters, setFilters] = useState({
       dateFrom: '',
       dateTo: '',
       transactionType: '',
       clientName: '',
       passportNumber: '',
       minAmount: '',
       maxAmount: ''
   });

   const [transactionForm, setTransactionForm] = useState({
    PassportID: '',
    TransactionType: 'إيداع',
    Amount: '',
    Notes: '',
    TransactionDate: new Date().toISOString().slice(0, 16),
    PaymentMethodID: null, // إضافة معرّف طريقة الدفع
    PaymentMethodType: null // إضافة نوع طريقة الدفع
  });


  useEffect(() => {
    const loadInitialData = async () => {
      await Promise.all([
        fetchStats(),
        fetchPaymentMethods()
      ]);
    };
    loadInitialData();
  }, []);

   useEffect(() => {
    return () => {
        if (transactionSearchTimerRef.current) {
            clearTimeout(transactionSearchTimerRef.current);
        }
    };
}, []);

   useEffect(() => {
    const handleKeyPress = (e) => {
        if ((e.ctrlKey || e.metaKey) && e.key === 'f') {
            e.preventDefault();
            document.querySelector('#searchInput')?.focus();
        }
        // إزالة أو تعليق التالي
        // if ((e.ctrlKey || e.metaKey) && e.key === 'n' && !showTransactionForm) {
        //     e.preventDefault();
        //     setShowTransactionForm(true);
        // }
        if (e.key === 'Escape') {
            if (showTransactionForm) setShowTransactionForm(false);
            if (showAccountDetails) setShowAccountDetails(false);
            if (filterVisible) setFilterVisible(false);
        }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
}, [showTransactionForm, showAccountDetails, filterVisible]);

   // Helpers
   const showToast = (message, type = 'success') => {
       setToast({ message, type });
       setTimeout(() => setToast(null), 3000);
   };

   const formatPhoneNumber = (phoneNumbers) => {
    // إذا كانت البيانات فارغة
    if (!phoneNumbers) return '-';
    
    try {
        let numbers = [];
        
        // إذا كان سلسلة نصية (string)
        if (typeof phoneNumbers === 'string') {
            // محاولة تحويلها إلى JSON إذا كانت بهذا الشكل
            try {
                const parsed = JSON.parse(phoneNumbers);
                
                // إذا كانت مصفوفة
                if (Array.isArray(parsed)) {
                    numbers = parsed.filter(n => n && n.length > 0);
                }
                // إذا كانت كائن
                else if (typeof parsed === 'object' && parsed !== null) {
                    numbers = Object.values(parsed).filter(n => n && n.length > 0);
                }
                else if (parsed) {
                    numbers = [parsed];
                }
            } catch (e) {
                // إذا لم تكن JSON صالح، استخدم النص كما هو إذا لم يكن []
                if (phoneNumbers !== '[]') {
                    numbers = [phoneNumbers];
                }
            }
        }
        // إذا كانت مصفوفة
        else if (Array.isArray(phoneNumbers)) {
            numbers = phoneNumbers.filter(n => n && n.length > 0);
        }
        // إذا كانت كائن
        else if (typeof phoneNumbers === 'object' && phoneNumbers !== null) {
            numbers = Object.values(phoneNumbers).filter(n => n && n.length > 0);
        }
        
        // إرجاع الأرقام مفصولة بفاصلة
        return numbers.length > 0 ? numbers.join(' ، ') : '-';
    } catch (error) {
        console.error('خطأ في معالجة رقم الهاتف:', error);
        return '-';
    }
};

const formatDisplayDate = (dateValue) => {
    if (!dateValue) return '-';
    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) return '-';
    return date.toLocaleDateString('ar-EG', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
};

const hasClientTraveled = (client) => Boolean(client?.TravelDate);

const getPreviousCompanyList = (client) => {
    const companies = client?.PreviousCompanies;
    if (!companies) return [];
    if (Array.isArray(companies)) {
        return companies.filter(company => company && String(company).trim());
    }
    if (typeof companies === 'string') {
        try {
            const parsed = JSON.parse(companies);
            return Array.isArray(parsed)
                ? parsed.filter(company => company && String(company).trim())
                : companies.split(/[،,]/).map(company => company.trim()).filter(Boolean);
        } catch {
            return companies.split(/[،,]/).map(company => company.trim()).filter(Boolean);
        }
    }
    return [];
};


// دوال نظام الصفحات
const totalPages = Math.ceil(recentTransactions.length / itemsPerPage);

const getPaginatedTransactions = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return recentTransactions.slice(startIndex, endIndex);
};

const handlePageChange = (page) => {
    setCurrentPage(page);
    document.getElementById('transactions-table')?.scrollIntoView({ behavior: 'smooth' });
};

// مكون التحكم في الصفحات
const PaginationControls = () => {
    const maxVisiblePages = 7;
    const pages = [];
    
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
    
    if (endPage - startPage < maxVisiblePages - 1) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }
    
    if (startPage > 1) {
        pages.push(
            <button
                key={1}
                onClick={() => handlePageChange(1)}
                className="px-3 py-2 text-sm border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 rounded-md"
            >
                1
            </button>
        );
        if (startPage > 2) {
            pages.push(
                <span key="dots-start" className="px-2 py-2 text-gray-500">
                    ...
                </span>
            );
        }
    }
    
    for (let i = startPage; i <= endPage; i++) {
        pages.push(
            <button
                key={i}
                onClick={() => handlePageChange(i)}
                className={`px-3 py-2 text-sm border rounded-md ${
                    i === currentPage
                        ? 'bg-blue-600 text-white border-blue-600'
                        : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'
                }`}
            >
                {i}
            </button>
        );
    }
    
    if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
            pages.push(
                <span key="dots-end" className="px-2 py-2 text-gray-500">
                    ...
                </span>
            );
        }
        pages.push(
            <button
                key={totalPages}
                onClick={() => handlePageChange(totalPages)}
                className="px-3 py-2 text-sm border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 rounded-md"
            >
                {totalPages}
            </button>
        );
    }
    
    return (
        <div className="bg-white px-3 sm:px-6 py-4 border-t border-gray-200">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                <div className="flex flex-col sm:flex-row sm:items-center flex-wrap gap-2">
                    <div className="text-sm text-gray-700">
                        عرض {((currentPage - 1) * itemsPerPage) + 1} إلى {Math.min(currentPage * itemsPerPage, recentTransactions.length)} من {recentTransactions.length} معاملة
                    </div>
                    
                    <div className="flex items-center gap-2">
                        <label className="text-sm text-gray-600">عدد المعاملات في الصفحة:</label>
                        <select
    value={itemsPerPage}
    onChange={(e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    }}
    className="px-2 py-1 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
>
    <option value={10}>10</option>
    <option value={20}>20</option>
    <option value={30}>30</option>
    <option value={50}>50</option>
    <option value={100}>100</option>
</select>
                    </div>
                </div>
                
                <div className="flex items-center gap-1 overflow-x-auto pb-1 max-w-full">
                    <button
                        onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
                        disabled={currentPage === 1}
                        className="px-3 py-2 text-sm border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        السابق
                    </button>
                    
                    {pages}
                    
                    <button
                        onClick={() => handlePageChange(Math.min(totalPages, currentPage + 1))}
                        disabled={currentPage === totalPages}
                        className="px-3 py-2 text-sm border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        التالي
                    </button>
                </div>
            </div>
        </div>
    );
};

const handlePaymentUpdateSuccess = async () => {
    // تحديث بيانات العميل بعد تحديث المبلغ المطلوب
    if (selectedClient && selectedClient.PassportID) {
        await fetchClientDetails(selectedClient.PassportID);
        showToast('تم تحديث المبلغ المطلوب بنجاح. يمكنك الآن إضافة إيداعات جديدة.', 'success');
    }
};




const AccountSummary = ({ client }) => {
    if (!client) return null;
    
    // حساب المبلغ المطلوب والمدفوع
    const requiredAmount = client.RequiredPayment !== undefined ? Number(client.RequiredPayment) : 0;
    const totalDeposits = client.TotalDeposits || 0;
    const totalWithdrawals = client.TotalWithdrawals || 0;
    
    // حساب صافي المبلغ المدفوع (الإيداعات - السحوبات)
    const netPaid = totalDeposits - totalWithdrawals;
    
    // إضافة حالات جديدة

    // حساب الفرق بين صافي المدفوع والمطلوب
    const difference = netPaid - requiredAmount;
    const isOverpaid = difference > 0;
    const remainingDue = Math.abs(difference);
    
    
    return (
      <div>
        {/* تحذير الأرشفة في أعلى الملخص */}
        {client.ClientIsActive === false && (
            <div className="mb-4 p-4 bg-yellow-50 border-2 border-yellow-200 rounded-xl">
                <div className="flex items-center justify-center">
                    <AlertCircle size={24} className="text-yellow-600 ml-2" />
                    <div className="text-center">
                        <h4 className="text-lg font-bold text-yellow-800">تنبيه: عميل مؤرشف</h4>
                        <p className="text-sm text-yellow-700">
                            هذا العميل مؤرشف ولن يظهر في قوائم الاختيار للمعاملات الجديدة
                        </p>
                    </div>
                </div>
            </div>
        )}

        {(Number(client.DebtSummary?.OutstandingEGP || 0) > 0 || Number(client.DebtSummary?.OutstandingSAR || 0) > 0) && (
            <div className="mb-4 rounded-xl border-2 border-rose-200 bg-rose-50 p-4">
                <div className="flex items-start gap-3">
                    <Wallet size={24} className="text-rose-600 mt-1 flex-shrink-0" />
                    <div className="flex-1">
                        <div className="flex items-center justify-between gap-3 flex-wrap">
                            <h4 className="text-lg font-black text-rose-800">مديونيات مفتوحة على الحساب الدائم للشخص</h4>
                            <span className="text-xs font-bold bg-rose-100 text-rose-700 px-3 py-1 rounded-full">
                                {Number(client.DebtSummary?.OpenDebtCount || 0)} مديونية
                            </span>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-3">
                            <div className="bg-white border border-rose-100 rounded-lg p-3">
                                <div className="text-xs text-gray-500">إجمالي المتبقي بالجنيه</div>
                                <div className="text-xl font-black text-rose-700">{Number(client.DebtSummary?.OutstandingEGP || 0).toLocaleString()} ج.م</div>
                            </div>
                            <div className="bg-white border border-rose-100 rounded-lg p-3">
                                <div className="text-xs text-gray-500">إجمالي المتبقي بالريال</div>
                                <div className="text-xl font-black text-rose-700">{Number(client.DebtSummary?.OutstandingSAR || 0).toLocaleString()} ر.س</div>
                            </div>
                        </div>
                        {(Number(client.DebtSummary?.PreviousTripsOutstandingEGP || 0) > 0 || Number(client.DebtSummary?.PreviousTripsOutstandingSAR || 0) > 0) && (
                            <div className="mt-3 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 text-sm font-bold text-amber-800">
                                توجد مديونية تخص سفرات سابقة مؤرشفة: {Number(client.DebtSummary?.PreviousTripsOutstandingEGP || 0).toLocaleString()} ج.م
                                {Number(client.DebtSummary?.PreviousTripsOutstandingSAR || 0) > 0 ? ` + ${Number(client.DebtSummary.PreviousTripsOutstandingSAR).toLocaleString()} ر.س` : ''}.
                                لا تُنقل هذه المديونية إلى السفرة الحالية.
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )}

        {/* بطاقة الرصيد النشط المميزة */}
        <div className="mb-4">
          <div className={`text-white rounded-xl shadow-lg p-5 border-2 transform hover:scale-105 transition-all ${
              client.ClientIsActive === false 
                  ? 'bg-gray-600 border-gray-400' 
                  : 'bg-blue-600 border-blue-400'
          }`}>
            <div className="flex justify-between items-center">
              <div>
                <p className="text-sm opacity-90 flex items-center gap-1 font-bold">
                  <Wallet size={18} className={client.ClientIsActive === false ? "text-gray-200" : "text-blue-200"} />
                  الرصيد النشط
                  {client.ClientIsActive === false && (
                      <span className="text-xs bg-yellow-500 text-yellow-900 px-2 py-1 rounded-full mr-2">
                          مؤرشف
                      </span>
                  )}
                </p>
                <p className={`text-3xl font-bold mt-2 ${client.CurrentBalance >= 0 ? 'text-white' : 'text-red-200'}`}>
                  {client.CurrentBalance?.toLocaleString()} ج.م
                </p>
              </div>
              <div className={`p-3 rounded-full ${
                  client.ClientIsActive === false ? 'bg-gray-500' : 'bg-blue-500'
              }`}>
                <Zap size={24} className="text-white" />
              </div>
            </div>
            <div className={`mt-2 text-xs rounded p-1 inline-block ${
                client.ClientIsActive === false 
                    ? 'bg-gray-700' 
                    : 'bg-blue-700'
            }`}>
              {client.ClientIsActive === false 
                  ? 'عميل مؤرشف - الرصيد للمراجعة فقط' 
                  : 'هذا هو الرصيد الفعلي المتاح حالياً'}
            </div>
          </div>
        </div>
  
        {/* قسم معلومات المستحقات */}
        <div className="mb-4">
          <div className={`rounded-xl shadow-lg p-5 
             ${isOverpaid 
                ? 'bg-gradient-to-br from-emerald-500 to-emerald-600 text-white' 
                : requiredAmount > 0 && difference < 0 
                  ? 'bg-gradient-to-br from-amber-500 to-amber-600 text-white' 
                  : 'bg-gradient-to-br from-green-500 to-green-600 text-white'}`}>
            <div className="flex justify-between items-center">
              <div>
                <p className="text-sm opacity-90 flex items-center gap-1 font-bold">
                  <DollarSign size={18} className="text-white opacity-80" />
                  {isOverpaid ? 'مبلغ زائد يمكن سحبه' : 'المستحقات المالية'}
                </p>
                <div className="flex flex-col gap-1 mt-2">
                  <div className="flex items-center justify-between">
                    <span className="text-sm">المبلغ المطلوب:</span>
                    <span className="text-lg font-medium">{requiredAmount.toLocaleString()} ج.م</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm">صافي المبلغ المدفوع:</span>
                    <span className="text-lg font-medium">{netPaid.toLocaleString()} ج.م</span>
                  </div>
                  <div className="border-t border-white border-opacity-20 my-2"></div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm">{isOverpaid ? 'المبلغ الزائد:' : 'المبلغ المتبقي:'}</span>
                    <span className="text-xl font-bold">{remainingDue.toLocaleString()} ج.م</span>
                  </div>
                </div>
              </div>
              <div className="bg-white bg-opacity-20 p-3 rounded-full">
                {isOverpaid ? (
                  <TrendingUp size={24} className="text-white" />
                ) : requiredAmount > 0 && difference < 0 ? (
                  <AlertCircle size={24} className="text-white" />
                ) : (
                  <CheckCircle size={24} className="text-white" />
                )}
              </div>
            </div>
            <div className="mt-2 text-xs bg-white bg-opacity-20 rounded p-1 inline-block">
              {isOverpaid 
                ? 'يمكن سحب مبلغ زائد من العميل' 
                : requiredAmount > 0 && difference < 0
                  ? 'توجد مستحقات متبقية للعميل' 
                  : 'تم سداد كامل المستحقات'}
            </div>
            {client.RequiredPayment > 0 ? (
              <div className="mt-2 px-2 py-1 bg-green-100 text-green-800 rounded text-xs inline-flex items-center">
                <CheckCircle size={12} className="mr-1" />
                تم تحديد مبلغ مطلوب: {client.RequiredPayment?.toLocaleString()} ج.م
              </div>
            ) : (
              <div className="mt-2 px-2 py-1 bg-red-100 text-red-800 rounded text-xs inline-flex items-center">
                <AlertCircle size={12} className="mr-1" />
                لم يتم تحديد مبلغ مطلوب (مطلوب للإيداع)
              </div>
            )}
          </div>
        </div>

        {/* البطاقات الأخرى */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <div className="bg-gray-50 rounded-lg p-4">
            <p className="text-sm text-gray-600 flex items-center gap-1">
              <CreditCard size={16} className="text-gray-500" />
              الرصيد الخامل
            </p>
            <p className={`text-xl font-bold ${client.InactiveBalance >= 0 ? 'text-gray-600' : 'text-red-400'}`}>
              {client.InactiveBalance?.toLocaleString()} ج.م
            </p>
          </div>
          
          <div className="bg-purple-50 rounded-lg p-4">
            <p className="text-sm text-gray-600 flex items-center gap-1">
              <CreditCard size={16} className="text-purple-500" />
              إجمالي الرصيد
            </p>
            <p className={`text-xl font-bold ${client.TotalBalance >= 0 ? 'text-purple-600' : 'text-red-600'}`}>
              {client.TotalBalance?.toLocaleString()} ج.م
            </p>
          </div>
          
          <div className="bg-green-50 rounded-lg p-4">
            <p className="text-sm text-gray-600 flex items-center gap-1">
              <TrendingUp size={16} className="text-green-500" />
              إجمالي الإيداعات النشطة
            </p>
            <p className="text-xl font-bold text-green-600">
              {client.TotalDeposits?.toLocaleString()} ج.م
            </p>
          </div>
        </div>
      </div>
    );
  };

   // Function to prepare chart data for visualization
   const prepareChartData = () => {
       // Group transactions by date
       const groupedByDate = {};
       
       recentTransactions.forEach(transaction => {
           const date = new Date(transaction.TransactionDate).toLocaleDateString('ar-EG');
           if (!groupedByDate[date]) {
               groupedByDate[date] = {
                   date,
                   deposits: 0,
                   withdrawals: 0
               };
           }
           
           if (transaction.TransactionType === 'إيداع') {
               groupedByDate[date].deposits += transaction.Amount;
           } else {
               groupedByDate[date].withdrawals += transaction.Amount;
           }
       });
       
       // Convert to array and sort by date
       return Object.values(groupedByDate).sort((a, b) => 
           new Date(a.date) - new Date(b.date)
       );
   };


   const fetchRecentTransactions = async (includeInactive = true, retryCount = 0) => {
    try {
        console.log('🔄 جلب جميع المعاملات للعرض مع الصفحات...');
        
        // إزالة limit تماماً أو تمرير 'all'
        let urlParams = `includeInactive=${includeInactive}&limit=all`;
        
        const url = `${API_BASE}/transactions/recent?${urlParams}`;
        console.log(`محاولة جلب جميع المعاملات من: ${url}`);
        
        setLoading(true);
        
        const response = await fetch(url);
        
        if (!response.ok) {
            if (retryCount < 3) {
                console.log(`إعادة المحاولة بعد فشل الاستجابة (${response.status})...`);
                await new Promise(resolve => setTimeout(resolve, 1000));
                return fetchRecentTransactions(includeInactive, retryCount + 1);
            }
            throw new Error(`فشل في جلب المعاملات (${response.status})`);
        }
        
        const data = await response.json();
        
        const formattedData = data.map(transaction => {
            let phoneNumbers = transaction.PhoneNumbers || '[]';
            
            return {
                ...transaction,
                PhoneNumbers: phoneNumbers
            };
        });
        
        setRecentTransactions(formattedData);
        setChartData(prepareChartData());
        
        showToast(`تم تحميل ${formattedData.length} معاملة بنجاح`, 'success');
        
    } catch (error) {
        console.error('خطأ في جلب المعاملات:', error);
        showToast('فشل في جلب المعاملات', 'error');
    } finally {
        setLoading(false);
    }
};


// دالة لجلب طرق الدفع المتاحة
const fetchPaymentMethods = async () => {
    try {
      console.log('جاري جلب طرق الدفع (الحسابات البنكية فقط)...');
      
      // تصحيح الـ URL
      const response = await axios.get(`${config.BANKS_API_URL}/api/banks/payment-methods`);
      
      console.log('استجابة طرق الدفع:', response.data);
      
      if (response.data && response.data.success && response.data.paymentMethods) {
        const bankAccounts = response.data.paymentMethods.filter(m => m.type === 'bank');
        setPaymentMethods(bankAccounts);
        console.log('تم تحميل الحسابات البنكية:', bankAccounts.length);
        
        setSelectedPaymentMethod(null);
        
        if (bankAccounts.length === 0) {
          console.warn('لا توجد حسابات بنكية متاحة');
          showToast('لا توجد حسابات بنكية متاحة', 'warning');
        }
      } else {
        console.warn('بيانات طرق الدفع غير صحيحة:', response.data);
        showToast('بيانات طرق الدفع غير صحيحة', 'error');
      }
    } catch (error) {
      console.error('خطأ في جلب طرق الدفع:', error);
      console.error('تفاصيل الخطأ:', error.response ? error.response.data : error.message);
      showToast('فشل في جلب طرق الدفع: ' + (error.response ? error.response.data.error : error.message), 'error');
    }
};




useEffect(() => {
    fetchRecentTransactions(showActiveOnly);
    // إزالة dateRange من الـ dependencies
}, [showActiveOnly]);

// إعادة تعيين الصفحة عند تغيير البيانات
useEffect(() => {
    setCurrentPage(1);
}, [recentTransactions.length, itemsPerPage]);

const fetchStats = async () => {
    try {
        // تصحيح الـ URL - إزالة /api الزائدة
        const response = await fetch(`${API_BASE}/transactions/stats`);
        if (!response.ok) throw new Error('فشل في جلب الإحصائيات');

        const data = await response.json();
        setStats(data);
    } catch (error) {
        console.error('خطأ في جلب الإحصائيات:', error);
        showToast('فشل في جلب الإحصائيات', 'error');
    }
};

const handleClientSearch = async (query) => {
    const cleanQuery = (query || '').trim();
    if (!cleanQuery || cleanQuery.length < 2) {
        setClientSearchResults([]);
        return;
    }

    setIsClientSearching(true);
    try {
        // بحث مستقل عن العملاء فقط
        const response = await fetch(`${API_BASE}/clients?search=${encodeURIComponent(cleanQuery)}&active_only=true`);
        if (!response.ok) throw new Error('فشل في البحث');

        const data = await response.json();
        console.log("نتائج البحث عن العملاء النشطين:", data);
        setClientSearchResults(data);
    } catch (error) {
        console.error('خطأ في البحث عن العملاء:', error);
        showToast('فشل في البحث عن العملاء', 'error');
    } finally {
        setIsClientSearching(false);
    }
};


const handleTransactionSearch = async (query) => {
    const cleanQuery = (query || '').trim();
    if (!cleanQuery || cleanQuery.length < 2) {
        // إعادة تحميل جميع المعاملات عند مسح بحث المعاملات فقط
        fetchRecentTransactions(showActiveOnly);
        return;
    }

    setIsTransactionSearching(true);
    try {
        console.log('🔍 البحث في سجل المعاملات:', cleanQuery);
        
        // بحث مستقل عن سجل المعاملات وليس بحث العملاء
        const response = await fetch(`${API_BASE}/transactions/recent?search=${encodeURIComponent(cleanQuery)}&includeInactive=${showActiveOnly}&limit=all`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        
        if (!response.ok) {
            const errorText = await response.text();
            console.error('خطأ من الخادم:', errorText);
            throw new Error(`خطأ في البحث: ${response.status}`);
        }

        const data = await response.json();
        console.log('✅ نتائج بحث المعاملات:', data.length, 'معاملة');
        
        const normalizedQuery = cleanQuery.toLowerCase();
        // فلترة محلية إضافية حتى يظهر بحث المعاملات بشكل أدق ومميز
        const filteredData = data.filter(transaction => 
            transaction.ClientName?.toLowerCase().includes(normalizedQuery) ||
            transaction.OfficeSerial?.toString().includes(cleanQuery) ||
            transaction.NationalID?.includes(cleanQuery) ||
            transaction.PassportNumber?.includes(cleanQuery) ||
            transaction.Notes?.toLowerCase().includes(normalizedQuery) ||
            transaction.CompanyName?.toLowerCase().includes(normalizedQuery) ||
            transaction.DelegateName?.toLowerCase().includes(normalizedQuery) ||
            transaction.PaymentMethodName?.toLowerCase().includes(normalizedQuery) ||
            transaction.TransactionType?.toLowerCase().includes(normalizedQuery) ||
            transaction.Amount?.toString().includes(cleanQuery)
        );
        
        setRecentTransactions(filteredData);
        setCurrentPage(1);
        console.log('📊 النتائج بعد الفلترة:', filteredData.length, 'معاملة');
        
        if (filteredData.length === 0) {
            showToast('لا توجد معاملات مطابقة للبحث المحدد', 'warning');
        }
        
    } catch (error) {
        console.error('❌ خطأ في البحث عن المعاملات:', error);
        showToast('فشل في البحث عن المعاملات: ' + error.message, 'error');
        
        // في حالة الخطأ، إعادة تحميل المعاملات العادية
        fetchRecentTransactions(showActiveOnly);
    } finally {
        setIsTransactionSearching(false);
    }
};


const fetchClientDetails = async (clientId) => {
    try {
      setLoading(true);
      console.log("جاري استدعاء API لمعرف العميل:", clientId);
      
      // تصحيح الـ URL - إزالة /api الزائدة
      const response = await fetch(`${API_BASE}/clients/${clientId}/account`);
      
      if (!response.ok) {
        console.error("استجابة API غير ناجحة:", response.status);
        throw new Error('فشل في جلب تفاصيل العميل');
      }

      const data = await response.json();
      console.log("بيانات تم استلامها من API:", data);
      console.log("المبلغ المطلوب من API:", data.RequiredPayment);
      
      if (data) {
        const totalPaid = data.TotalDeposits || 0;
        const requiredAmount = data.RequiredPayment !== undefined ? data.RequiredPayment : 0;
        console.log("المبلغ المطلوب بعد المعالجة:", requiredAmount);
        
        const difference = totalPaid - requiredAmount;
        const isOverpaid = difference > 0;
        
        const formattedTransactions = data.transactions.map(transaction => ({
            ...transaction,
            BankTransactionID: transaction.BankTransactionID || transaction.RelatedBankTransactionID,
            IsActive: transaction.IsActive === undefined ? true : transaction.IsActive
          }));
        
        const formattedClient = {
          ...data,
          InactiveBalance: data.InactiveBalance || 0,
          InactiveDeposits: data.InactiveDeposits || 0,
          InactiveWithdrawals: data.InactiveWithdrawals || 0,
          TotalBalance: data.TotalBalance || 0,
          CurrentBalance: data.CurrentBalance || 0,
          TravelDate: data.TravelDate || null,
          HasTravelDate: data.HasTravelDate || Boolean(data.TravelDate),
          RequiredPayment: requiredAmount,
          RemainingDue: Math.abs(difference),
          IsOverpaid: isOverpaid,
          transactions: formattedTransactions
        };
        
        console.log("بيانات العميل المنسقة:", formattedClient);
        console.log("المبلغ المطلوب النهائي:", formattedClient.RequiredPayment);
        console.log("الرصيد النشط النهائي:", formattedClient.CurrentBalance);
        
        setSelectedClient(formattedClient);
        setShowAccountDetails(true);
      } else {
        throw new Error('بيانات العميل غير متوفرة');
      }
    } catch (error) {
      console.error('خطأ في جلب تفاصيل العميل:', error);
      showToast('فشل في جلب تفاصيل العميل', 'error');
    } finally {
      setLoading(false);
    }
};


const saveClientPayment = async () => {
    if (!selectedClient) {
        showToast('يرجى اختيار عميل أولاً', 'error');
        return;
    }
    
    if (paymentForm.RequiredPayment === '') {
        showToast('يرجى إدخال المبلغ المطلوب', 'error');
        return;
    }

    setLoading(true);
    try {
        console.log('بيانات الطلب:', {
            PassportID: selectedClient.PassportID,
            RequiredPayment: parseFloat(paymentForm.RequiredPayment),
            Notes: paymentForm.Notes,
            UpdatedBy: getCurrentUser()
        });
        
        const response = await fetch(`${API_BASE}/clients/${selectedClient.PassportID}/payment`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                RequiredPayment: parseFloat(paymentForm.RequiredPayment),
                Notes: paymentForm.Notes,
                UpdatedBy: getCurrentUser()
            }),
        });
        
        if (!response.ok) {
            throw new Error(await response.json().then(data => data.error) || 'فشل في تحديث المبلغ المطلوب');
        }

        // مزامنة البيانات مع نظام إدارة الحسابات
        try {
            await fetch(`${config.BANKS_API_URL}/api/sync/payment-requirements`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    PassportID: selectedClient.PassportID,
                    RequiredPayment: parseFloat(paymentForm.RequiredPayment),
                    Notes: paymentForm.Notes || ''
                }),
            });
            console.log('تمت مزامنة المبلغ المطلوب مع نظام إدارة الحسابات بنجاح');
        } catch (syncError) {
            console.warn('تحذير: فشلت مزامنة البيانات مع نظام إدارة الحسابات:', syncError);
        }

        setSelectedClient(prevClient => ({
            ...prevClient,
            RequiredPayment: parseFloat(paymentForm.RequiredPayment),
            Notes: paymentForm.Notes || prevClient.Notes
        }));
        
        await fetchClientDetails(selectedClient.PassportID);
        
        setShowPaymentForm(false);
        resetPaymentForm();
        
        // استدعاء الدالة المساعدة الجديدة
        await handlePaymentUpdateSuccess();
        
    } catch (error) {
        console.error('خطأ في تحديث المبلغ المطلوب:', error);
        showToast(error.message || 'فشل في تحديث المبلغ المطلوب', 'error');
    } finally {
        setLoading(false);
    }
};

  // دالة إعادة تعيين نموذج الدفع
  const resetPaymentForm = () => {
    setPaymentForm({
      RequiredPayment: '',
      Notes: ''
    });
  };  




// دالة لتغيير حالة نشاط معاملة واحدة
const toggleTransactionActive = async (transactionId, isActive) => {
    try {
      setIsProcessing(true);
      
      // تصحيح الـ URL
      const response = await fetch(`${API_BASE}/transactions/${transactionId}/toggle-active`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ IsActive: isActive, UpdatedBy: getCurrentUser() })
      });

      if (!response.ok) throw new Error('فشل في تغيير حالة المعاملة');
      
      const data = await response.json();
      await fetchClientDetails(selectedClient.PassportID);
      
      // تحديث المعاملات ليعكس التغييرات
      fetchRecentTransactions();
      
      showToast(data.message || 'تم تغيير حالة المعاملة بنجاح');
    } catch (error) {
      console.error('خطأ في تغيير حالة المعاملة:', error);
      showToast(error.message, 'error');
    } finally {
      setIsProcessing(false);
    }
};


// دالة لتغيير حالة نشاط جميع معاملات العميل
const toggleAllTransactionsActive = async (clientId, isActive) => {
    try {
        setIsProcessing(true);
        const response = await fetch(`${API_BASE}/api/clients/${clientId}/toggle-all-transactions`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                IsActive: isActive,
                UpdatedBy: getCurrentUser()
            })
        });

        if (!response.ok) {
            throw new Error('فشل في تغيير حالة المعاملات');
        }

        const data = await response.json();
        
        // تحديث بيانات العميل
        await fetchClientDetails(clientId);
        
        showToast(data.message || 'تم تغيير حالة جميع المعاملات بنجاح');
    } catch (error) {
        console.error('خطأ في تغيير حالة المعاملات:', error);
        showToast(error.message, 'error');
    } finally {
        setIsProcessing(false);
    }
};


const handleAddTransaction = async (e) => {
    e.preventDefault();
    
    if (!selectedClient && !isEditMode) {
        showToast('يرجى اختيار عميل أولاً', 'error');
        return;
    }

    if (!selectedPaymentMethod) {
        showToast('يرجى اختيار طريقة الدفع', 'error');
        return;
    }

    // التحقق من صلاحية المبلغ المطلوب للإيداعات فقط
    if (transactionForm.TransactionType === 'إيداع' && selectedClient && !isEditMode) {
        try {
            console.log(`🔍 التحقق من صلاحية المبلغ المطلوب للعميل: ${selectedClient.PassportID}`);
            
            const validityResponse = await fetch(`${API_BASE}/clients/${selectedClient.PassportID}/check-payment-validity`);
            
            if (validityResponse.ok) {
                const validationData = await validityResponse.json();
                console.log('نتيجة التحقق من الصلاحية:', validationData);
                
                if (validationData.isOverdue && validationData.blockDeposits) {
                    showToast(validationData.message, 'error');
                    return;
                } else if (validationData.isOverdue && validationData.showPopupWarning) {
                    const confirmProceed = window.confirm(
                        `${validationData.message}\n\nهل تريد المتابعة مع إضافة الإيداع؟`
                    );
                    
                    if (!confirmProceed) {
                        return;
                    }
                    
                    showToast('تحذير: تم إضافة الإيداع رغم انتهاء صلاحية المبلغ المطلوب', 'warning');
                }
            } else {
                console.warn('فشل في التحقق من صلاحية المبلغ المطلوب');
            }
        } catch (error) {
            console.error('خطأ في التحقق من صلاحية المبلغ:', error);
        }
    }

    try {
        setLoading(true);
        
        let formattedNotes = transactionForm.Notes || "";
        if (selectedClient && !formattedNotes.includes("معاملة للعميل:")) {
            formattedNotes = `معاملة للعميل: ${selectedClient.NameArabic} - ${formattedNotes}`;
        }
        
        console.log("🚀 بدء إنشاء معاملة جديدة مع المزامنة الكاملة");
        
        const response = await fetch(`${API_BASE}/transactions/create-with-sync`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                ...transactionForm,
                Notes: formattedNotes,
                PaymentMethodID: selectedPaymentMethod.id,
                PaymentMethodType: selectedPaymentMethod.type,
                RequiredPayment: parseFloat(transactionForm.RequiredPayment || 0),
                CreatedBy: getCurrentUser(),
                TransactionDate: transactionForm.TransactionDate || new Date().toISOString(),
                ClientDetails: {
                    NameArabic: selectedClient.NameArabic,
                    NationalID: selectedClient.NationalID,
                    CompanyName: selectedClient.CompanyName,
                    DelegateName: selectedClient.DelegateName,
                    PhoneNumbers: selectedClient.PhoneNumbers
                }
            })
        });

        const data = await response.json();

        if (response.ok) {
            console.log("✅ تم إنشاء المعاملة بنجاح:", data);
            
            // إغلاق النافذة
            setShowTransactionForm(false);
            
            // مسح النموذج بالكامل
            setTransactionForm({
                PassportID: '',
                TransactionType: 'إيداع',
                Amount: '',
                Notes: '',
                TransactionDate: new Date().toISOString().slice(0, 16),
                PaymentMethodID: null,
                PaymentMethodType: null
            });
            
            // مسح طريقة الدفع المختارة
            setSelectedPaymentMethod(null);
            
            // مسح العميل المختار
            setSelectedClient(null);
            
            // مسح حالات التعديل
            setIsEditMode(false);
            setEditingTransaction(null);
            
            showToast(data.message || 'تم إضافة المعاملة بنجاح مع المزامنة الكاملة');
            
            fetchRecentTransactions();
            
        } else {
            throw new Error(data.error || 'فشل في إضافة المعاملة');
        }
    } catch (error) {
        console.error('خطأ في إضافة المعاملة:', error);
        showToast(error.message || 'فشل في إضافة المعاملة', 'error');
    } finally {
        setLoading(false);
    }
};

const handleEditTransaction = async (e) => {
    e.preventDefault();
    try {
        console.log("🔄 بدء تعديل المعاملة مع المزامنة الكاملة");
        
        if (!selectedPaymentMethod) {
            showToast('يرجى اختيار طريقة الدفع', 'error');
            return;
        }
        
        // استخراج معلومات العميل من الملاحظات
        let clientInfo = "";
        if (editingTransaction.Notes && editingTransaction.Notes.includes("معاملة للعميل:")) {
            const parts = editingTransaction.Notes.split("معاملة للعميل:");
            if (parts.length > 1) {
                const clientPart = parts[1].trim();
                clientInfo = clientPart.split(' - ')[0].trim();
            }
        }
        
        // تنسيق الملاحظات
        let formattedNotes = transactionForm.Notes || "";
        if (clientInfo && !formattedNotes.includes("معاملة للعميل:")) {
            formattedNotes = `معاملة للعميل: ${clientInfo} - ${formattedNotes}`;
        }
        
        const transactionData = {
            TransactionID: editingTransaction.TransactionID,
            ...transactionForm,
            Notes: formattedNotes,
            PaymentMethodID: selectedPaymentMethod.id,
            PaymentMethodType: selectedPaymentMethod.type,
            UpdatedBy: getCurrentUser()
        };
        
        console.log('بيانات المعاملة المراد تعديلها:', transactionData);

        // استخدام API التعديل المحسن مع المزامنة
        const response = await fetch(`${API_BASE}/transactions/${editingTransaction.TransactionID}/with-sync`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(transactionData)
        });
        
        const data = await response.json();
        
        if (!response.ok) {
            throw new Error(data.error || 'فشل في تحديث المعاملة');
        }
        
        // تحديث البيانات
        await Promise.all([
            fetchRecentTransactions(),
            fetchStats()
        ]);
        
        // إذا كان العميل محدد، قم بتحديث بياناته
        if (selectedClient && selectedClient.PassportID) {
            await fetchClientDetails(selectedClient.PassportID);
        }
        
        // إعادة تعيين الحالة بالكامل
        setShowTransactionForm(false);
        setIsEditMode(false);
        setEditingTransaction(null);
        setSelectedPaymentMethod(null);
        setSelectedClient(null);
        setTransactionForm({
            PassportID: '',
            TransactionType: 'إيداع',
            Amount: '',
            Notes: '',
            TransactionDate: new Date().toISOString().slice(0, 16),
            PaymentMethodID: null,
            PaymentMethodType: null
        });
        
        showToast(data.message || 'تم تحديث المعاملة بنجاح مع المزامنة الكاملة');
    } catch (error) {
        console.error('خطأ في تعديل المعاملة:', error);
        showToast(error.message, 'error');
    }
};

const handleDeleteTransaction = async (transactionId) => {
    if (!window.confirm('هل أنت متأكد من حذف هذه المعاملة؟\n\nسيتم حذفها من نظام العملاء ونظام البنوك معاً.')) return;

    try {
        setLoading(true);
        console.log("🔥 بدء عملية الحذف المتزامن للمعاملة: " + transactionId);
        
        // استخدام endpoint الحذف المتزامن الجديد
        const response = await fetch(`${API_BASE}/transactions/${transactionId}/sync-delete`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'فشل في حذف المعاملة');
        }
        
        const responseData = await response.json();
        console.log('✅ نتيجة الحذف المتزامن:', responseData);
        
        // تحديث البيانات بعد الحذف
        await Promise.all([
            fetchRecentTransactions(),
            fetchStats()
        ]);
        
        // إذا كان العميل محدد، قم بتحديث بياناته
        if (selectedClient && selectedClient.PassportID) {
            await fetchClientDetails(selectedClient.PassportID);
        }
        
        showToast(responseData.message || 'تم حذف المعاملة بنجاح', 'success');
        
    } catch (error) {
        console.error('❌ خطأ في حذف المعاملة:', error);
        showToast(error.message || 'فشل في حذف المعاملة', 'error');
    } finally {
        setLoading(false);
    }
};







   // دالة نسخ رقم الهاتف
   const copyToClipboard = (text) => {
       if (!text || text === '-') return;
       
       navigator.clipboard.writeText(text)
           .then(() => {
               showToast('تم نسخ رقم الهاتف بنجاح');
           })
           .catch(err => {
               console.error('فشل في نسخ النص: ', err);
               showToast('فشل في نسخ رقم الهاتف', 'error');
           });
   };


   // دالة لاسترجاع سجل تعديلات المبلغ المطلوب
const fetchPaymentHistory = async (clientId) => {
    try {
      setIsProcessing(true);
      console.log("جاري استدعاء سجل تعديلات المبلغ المطلوب للعميل:", clientId);
      
      const response = await fetch(`${API_BASE}/api/clients/${clientId}/payment-history`);
      
      if (!response.ok) {
        console.error("استجابة API غير ناجحة:", response.status);
        throw new Error('فشل في جلب سجل تعديلات المبلغ المطلوب');
      }
  
      const data = await response.json();
      console.log("سجل تعديلات المبلغ المطلوب:", data);
      
      return data.history;
    } catch (error) {
      console.error('خطأ في جلب سجل تعديلات المبلغ المطلوب:', error);
      showToast('فشل في جلب سجل تعديلات المبلغ المطلوب', 'error');
      return [];
    } finally {
      setIsProcessing(false);
    }
  };
  
  // دالة لحذف سجل من تاريخ تعديلات المبلغ المطلوب
  const deletePaymentHistoryRecord = async (historyId) => {
    if (!window.confirm('هل أنت متأكد من حذف هذا السجل؟')) {
      return;
    }
    
    try {
      setIsProcessing(true);
      
      const response = await fetch(`${API_BASE}/api/clients/payment-history/${historyId}`, {
        method: 'DELETE'
      });
      
      if (!response.ok) {
        throw new Error('فشل في حذف سجل التعديل');
      }
      
      const data = await response.json();
      
      // تحديث سجل التعديلات بعد الحذف
      if (selectedClient) {
        setPaymentHistory(await fetchPaymentHistory(selectedClient.PassportID));
      }
      
      showToast('تم حذف سجل التعديل بنجاح');
    } catch (error) {
      console.error('خطأ في حذف سجل التعديل:', error);
      showToast(error.message || 'فشل في حذف سجل التعديل', 'error');
    } finally {
      setIsProcessing(false);
    }
  };







// دالة بدء سفرة جديدة
const startNewTrip = async (passportId) => {
    if (!window.confirm('هل أنت متأكد من بدء سفرة جديدة لهذا العميل؟')) return;
    
    try {
      setLoading(true);
      console.log(`محاولة بدء سفرة جديدة للعميل: ${passportId}`);
      
      const response = await fetch(`${API_BASE}/api/clients/${passportId}/trips`, {

        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          StartDate: new Date().toISOString(),
          Description: 'سفرة جديدة',
          CreatedBy: getCurrentUser()
        })
      });
      
      const data = await response.json();
      console.log('استجابة API:', data);
      
      if (!response.ok) {
        throw new Error(data.error || 'فشل في بدء سفرة جديدة');
      }
      
      await fetchClientDetails(passportId);
      showToast('تم بدء سفرة جديدة بنجاح');
    } catch (error) {
      console.error('خطأ في بدء سفرة جديدة:', error);
      showToast(error.message || 'فشل في بدء سفرة جديدة', 'error');
    } finally {
      setLoading(false);
    }
  };


   // Filter Functions
   const applyFilters = () => {
       let filteredData = [...recentTransactions];

       if (filters.dateFrom) {
           filteredData = filteredData.filter(t => 
               new Date(t.TransactionDate) >= new Date(filters.dateFrom)
           );
       }
       if (filters.dateTo) {
           filteredData = filteredData.filter(t => 
               new Date(t.TransactionDate) <= new Date(filters.dateTo)
           );
       }
       if (filters.transactionType) {
           filteredData = filteredData.filter(t => 
               t.TransactionType === filters.transactionType
           );
       }
       if (filters.minAmount) {
           filteredData = filteredData.filter(t => 
               t.Amount >= parseFloat(filters.minAmount)
           );
       }
       if (filters.maxAmount) {
           filteredData = filteredData.filter(t => 
               t.Amount <= parseFloat(filters.maxAmount)
           );
       }

       setRecentTransactions(filteredData);
       setFilterVisible(false);
       showToast('تم تطبيق الفلترة بنجاح');
   };

   const resetFilters = async () => {
       setFilters({
           dateFrom: '',
           dateTo: '',
           transactionType: '',
           minAmount: '',
           maxAmount: ''
       });
       await fetchRecentTransactions();
       setFilterVisible(false);
       showToast('تم إعادة تعيين الفلترة');
   };


// دالة لجلب جميع المعاملات للتصدير - محدثة
const fetchAllTransactionsForExport = async (options = {}) => {
  try {
      console.log('📄 جاري جلب جميع المعاملات للتصدير مع الفلاتر:', options);
      
      // بناء المعاملات
      const params = new URLSearchParams({
          includeInactive: 'true' // جلب كل شيء بما في ذلك المعاملات غير النشطة
      });
      
      // إضافة فلاتر التاريخ إذا كانت محددة
      if (options.dateFrom) {
          params.append('dateFrom', options.dateFrom);
      }
      if (options.dateTo) {
          params.append('dateTo', options.dateTo);
      }
      if (options.transactionType) {
          params.append('transactionType', options.transactionType);
      }
      
      const url = `${API_BASE}/transactions/all-for-export?${params.toString()}`;
      console.log('URL الطلب:', url);
      
      const response = await fetch(url, {
          method: 'GET',
          headers: {
              'Content-Type': 'application/json'
          }
      });
      
      if (!response.ok) {
          throw new Error(`خطأ في جلب البيانات: ${response.status}`);
      }
      
      const data = await response.json();
      console.log(`✅ تم جلب ${data.length} معاملة للتصدير`);
      
      return data.map(transaction => ({
          ...transaction,
          PhoneNumbers: transaction.PhoneNumbers || '[]'
      }));
      
  } catch (error) {
      console.error('❌ خطأ في جلب جميع المعاملات:', error);
      throw error;
  }
};

// دالة تصدير Excel محسنة - بدون endpoint إضافي
const exportToAdvancedExcel = async () => {
    try {
        setLoading(true);
        
        let dataToExport = [];
        
        // تحديد البيانات المطلوب تصديرها حسب الخيار المحدد
        if (exportOptions.dateRange === 'current-page') {
            // تصدير الصفحة الحالية فقط
            dataToExport = getPaginatedTransactions();
            console.log(`📄 تصدير الصفحة الحالية: ${dataToExport.length} معاملة`);
        } else if (exportOptions.dateRange === 'filtered') {
            // استخدام البيانات المعروضة حالياً
            dataToExport = [...recentTransactions];
            console.log(`📋 تصدير البيانات المعروضة: ${dataToExport.length} معاملة`);
        } else if (exportOptions.dateRange === 'all') {
            // جلب جميع البيانات من قاعدة البيانات
            showToast('جاري جلب جميع البيانات للتصدير...', 'info');
            
            try {
                const response = await fetch(`${API_BASE}/transactions/recent?limit=100000&includeInactive=true`);
                if (!response.ok) {
                    throw new Error('فشل في جلب البيانات');
                }
                const allData = await response.json();
                dataToExport = allData.map(transaction => ({
                    ...transaction,
                    PhoneNumbers: transaction.PhoneNumbers || '[]'
                }));
                
                console.log(`✅ تم جلب ${dataToExport.length} معاملة للتصدير`);
            } catch (error) {
                console.error('خطأ في جلب جميع البيانات:', error);
                showToast('فشل في جلب جميع البيانات، سيتم تصدير البيانات المعروضة', 'warning');
                dataToExport = [...recentTransactions];
            }
        } else if (exportOptions.dateRange === 'custom') {
            // للبيانات المخصصة، جلب جميع البيانات ثم فلترها حسب التاريخ
            showToast('جاري جلب البيانات للفترة المخصصة...', 'info');
            
            try {
                const response = await fetch(`${API_BASE}/transactions/recent?limit=100000&includeInactive=true`);
                if (!response.ok) {
                    throw new Error('فشل في جلب البيانات');
                }
                const allData = await response.json();
                dataToExport = allData.map(transaction => ({
                    ...transaction,
                    PhoneNumbers: transaction.PhoneNumbers || '[]'
                }));
                
                // تطبيق فلتر التاريخ المخصص
                if (exportOptions.customStartDate || exportOptions.customEndDate) {
                    dataToExport = dataToExport.filter(transaction => {
                        const transactionDate = new Date(transaction.TransactionDate);
                        let isValid = true;
                        
                        if (exportOptions.customStartDate) {
                            const startDate = new Date(exportOptions.customStartDate);
                            isValid = isValid && transactionDate >= startDate;
                        }
                        
                        if (exportOptions.customEndDate) {
                            const endDate = new Date(exportOptions.customEndDate);
                            endDate.setHours(23, 59, 59, 999); // نهاية اليوم
                            isValid = isValid && transactionDate <= endDate;
                        }
                        
                        return isValid;
                    });
                }
                
                console.log(`📅 تم فلترة ${dataToExport.length} معاملة للفترة المخصصة`);
            } catch (error) {
                console.error('خطأ في جلب البيانات المخصصة:', error);
                showToast('فشل في جلب البيانات، سيتم تصدير البيانات المعروضة', 'warning');
                dataToExport = [...recentTransactions];
            }
        }
        
        // تطبيق فلتر نوع المعاملة (إن وُجد)
        if (exportOptions.selectedTypes.length === 1) {
            dataToExport = dataToExport.filter(t => 
                exportOptions.selectedTypes.includes(t.TransactionType)
            );
            console.log(`🔍 تم فلترة ${dataToExport.length} معاملة حسب النوع: ${exportOptions.selectedTypes[0]}`);
        }
        
        // ترتيب البيانات حسب التاريخ (الأحدث أولاً)
        dataToExport.sort((a, b) => new Date(b.TransactionDate) - new Date(a.TransactionDate));
        
        if (dataToExport.length === 0) {
            showToast('لا توجد بيانات للتصدير حسب الفلاتر المحددة', 'warning');
            return;
        }
        
        showToast(`جاري تصدير ${dataToExport.length} معاملة...`, 'info');
        
        const exportSummary = calculateSummaryForClientData(dataToExport);
        
        // إنشاء workbook جديد
        const workbook = XLSX.utils.book_new();
        
        // ========== ورقة البيانات الرئيسية ==========
        const worksheetData = [];
        
        // العنوان الرئيسي
        worksheetData.push(['تقرير معاملات العملاء الشامل']);
        worksheetData.push(['']); // سطر فارغ
        worksheetData.push([`تاريخ التقرير: ${new Date().toLocaleDateString('ar-EG', {
            year: 'numeric',
            month: 'long', 
            day: 'numeric',
            weekday: 'long'
        })}`]);
        worksheetData.push([`عدد المعاملات: ${dataToExport.length}`]);
        
        // إضافة معلومات الفلترة
        if (exportOptions.dateRange === 'custom' && (exportOptions.customStartDate || exportOptions.customEndDate)) {
            let dateRangeText = 'نطاق التاريخ: ';
            if (exportOptions.customStartDate) {
                dateRangeText += `من ${new Date(exportOptions.customStartDate).toLocaleDateString('ar-EG')} `;
            }
            if (exportOptions.customEndDate) {
                dateRangeText += `إلى ${new Date(exportOptions.customEndDate).toLocaleDateString('ar-EG')}`;
            }
            worksheetData.push([dateRangeText]);
        }
        
        if (exportOptions.selectedTypes.length > 0 && exportOptions.selectedTypes.length < 2) {
            worksheetData.push([`نوع المعاملات: ${exportOptions.selectedTypes.join(', ')}`]);
        }
        
        worksheetData.push(['']); // سطر فارغ
        
        // الملخص المالي (إذا كان مختار)
        if (exportOptions.includeSummary) {
            worksheetData.push(['الملخص المالي']);
            worksheetData.push(['عدد المعاملات', exportSummary.TotalTransactions]);
            worksheetData.push(['إجمالي الإيداعات (ج.م)', exportSummary.TotalDeposits]);
            worksheetData.push(['إجمالي السحوبات (ج.م)', exportSummary.TotalWithdrawals]);
            worksheetData.push(['صافي الرصيد (ج.م)', exportSummary.CurrentBalance]);
            worksheetData.push(['']); // سطر فارغ
        }
        
        // رؤوس الأعمدة
        const headers = [
            'م',
            'التاريخ', 
            'اسم العميل',
            'الرقم القومي',
            'الشركة',
            'المندوب', 
            'رقم الهاتف',
            'نوع المعاملة',
            'المبلغ (ج.م)',
            'الرصيد (ج.م)',
            'الحالة',
            'الملاحظات'
        ];
        worksheetData.push(headers);
        
        // بيانات المعاملات
        dataToExport.forEach((transaction, index) => {
            const row = [
                index + 1,
                new Date(transaction.TransactionDate).toLocaleDateString('ar-EG'),
                transaction.ClientName,
                transaction.NationalID || '-',
                transaction.CompanyName || '-', 
                transaction.DelegateName || '-',
                formatPhoneNumber(transaction.PhoneNumbers),
                transaction.TransactionType,
                transaction.Amount,
                transaction.IsActive === false 
                    ? "غير محتسب"
                    : (transaction.ActiveBalance !== null && transaction.ActiveBalance !== undefined)
                      ? transaction.ActiveBalance
                      : transaction.Balance || 0,
                transaction.IsActive === false ? "خامل" : "نشط",
                transaction.Notes || '-'
            ];
            worksheetData.push(row);
        });
  
        // إنشاء الورقة
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        
        // تحديد نطاقات البيانات
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        const headerRowIndex = worksheetData.findIndex(row => 
            Array.isArray(row) && row[0] === 'م'
        );
        const dataStartRow = headerRowIndex + 1;
        
        // تعيين عرض الأعمدة
        worksheet['!cols'] = [
            { wch: 5 },   // م
            { wch: 12 },  // التاريخ  
            { wch: 20 },  // اسم العميل
            { wch: 15 },  // الرقم القومي
            { wch: 20 },  // الشركة
            { wch: 15 },  // المندوب
            { wch: 15 },  // رقم الهاتف
            { wch: 12 },  // نوع المعاملة
            { wch: 15 },  // المبلغ
            { wch: 15 },  // الرصيد
            { wch: 10 },  // الحالة
            { wch: 25 }   // الملاحظات
        ];
        
        // تنسيق العنوان الرئيسي
        if (worksheet['A1']) {
            worksheet['A1'].s = {
                font: { bold: true, sz: 16, color: { rgb: "1F4E79" } },
                alignment: { horizontal: "center", vertical: "center" },
                fill: { fgColor: { rgb: "E6F2FF" } }
            };
        }
        
        // دمج خلايا العنوان الرئيسي
        if (!worksheet['!merges']) worksheet['!merges'] = [];
        worksheet['!merges'].push({
            s: { c: 0, r: 0 }, 
            e: { c: headers.length - 1, r: 0 }
        });
        
        // تنسيق معلومات التاريخ والعدد
        const infoRows = ['A3', 'A4', 'A5', 'A6'];
        infoRows.forEach(cell => {
            if (worksheet[cell]) {
                worksheet[cell].s = {
                    font: { bold: true, sz: 11 },
                    alignment: { horizontal: "right" }
                };
            }
        });
        
        // تنسيق رؤوس الأعمدة
        for (let col = 0; col < headers.length; col++) {
            const cellAddress = XLSX.utils.encode_cell({ c: col, r: headerRowIndex });
            if (worksheet[cellAddress]) {
                worksheet[cellAddress].s = {
                    font: { bold: true, sz: 12, color: { rgb: "FFFFFF" } },
                    fill: { fgColor: { rgb: "2F5597" } },
                    alignment: { horizontal: "center", vertical: "center" },
                    border: {
                        top: { style: "thick", color: { rgb: "1F4E79" } },
                        bottom: { style: "thick", color: { rgb: "1F4E79" } },
                        left: { style: "thin", color: { rgb: "1F4E79" } },
                        right: { style: "thin", color: { rgb: "1F4E79" } }
                    }
                };
            }
        }
        
        // تنسيق بيانات المعاملات
        for (let row = dataStartRow; row <= range.e.r; row++) {
            const isEvenRow = (row - dataStartRow) % 2 === 0;
            
            for (let col = 0; col <= range.e.c; col++) {
                const cellAddress = XLSX.utils.encode_cell({ c: col, r: row });
                if (worksheet[cellAddress]) {
                    let cellStyle = {
                        alignment: { horizontal: "center", vertical: "center" },
                        border: {
                            top: { style: "thin", color: { rgb: "D1D5DB" } },
                            bottom: { style: "thin", color: { rgb: "D1D5DB" } },
                            left: { style: "thin", color: { rgb: "D1D5DB" } },
                            right: { style: "thin", color: { rgb: "D1D5DB" } }
                        },
                        fill: { fgColor: { rgb: isEvenRow ? "F8F9FA" : "FFFFFF" } }
                    };
                    
                    // تنسيق خاص للمبالغ
                    if (col === 8 || col === 9) { // عمود المبلغ والرصيد
                        cellStyle.numFmt = "#,##0";
                        cellStyle.font = { bold: true };
                    }
                    
                    // تنسيق خاص لنوع المعاملة
                    if (col === 7) { // عمود نوع المعاملة
                        const cellValue = worksheet[cellAddress].v;
                        if (cellValue === 'إيداع') {
                            cellStyle.font = { bold: true, color: { rgb: "059669" } };
                            cellStyle.fill = { fgColor: { rgb: "ECFDF5" } };
                        } else if (cellValue === 'سحب') {
                            cellStyle.font = { bold: true, color: { rgb: "DC2626" } };
                            cellStyle.fill = { fgColor: { rgb: "FEF2F2" } };
                        }
                    }
                    
                    // تنسيق خاص للحالة
                    if (col === 10) { // عمود الحالة
                        const cellValue = worksheet[cellAddress].v;
                        if (cellValue === 'نشط') {
                            cellStyle.font = { bold: true, color: { rgb: "059669" } };
                            cellStyle.fill = { fgColor: { rgb: "ECFDF5" } };
                        } else {
                            cellStyle.font = { bold: true, color: { rgb: "6B7280" } };
                            cellStyle.fill = { fgColor: { rgb: "F3F4F6" } };
                        }
                    }
                    
                    worksheet[cellAddress].s = cellStyle;
                }
            }
        }
        
        // تعيين اتجاه النص من اليمين لليسار
        worksheet['!dir'] = 'rtl';
        
        // إضافة الورقة للمصنف
        XLSX.utils.book_append_sheet(workbook, worksheet, "معاملات العملاء");
        
        // تصدير الملف
        const fileName = `تقرير_معاملات_العملاء_${new Date().toISOString().split('T')[0]}.xlsx`;
        XLSX.writeFile(workbook, fileName);
        
        showToast(`تم تصدير ${dataToExport.length} معاملة بتنسيق Excel متقدم بنجاح!`, 'success');
        
    } catch (error) {
        console.error('خطأ في التصدير:', error);
        showToast('حدث خطأ أثناء التصدير: ' + error.message, 'error');
    } finally {
        setLoading(false);
    }
  };

// دالة لتنفيذ تخميل المعاملات
// دالة لتنفيذ تخميل المعاملات
const handleDeactivateTransactions = async (e) => {
    e.preventDefault();
    
    // التحقق من رمز الأمان
    if (securityCode !== "123456") {  // يمكنك تغيير رمز الأمان حسب الحاجة
        showToast('رمز الأمان غير صحيح', 'error');
        return;
    }
    
    // تأكيد نهائي
    if (!window.confirm('تحذير نهائي: هل أنت متأكد من تخميل المعاملات؟ لا يمكن التراجع عن هذا الإجراء بسهولة.')) {
        return;
    }
    
    setLoading(true);
    try {
        // بناء الاستعلام
        const params = new URLSearchParams();
        if (deactivationFilter.clientName) params.append('clientName', deactivationFilter.clientName);
        if (deactivationFilter.dateFrom) params.append('dateFrom', deactivationFilter.dateFrom);
        if (deactivationFilter.dateTo) params.append('dateTo', deactivationFilter.dateTo);
        
        // استدعاء API
        const response = await fetch(`${API_BASE}/api/transactions/deactivate-bulk?${params.toString()}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                SecurityCode: securityCode,
                UpdatedBy: getCurrentUser()
            }),
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'فشل في تنفيذ العملية');
        }
        
        const data = await response.json();
        
        // إغلاق النافذة وإعادة تعيين الحالات
        setShowDeactivateDialog(false);
        setSecurityCode('');
        setDeactivationFilter({
            clientName: '',
            dateFrom: '',
            dateTo: ''
        });
        
        // تحديث البيانات
        fetchRecentTransactions();
        
        // عرض رسالة نجاح
        showToast(`تم تخميل ${data.affectedCount || 0} معاملة بنجاح`, 'success');
    } catch (error) {
        console.error('خطأ في تخميل المعاملات:', error);
        showToast(error.message || 'فشل في تخميل المعاملات', 'error');
    } finally {
        setLoading(false);
    }
};

// دالة لتنفيذ تنشيط المعاملات
// دالة لتنفيذ تنشيط المعاملات
const handleActivateTransactions = async (e) => {
    e.preventDefault();
    
    // التحقق من رمز الأمان
    if (securityCode !== "123456") {
        showToast('رمز الأمان غير صحيح', 'error');
        return;
    }
    
    // تأكيد نهائي
    if (!window.confirm('هل أنت متأكد من تنشيط المعاملات المحددة؟')) {
        return;
    }
    
    setLoading(true);
    try {
        // بناء الاستعلام
        const params = new URLSearchParams();
        if (deactivationFilter.clientName) params.append('clientName', deactivationFilter.clientName);
        if (deactivationFilter.dateFrom) params.append('dateFrom', deactivationFilter.dateFrom);
        if (deactivationFilter.dateTo) params.append('dateTo', deactivationFilter.dateTo);
        
        // استدعاء API
        const response = await fetch(`${API_BASE}/api/transactions/activate-bulk?${params.toString()}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                SecurityCode: securityCode,
                UpdatedBy: getCurrentUser()
            }),
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'فشل في تنفيذ العملية');
        }
        
        const data = await response.json();
        
        // إغلاق النافذة وإعادة تعيين الحالات
        setShowActivateDialog(false);
        setSecurityCode('');
        setDeactivationFilter({
            clientName: '',
            dateFrom: '',
            dateTo: ''
        });
        
        // تحديث البيانات
        fetchRecentTransactions();
        
        // عرض رسالة نجاح
        showToast(`تم تنشيط ${data.affectedCount || 0} معاملة بنجاح`, 'success');
    } catch (error) {
        console.error('خطأ في تنشيط المعاملات:', error);
        showToast(error.message || 'فشل في تنشيط المعاملات', 'error');
    } finally {
        setLoading(false);
    }
};

// دالة لحفظ إعدادات جدولة تخميل المعاملات
const handleScheduleDeactivation = async (e) => {
    e.preventDefault();
    
    setLoading(true);
    try {
        // يمكن هنا الاتصال بـ API لحفظ إعدادات الجدولة في قاعدة البيانات
        // هذا مثال بسيط يحفظ البيانات في localStorage
        localStorage.setItem('scheduledDeactivation', JSON.stringify(scheduledDeactivation));
        
        setShowScheduleDialog(false);
        showToast('تم حفظ إعدادات الجدولة بنجاح', 'success');
        
        // إذا تم تفعيل الجدولة، ابدأ المؤقت
        if (scheduledDeactivation.isActive) {
            startDeactivationScheduler();
        } else {
            stopDeactivationScheduler();
        }
    } catch (error) {
        console.error('خطأ في حفظ إعدادات الجدولة:', error);
        showToast(error.message || 'فشل في حفظ إعدادات الجدولة', 'error');
    } finally {
        setLoading(false);
    }
};

// دالة لبدء المؤقت للجدولة
const startDeactivationScheduler = () => {
    // هنا يمكن تنفيذ الجدولة حسب التكرار المحدد
    // هذا مثال بسيط، في بيئة الإنتاج يجب استخدام خدمة خلفية
    console.log('تم بدء جدولة تخميل المعاملات');
    showToast('تم بدء جدولة تخميل المعاملات', 'success');
};

// دالة لإيقاف المؤقت
// دالة لإيقاف المؤقت
const stopDeactivationScheduler = (showMessage = true) => {
    console.log('تم إيقاف جدولة تخميل المعاملات');
    // عرض الرسالة فقط إذا كان showMessage صحيحًا
    if (showMessage) {
        showToast('تم إيقاف جدولة تخميل المعاملات', 'info');
    }
};





// دالة تحميل مكتبة SheetJS ديناميكياً
const loadSheetJSLibrary = () => {
  return new Promise((resolve, reject) => {
    if (typeof window.XLSX !== 'undefined') {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js';
    script.onload = () => {
      if (typeof window.XLSX !== 'undefined' && window.XLSX.utils) {
        resolve();
      } else {
        reject(new Error('فشل في تحميل مكتبة Excel'));
      }
    };
    script.onerror = () => reject(new Error('فشل في تحميل مكتبة Excel'));
    document.head.appendChild(script);
  });
};

// دالة تنسيق التاريخ للعرض في Excel
const formatDateForExcel = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  
  return `${day}/${month}/${year}`;
};

// دالة حساب الملخص لبيانات العملاء
const calculateSummaryForClientData = (data) => {
  const totalDeposits = data
    .filter(t => t.TransactionType === 'إيداع')
    .reduce((sum, t) => sum + parseFloat(t.Amount || 0), 0);
  
  const totalWithdrawals = data
    .filter(t => t.TransactionType === 'سحب')
    .reduce((sum, t) => sum + parseFloat(t.Amount || 0), 0);
  
  return {
    TotalTransactions: data.length,
    TotalDeposits: totalDeposits,
    TotalWithdrawals: totalWithdrawals,
    CurrentBalance: totalDeposits - totalWithdrawals
  };
};

const getExportData = () => {
    let dataToExport = [...recentTransactions];
    
    if (exportOptions.dateRange === 'current-page') {
      // تصدير المعاملات المعروضة في الصفحة الحالية فقط
      dataToExport = getPaginatedTransactions();
    } else if (exportOptions.dateRange === 'filtered') {
      dataToExport = recentTransactions;
    } else if (exportOptions.dateRange === 'custom') {
    if (exportOptions.customStartDate) {
      dataToExport = dataToExport.filter(t => new Date(t.TransactionDate) >= new Date(exportOptions.customStartDate));
    }
    if (exportOptions.customEndDate) {
      dataToExport = dataToExport.filter(t => new Date(t.TransactionDate) <= new Date(exportOptions.customEndDate));
    }
  }
  
  if (exportOptions.selectedTypes.length > 0 && exportOptions.selectedTypes.length < 2) {
    dataToExport = dataToExport.filter(t => exportOptions.selectedTypes.includes(t.TransactionType));
  }
  
  dataToExport.sort((a, b) => new Date(b.TransactionDate) - new Date(a.TransactionDate));
  
  return dataToExport;
};

// دالة إنشاء HTML مع تنسيق Excel للعملاء
const createClientExcelHTML = (data, summary) => {
  const currentDate = new Date();
  const formattedDate = currentDate.toLocaleDateString('ar-EG', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    weekday: 'long'
  });

  return `
    <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
    <head>
      <meta charset="UTF-8">
      <style>
        @page {
          size: A4;
          margin: 0.75in 0.7in 0.75in 0.7in;
          mso-page-orientation: portrait;
        }
        
        table { 
          border-collapse: collapse; 
          width: 100%; 
          direction: rtl;
          font-family: Calibri, Arial, sans-serif;
        }
        
        td {
          border: 2px solid #000000 !important;
          padding: 8px !important;
          vertical-align: middle !important;
          text-align: center !important;
          color: #000000 !important;
        }
        
        .header-main {
          background-color: #ADD8E6 !important;
          font-size: 22pt !important;
          font-weight: bold !important;
          text-align: center !important;
          padding: 12px !important;
          height: 45px !important;
        }
        
        .summary-row {
          background-color: #ADD8E6 !important;
          font-size: 22pt !important;
          font-weight: bold !important;
          text-align: center !important;
          padding: 12px !important;
          height: 45px !important;
        }
        
        .table-header {
          background-color: #D3D3D3 !important;
          font-size: 22pt !important;
          font-weight: bold !important;
          text-align: center !important;
          padding: 10px !important;
          height: 40px !important;
        }
        
        .data-cell {
          font-size: 18pt !important;
          text-align: center !important;
          padding: 8px !important;
          height: 35px !important;
          background-color: #FFFFFF !important;
        }
        
        .amount-cell {
          font-weight: bold !important;
          font-size: 18pt !important;
        }
      </style>
    </head>
    <body>
      <table>
        <tr>
          <td colspan="10" class="header-main">
            تاريخ التقرير: ${formattedDate}
          </td>
        </tr>
        
        <tr>
          <td colspan="10" class="summary-row">
            إجمالي المعاملات ${summary.TotalTransactions} / إجمالي الإيداعات ${summary.TotalDeposits.toLocaleString()} ج.م / إجمالي السحوبات ${summary.TotalWithdrawals.toLocaleString()} ج.م / الرصيد الحالي ${summary.CurrentBalance.toLocaleString()} ج.م
          </td>
        </tr>
        
        <tr>
          <td class="table-header">م</td>
          <td class="table-header">التاريخ</td>
          <td class="table-header">اسم العميل</td>
          <td class="table-header">الرقم القومي</td>
          <td class="table-header">الشركة</td>
          <td class="table-header">المندوب</td>
          <td class="table-header">رقم الهاتف</td>
          <td class="table-header">نوع المعاملة</td>
          <td class="table-header">المبلغ (ج.م)</td>
          <td class="table-header">الرصيد</td>
        </tr>
        
        ${data.map((transaction, index) => `
          <tr>
            <td class="data-cell">${index + 1}</td>
            <td class="data-cell">${formatDateForExcel(transaction.TransactionDate)}</td>
            <td class="data-cell">${transaction.ClientName}</td>
            <td class="data-cell">${transaction.NationalID || '-'}</td>
            <td class="data-cell">${transaction.CompanyName || '-'}</td>
            <td class="data-cell">${transaction.DelegateName || '-'}</td>
            <td class="data-cell">${formatPhoneNumber(transaction.PhoneNumbers)}</td>
            <td class="data-cell">${transaction.TransactionType}</td>
            <td class="amount-cell">${parseInt(transaction.Amount).toLocaleString()}</td>
            <td class="amount-cell">${transaction.IsActive === false 
              ? "غير محتسب" 
              : (transaction.ActiveBalance !== null && transaction.ActiveBalance !== undefined)
                ? `${transaction.ActiveBalance.toLocaleString()} ج.م`
                : `${transaction.Balance?.toLocaleString() || 0} ج.م`}</td>
          </tr>
        `).join('')}
      </table>
    </body>
    </html>
  `;
};

// دالة التصدير المتقدم للعملاء
const exportToExcelAdvanced = async () => {
  try {
    const dataToExport = getExportData();
    const exportSummary = calculateSummaryForClientData(dataToExport);
    
    const htmlContent = createClientExcelHTML(dataToExport, exportSummary);
    
    const blob = new Blob([htmlContent], {
      type: 'application/vnd.ms-excel;charset=utf-8'
    });
    
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `تقرير_معاملات_العملاء_${new Date().toISOString().split('T')[0]}.xls`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    showToast('تم تصدير التقرير بتنسيق احترافي بنجاح!', 'success');
  } catch (error) {
    console.error('خطأ في التصدير:', error);
    showToast('حدث خطأ أثناء التصدير', 'error');
  }
};

// دالة تصدير CSV للعملاء
const exportToCSV = () => {
  const dataToExport = getExportData();
  
  let csvContent = "\uFEFF";
  csvContent += "تقرير معاملات العملاء\n";
  csvContent += `تاريخ التقرير: ${new Date().toLocaleDateString('ar-EG')}\n`;
  csvContent += `عدد المعاملات: ${dataToExport.length}\n\n`;
  
  if (exportOptions.includeSummary) {
    const exportSummary = calculateSummaryForClientData(dataToExport);
    csvContent += "الملخص المالي:\n";
    csvContent += `إجمالي الإيداعات,${exportSummary.TotalDeposits} ج.م\n`;
    csvContent += `إجمالي السحوبات,${exportSummary.TotalWithdrawals} ج.م\n`;
    csvContent += `الرصيد الحالي,${exportSummary.CurrentBalance} ج.م\n\n`;
  }
  
  csvContent += "التاريخ,اسم العميل,الرقم القومي,الشركة,المندوب,رقم الهاتف,نوع المعاملة,المبلغ (ج.م),الرصيد,الحالة\n";
  
  dataToExport.forEach(transaction => {
    const row = [
      new Date(transaction.TransactionDate).toLocaleDateString('ar-EG'),
      transaction.ClientName,
      transaction.NationalID || '',
      transaction.CompanyName || '',
      transaction.DelegateName || '',
      formatPhoneNumber(transaction.PhoneNumbers),
      transaction.TransactionType,
      `${transaction.Amount} ج.م`,
      transaction.IsActive === false 
        ? "غير محتسب" 
        : (transaction.ActiveBalance !== null && transaction.ActiveBalance !== undefined)
          ? `${transaction.ActiveBalance?.toLocaleString()} ج.م`
          : `${transaction.Balance?.toLocaleString() || 0} ج.م`,
      transaction.IsActive === false ? "خامل" : "نشط"
    ];
    csvContent += row.map(field => `"${field}"`).join(',') + '\n';
  });
  
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `معاملات_العملاء_${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const exportToPDF = async () => {
    try {
        setLoading(true);
        
        let dataToExport = [];
        
        // تحديد البيانات المطلوب تصديرها حسب الخيار المحدد
        if (exportOptions.dateRange === 'current-page') {
            // تصدير الصفحة الحالية فقط
            dataToExport = getPaginatedTransactions();
            console.log(`📄 تصدير الصفحة الحالية: ${dataToExport.length} معاملة`);
        } else if (exportOptions.dateRange === 'filtered') {
            // استخدام البيانات المعروضة حالياً
            dataToExport = [...recentTransactions];
            console.log(`📋 تصدير البيانات المعروضة: ${dataToExport.length} معاملة`);
        } else if (exportOptions.dateRange === 'all') {
            // جلب جميع البيانات من قاعدة البيانات
            showToast('جاري جلب جميع البيانات للتصدير...', 'info');
            
            try {
                const response = await fetch(`${API_BASE}/transactions/recent?limit=100000&includeInactive=true`);
                if (!response.ok) {
                    throw new Error('فشل في جلب البيانات');
                }
                const allData = await response.json();
                dataToExport = allData.map(transaction => ({
                    ...transaction,
                    PhoneNumbers: transaction.PhoneNumbers || '[]'
                }));
                
                console.log(`✅ تم جلب ${dataToExport.length} معاملة للتصدير`);
            } catch (error) {
                console.error('خطأ في جلب جميع البيانات:', error);
                showToast('فشل في جلب جميع البيانات، سيتم تصدير البيانات المعروضة', 'warning');
                dataToExport = [...recentTransactions];
            }
        } else if (exportOptions.dateRange === 'custom') {
            // للبيانات المخصصة، جلب جميع البيانات ثم فلترها حسب التاريخ
            showToast('جاري جلب البيانات للفترة المخصصة...', 'info');
            
            try {
                const response = await fetch(`${API_BASE}/transactions/recent?limit=100000&includeInactive=true`);
                if (!response.ok) {
                    throw new Error('فشل في جلب البيانات');
                }
                const allData = await response.json();
                dataToExport = allData.map(transaction => ({
                    ...transaction,
                    PhoneNumbers: transaction.PhoneNumbers || '[]'
                }));
                
                // تطبيق فلتر التاريخ المخصص
                if (exportOptions.customStartDate || exportOptions.customEndDate) {
                    dataToExport = dataToExport.filter(transaction => {
                        const transactionDate = new Date(transaction.TransactionDate);
                        let isValid = true;
                        
                        if (exportOptions.customStartDate) {
                            const startDate = new Date(exportOptions.customStartDate);
                            isValid = isValid && transactionDate >= startDate;
                        }
                        
                        if (exportOptions.customEndDate) {
                            const endDate = new Date(exportOptions.customEndDate);
                            endDate.setHours(23, 59, 59, 999); // نهاية اليوم
                            isValid = isValid && transactionDate <= endDate;
                        }
                        
                        return isValid;
                    });
                }
                
                console.log(`📅 تم فلترة ${dataToExport.length} معاملة للفترة المخصصة`);
            } catch (error) {
                console.error('خطأ في جلب البيانات المخصصة:', error);
                showToast('فشل في جلب البيانات، سيتم تصدير البيانات المعروضة', 'warning');
                dataToExport = [...recentTransactions];
            }
        }
        
        // تطبيق فلتر نوع المعاملة (إن وُجد)
        if (exportOptions.selectedTypes.length === 1) {
            dataToExport = dataToExport.filter(t => 
                exportOptions.selectedTypes.includes(t.TransactionType)
            );
            console.log(`🔍 تم فلترة ${dataToExport.length} معاملة حسب النوع: ${exportOptions.selectedTypes[0]}`);
        }
        
        // ترتيب البيانات حسب التاريخ (الأحدث أولاً)
        dataToExport.sort((a, b) => new Date(b.TransactionDate) - new Date(a.TransactionDate));
        
        if (dataToExport.length === 0) {
            showToast('لا توجد بيانات للتصدير حسب الفلاتر المحددة', 'warning');
            return;
        }
        
        showToast(`جاري تحضير PDF لـ ${dataToExport.length} معاملة...`, 'info');
        
        const exportSummary = calculateSummaryForClientData(dataToExport);
        
        const printWindow = window.open('', '_blank');
        const htmlContent = `
            <!DOCTYPE html>
            <html dir="rtl" lang="ar">
            <head>
                <meta charset="UTF-8">
                <title>تقرير معاملات العملاء</title>
                <style>
                    * { margin: 0; padding: 0; box-sizing: border-box; }
                    body {
                        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                        direction: rtl;
                        background: white;
                        padding: 20px;
                        font-size: 12px;
                    }
                    .header {
                        text-align: center;
                        margin-bottom: 30px;
                        border-bottom: 2px solid #3b82f6;
                        padding-bottom: 20px;
                    }
                    .company-name {
                        font-size: 24px;
                        font-weight: bold;
                        color: #1e40af;
                        margin-bottom: 10px;
                    }
                    .report-title {
                        font-size: 18px;
                        color: #374151;
                        margin-bottom: 10px;
                    }
                    .report-date {
                        color: #6b7280;
                        font-size: 14px;
                    }
                    
                    ${exportOptions.includeSummary ? `
                    .summary-section {
                        background: #f8fafc;
                        border: 1px solid #e2e8f0;
                        border-radius: 8px;
                        padding: 20px;
                        margin-bottom: 30px;
                    }
                    .summary-title {
                        font-size: 16px;
                        font-weight: bold;
                        color: #1e40af;
                        margin-bottom: 15px;
                        text-align: center;
                    }
                    .summary-grid {
                        display: grid;
                        grid-template-columns: repeat(4, 1fr);
                        gap: 20px;
                        text-align: center;
                    }
                    .summary-item {
                        background: white;
                        padding: 15px;
                        border-radius: 6px;
                        border: 1px solid #e2e8f0;
                    }
                    .summary-label {
                        font-weight: bold;
                        color: #374151;
                        margin-bottom: 5px;
                    }
                    .summary-value {
                        font-size: 18px;
                        font-weight: bold;
                    }
                    .deposits { color: #10b981; }
                    .withdrawals { color: #ef4444; }
                    .balance { color: #3b82f6; }
                    .transactions { color: #8b5cf6; }
                    ` : ''}
                    
                    .table-container {
                        margin-top: 20px;
                        overflow-x: auto;
                    }
                    table {
                        width: 100%;
                        border-collapse: collapse;
                        background: white;
                        border: 1px solid #e2e8f0;
                    }
                    th, td {
                        padding: 8px 6px;
                        text-align: right;
                        border: 1px solid #e2e8f0;
                        font-size: 10px;
                    }
                    th {
                        background: #f1f5f9;
                        font-weight: bold;
                        color: #334155;
                    }
                    tr:nth-child(even) { background: #f8fafc; }
                    
                    .type-badge {
                        padding: 4px 8px;
                        border-radius: 12px;
                        font-size: 9px;
                        font-weight: bold;
                    }
                    .deposit-badge {
                        background: #d1fae5;
                        color: #065f46;
                    }
                    .withdrawal-badge {
                        background: #fee2e2;
                        color: #991b1b;
                    }
                    
                    .amount {
                        font-weight: bold;
                        font-size: 10px;
                    }
                    .amount.deposit { color: #10b981; }
                    .amount.withdrawal { color: #ef4444; }
                    
                    .footer {
                        margin-top: 30px;
                        text-align: center;
                        color: #6b7280;
                        font-size: 10px;
                        border-top: 1px solid #e2e8f0;
                        padding-top: 15px;
                    }
                    
                    @media print {
                        body { padding: 10px; }
                        .header { margin-bottom: 20px; }
                        .summary-section { margin-bottom: 20px; }
                        th, td { padding: 6px 4px; font-size: 9px; }
                    }
                </style>
            </head>
            <body>
                <div class="header">
                    <div class="company-name">معاملات العملاء</div>
                    <div class="report-title">تقرير حساب العملاء الشامل</div>
                    <div class="report-date">
                        تاريخ التقرير: ${new Date().toLocaleDateString('ar-EG', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                        })} | 
                        عدد المعاملات: ${dataToExport.length}
                        ${exportOptions.dateRange === 'custom' && (exportOptions.customStartDate || exportOptions.customEndDate) ? `
                        <br>نطاق التاريخ: ${exportOptions.customStartDate ? 'من ' + new Date(exportOptions.customStartDate).toLocaleDateString('ar-EG') : ''} ${exportOptions.customEndDate ? 'إلى ' + new Date(exportOptions.customEndDate).toLocaleDateString('ar-EG') : ''}
                        ` : ''}
                        ${exportOptions.selectedTypes.length > 0 && exportOptions.selectedTypes.length < 2 ? `
                        <br>نوع المعاملات: ${exportOptions.selectedTypes.join(', ')}
                        ` : ''}
                    </div>
                </div>
    
                ${exportOptions.includeSummary ? `
                <div class="summary-section">
                    <div class="summary-title">الملخص المالي</div>
                    <div class="summary-grid">
                        <div class="summary-item">
                            <div class="summary-label">عدد المعاملات</div>
                            <div class="summary-value transactions">${exportSummary.TotalTransactions}</div>
                        </div>
                        <div class="summary-item">
                            <div class="summary-label">إجمالي الإيداعات</div>
                            <div class="summary-value deposits">${exportSummary.TotalDeposits.toLocaleString()} ج.م</div>
                        </div>
                        <div class="summary-item">
                            <div class="summary-label">إجمالي السحوبات</div>
                            <div class="summary-value withdrawals">${exportSummary.TotalWithdrawals.toLocaleString()} ج.م</div>
                        </div>
                        <div class="summary-item">
                            <div class="summary-label">الرصيد الحالي</div>
                            <div class="summary-value balance">${exportSummary.CurrentBalance.toLocaleString()} ج.م</div>
                        </div>
                    </div>
                </div>
                ` : ''}
    
                <div class="table-container">
                    <table>
                        <thead>
                            <tr>
                                <th>التاريخ</th>
                                <th>اسم العميل</th>
                                <th>الرقم القومي</th>
                                <th>الشركة</th>
                                <th>المندوب</th>
                                <th>رقم الهاتف</th>
                                <th>النوع</th>
                                <th>المبلغ</th>
                                <th>الرصيد</th>
                                <th>الحالة</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${dataToExport.map(transaction => `
                                <tr>
                                    <td>${new Date(transaction.TransactionDate).toLocaleDateString('ar-EG')}</td>
                                    <td>${transaction.ClientName}</td>
                                    <td>${transaction.NationalID || '-'}</td>
                                    <td>${transaction.CompanyName || '-'}</td>
                                    <td>${transaction.DelegateName || '-'}</td>
                                    <td>${formatPhoneNumber(transaction.PhoneNumbers)}</td>
                                    <td>
                                        <span class="type-badge ${transaction.TransactionType === 'إيداع' ? 'deposit-badge' : 'withdrawal-badge'}">
                                            ${transaction.TransactionType}
                                        </span>
                                    </td>
                                    <td>
                                        <span class="amount ${transaction.TransactionType === 'إيداع' ? 'deposit' : 'withdrawal'}">
                                            ${transaction.Amount?.toLocaleString()} ج.م
                                        </span>
                                    </td>
                                    <td>
                                        ${transaction.IsActive === false 
                                            ? "غير محتسب" 
                                            : (transaction.ActiveBalance !== null && transaction.ActiveBalance !== undefined)
                                                ? `${transaction.ActiveBalance?.toLocaleString()} ج.م`
                                                : `${transaction.Balance?.toLocaleString() || 0} ج.م`}
                                    </td>
                                    <td>${transaction.IsActive === false ? "خامل" : "نشط"}</td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                </div>
    
                <div class="footer">
                    تم إنشاء هذا التقرير بواسطة نظام إدارة حسابات العملاء | 
                    ${new Date().toLocaleString('ar-EG')}
                </div>
            </body>
            </html>
        `;
        
        printWindow.document.write(htmlContent);
        printWindow.document.close();
        
        printWindow.onload = () => {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
        };
        
        showToast(`تم تحضير PDF لـ ${dataToExport.length} معاملة بنجاح! 🎉`, 'success');
        
      } catch (error) {
        console.error('خطأ في تصدير PDF:', error);
        showToast('حدث خطأ أثناء تصدير PDF: ' + error.message, 'error');
      } finally {
        setLoading(false);
      }
  };

// دالة تنفيذ التصدير حسب النوع المختار
const executeExport = () => {
    if (exportOptions.format === 'excel') {
        exportToAdvancedExcel();
  } else if (exportOptions.format === 'csv') {
    exportToCSV();
  } else if (exportOptions.format === 'pdf') {
    exportToPDF();
  }
  setIsExportModalOpen(false);
};

// دالة عرض نافذة التصدير
const exportReport = () => {
  setIsExportModalOpen(true);
};




// دالة إصلاح المعاملات غير المرتبطة
const fixUnlinkedTransactions = async () => {
    try {
        setLoading(true);
        console.log("🔧 بدء إصلاح المعاملات غير المرتبطة...");
        
        const response = await fetch('/api/client-accounts/diagnosis/fix/unlinked-transactions', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        
        if (data.success) {
            showToast(`✅ تم إصلاح ${data.fixedTransactions} معاملة وحذف ${data.deletedOrphans} معاملة يتيمة`, 'success');
            // تحديث البيانات
            await fetchRecentTransactions();
            await fetchStats();
        } else {
            throw new Error(data.error);
        }
    } catch (error) {
        console.error('خطأ في إصلاح المعاملات:', error);
        showToast('❌ فشل في إصلاح المعاملات: ' + error.message, 'error');
    } finally {
        setLoading(false);
    }
};



// دالة مزامنة المعاملات مع نظام البنوك
const syncWithBankingSystem = async (clientTransaction) => {
    try {
      console.log("جاري مزامنة المعاملة مع نظام البنوك...", clientTransaction);
      
      // 1. البحث عن معاملة بنكية مطابقة بنفس التاريخ والمبلغ
      const response = await axios.get(`${config.BANKS_API_URL}/api/all-transactions`);
      
      if (response.data && Array.isArray(response.data)) {
        const allBankTransactions = response.data;
        
        // البحث عن معاملة بنفس المبلغ والتاريخ تقريباً
        const matchingTransaction = allBankTransactions.find(t => {
          const dateMatch = new Date(t.date).toDateString() === new Date(clientTransaction.TransactionDate).toDateString();
          const amountMatch = Math.abs(parseFloat(t.amount) - parseFloat(clientTransaction.Amount)) < 0.1;
          return dateMatch && amountMatch && t.type.toLowerCase() === clientTransaction.TransactionType.toLowerCase();
        });
        
        if (matchingTransaction) {
          console.log("تم العثور على معاملة بنكية مطابقة:", matchingTransaction);
          
          // 2. تحديث المعاملة البنكية
          const syncResponse = await fetch(`${config.BANKS_API_URL}/api/sync/transaction`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              TransactionID: matchingTransaction.id,
              Amount: parseFloat(clientTransaction.Amount),
              Notes: clientTransaction.Notes || '',
              TransactionType: clientTransaction.TransactionType,
              TransactionDate: clientTransaction.TransactionDate
            })
          });
          
          // 3. تحديث معرف المعاملة البنكية في معاملة العميل
          await fetch(`${API_BASE}/api/transactions/${clientTransaction.TransactionID}/update-bank-transaction`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ bankTransactionId: matchingTransaction.id })
          });
          
          return { success: true, message: "تمت المزامنة بنجاح", bankTransactionId: matchingTransaction.id };
        } else {
          console.log("لم يتم العثور على معاملة بنكية مطابقة");
          return { success: false, message: "لم يتم العثور على معاملة بنكية مطابقة" };
        }
      }
      
      return { success: false, message: "فشل في الوصول إلى بيانات المعاملات البنكية" };
    } catch (error) {
      console.error("خطأ في مزامنة المعاملة مع نظام البنوك:", error);
      return { success: false, message: "خطأ في المزامنة", error };
    }
  };


  // دالة خاصة للمزامنة مع نظام البنوك
  const syncWithBankSystem = async (transaction) => {
    try {
      // تأكد من الحفاظ على تنسيق الملاحظات
      let syncedNotes = transaction.Notes || "";
      // تحقق إذا كانت الملاحظات تحتوي بالفعل على معلومات العميل
      if (!syncedNotes.includes("معاملة للعميل:") && transaction.ClientName) {
        syncedNotes = `معاملة للعميل: ${transaction.ClientName} - ${syncedNotes}`;
      }
      
      // بناء البيانات المطلوبة للمزامنة
      const syncData = {
        transactionId: transaction.BankTransactionID,
        amount: parseFloat(transaction.Amount),
        notes: syncedNotes, // استخدام الملاحظات المنسقة
        type: transaction.TransactionType,
        date: transaction.TransactionDate
      };
      
      console.log('محاولة مزامنة المعاملة مع نظام البنوك:', syncData);
      
      // استدعاء واجهة API المخصصة للمزامنة
 const response = await axios.post(`${config.BANKS_API_URL}/api/bank-accounts/transactions/sync`, syncData);
      
      if (response.data.success) {
        console.log('تمت مزامنة المعاملة مع نظام البنوك بنجاح');
        return true;
      } else {
        console.warn('فشل في مزامنة المعاملة مع نظام البنوك:', response.data.message);
        return false;
      }
    } catch (error) {
      console.error('خطأ أثناء مزامنة المعاملة مع نظام البنوك:', error);
      return false;
    }
  };





// تعديل useEffect
useEffect(() => {
    // استرجاع إعدادات الجدولة من التخزين
    try {
        const savedSchedule = localStorage.getItem('scheduledDeactivation');
        if (savedSchedule) {
            setScheduledDeactivation(JSON.parse(savedSchedule));
        }
    } catch (error) {
        console.error('خطأ في استرجاع إعدادات الجدولة:', error);
    }
}, []);

// تعديل useEffect الثاني
useEffect(() => {
    // تجاهل التأثير عند التحميل الأولي
    if (initialLoad) {
        setInitialLoad(false);
        return;
    }
    
    if (scheduledDeactivation.isActive) {
        startDeactivationScheduler();
    } else {
        stopDeactivationScheduler(true); // إظهار الرسالة فقط عند تغيير الحالة
    }
}, [scheduledDeactivation.isActive]);







// دالة الطباعة المحسنة - للمعاملات المعروضة في الصفحة الحالية فقط
const handlePrint = () => {
    // استخدام المعاملات المعروضة في الصفحة الحالية فقط
    const dataToExport = getPaginatedTransactions();
    const printSummary = calculateSummaryForClientData(dataToExport);
    
    const printWindow = window.open('', '_blank');
    
    const htmlContent = `
      <!DOCTYPE html>
      <html dir="rtl" lang="ar">
      <head>
        <meta charset="UTF-8">
        <title>تقرير المعاملات - الصفحة ${currentPage}</title>
        <style>
          @page {
            size: A4;
            margin: 8mm 3mm;
          }
          
          * { 
            margin: 0; 
            padding: 0; 
            box-sizing: border-box; 
          }
          
          body { 
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            direction: rtl;
            background: white;
            color: black;
            font-size: 14px;
            line-height: 1.4;
          }
          
          .print-container {
            max-width: 100%;
            margin: 0;
            background: white;
            padding: 5px;
          }
          
          .report-header {
            text-align: center;
            margin-bottom: 15px;
            border-bottom: 3px solid black;
            padding-bottom: 10px;
          }
          
          .company-name {
            font-size: 28px;
            font-weight: bold;
            color: black;
            margin-bottom: 5px;
          }
          
          .report-title {
            font-size: 22px;
            color: black;
            margin-bottom: 5px;
          }
          
          .report-date {
            font-size: 16px;
            color: black;
          }
          
          .pagination-info {
            background: #f0f0f0;
            border: 2px solid black;
            border-radius: 8px;
            padding: 10px;
            margin-bottom: 15px;
            text-align: center;
          }
          
          .pagination-title {
            font-size: 18px;
            font-weight: bold;
            color: black;
            margin-bottom: 8px;
          }
          
          .pagination-details {
            font-size: 14px;
            color: black;
          }
          
          .summary-section {
            background: white;
            border: 2px solid black;
            border-radius: 8px;
            padding: 12px;
            margin-bottom: 15px;
          }
          
          .summary-title {
            font-size: 20px;
            font-weight: bold;
            color: black;
            margin-bottom: 10px;
            text-align: center;
            border-bottom: 1px solid black;
            padding-bottom: 5px;
          }
          
          .summary-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 10px;
            text-align: center;
          }
          
          .summary-item {
            background: white;
            padding: 8px;
            border: 1px solid black;
            border-radius: 4px;
          }
          
          .summary-label {
            font-weight: bold;
            color: black;
            margin-bottom: 3px;
            font-size: 12px;
          }
          
          .summary-value {
            font-size: 16px;
            font-weight: bold;
            color: black;
          }
          
          .table-container {
            margin-top: 10px;
            overflow-x: auto;
          }
          
          table { 
            width: 100%; 
            border-collapse: collapse;
            background: white;
            border: 2px solid black;
          }
          
          th, td { 
            padding: 6px 4px;
            text-align: center;
            border: 1px solid black;
            font-size: 11px;
            color: black;
          }
          
          th { 
            background: #f0f0f0;
            font-weight: bold;
            color: black;
            font-size: 12px;
          }
          
          tr:nth-child(even) { 
            background: #f8f8f8; 
          }
          
          tr:nth-child(odd) { 
            background: white; 
          }
          
          .footer {
            margin-top: 15px;
            text-align: center;
            color: black;
            font-size: 12px;
            border-top: 1px solid black;
            padding-top: 8px;
          }
          
          @media print {
            body { 
              font-size: 12px;
            }
            
            .print-container {
              padding: 3px;
            }
            
            .company-name {
              font-size: 24px;
            }
            
            .report-title {
              font-size: 20px;
            }
            
            .report-date {
              font-size: 14px;
            }
            
            .summary-title {
              font-size: 18px;
            }
            
            .summary-value {
              font-size: 14px;
            }
            
            th, td { 
              padding: 5px 3px; 
              font-size: 10px;
            }
            
            th {
              font-size: 11px;
            }
          }
        </style>
      </head>
      <body>
        <div class="print-container">
          <div class="report-header">
            <div class="company-name">حسابات العملاء</div>
            <div class="report-title">تقرير معاملات العملاء - الصفحة الحالية</div>
            <div class="report-date">
              تاريخ التقرير: ${new Date().toLocaleDateString('ar-EG', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                weekday: 'long'
              })}
            </div>
          </div>
  
          <div class="pagination-info">
            <div class="pagination-title">معلومات الصفحة المطبوعة</div>
            <div class="pagination-details">
              الصفحة ${currentPage} من ${totalPages} | 
              عرض ${((currentPage - 1) * itemsPerPage) + 1} إلى ${Math.min(currentPage * itemsPerPage, recentTransactions.length)} من ${recentTransactions.length} معاملة
            </div>
          </div>
  
          <div class="summary-section">
            <div class="summary-title">ملخص المعاملات المعروضة في هذه الصفحة</div>
            <div class="summary-grid">
              <div class="summary-item">
                <div class="summary-label">عدد المعاملات في الصفحة</div>
                <div class="summary-value">${printSummary.TotalTransactions}</div>
              </div>
              <div class="summary-item">
                <div class="summary-label">إجمالي الإيداعات</div>
                <div class="summary-value">${printSummary.TotalDeposits.toLocaleString()} ج.م</div>
              </div>
              <div class="summary-item">
                <div class="summary-label">إجمالي السحوبات</div>
                <div class="summary-value">${printSummary.TotalWithdrawals.toLocaleString()} ج.م</div>
              </div>
              <div class="summary-item">
                <div class="summary-label">صافي المعاملات</div>
                <div class="summary-value">${(printSummary.TotalDeposits - printSummary.TotalWithdrawals).toLocaleString()} ج.م</div>
              </div>
            </div>
          </div>
  
          <div class="table-container">
            <table>
              <thead>
                <tr>
                  <th>م</th>
                  <th>التاريخ</th>
                  <th>اسم العميل</th>
                  <th>الرقم القومي</th>
                  <th>الشركة</th>
                  <th>المندوب</th>
                  <th>الهاتف</th>
                  <th>النوع</th>
                  <th>المبلغ (ج.م)</th>
                  <th>الرصيد</th>
                  <th>الحالة</th>
                </tr>
              </thead>
              <tbody>
                ${dataToExport.map((transaction, index) => `
                  <tr>
                    <td>${((currentPage - 1) * itemsPerPage) + index + 1}</td>
                    <td>${formatDateForExcel(transaction.TransactionDate)}</td>
                    <td>${transaction.ClientName}</td>
                    <td>${transaction.NationalID || '-'}</td>
                    <td>${transaction.CompanyName || '-'}</td>
                    <td>${transaction.DelegateName || '-'}</td>
                    <td>${formatPhoneNumber(transaction.PhoneNumbers)}</td>
                    <td>${transaction.TransactionType}</td>
                    <td>${parseInt(transaction.Amount).toLocaleString()}</td>
                    <td>${transaction.IsActive === false 
                      ? "غير محتسب" 
                      : (transaction.ActiveBalance !== null && transaction.ActiveBalance !== undefined)
                        ? `${transaction.ActiveBalance.toLocaleString()} ج.م`
                        : `${transaction.Balance?.toLocaleString() || 0} ج.م`}</td>
                    <td>${transaction.IsActive === false ? "خامل" : "نشط"}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </div>
  
          <div class="footer">
            تم إنشاء هذا التقرير بواسطة نظام إدارة حسابات العملاء | 
            ${new Date().toLocaleString('ar-EG')} | 
            طباعة الصفحة ${currentPage} فقط
          </div>
        </div>
      </body>
      </html>
    `;
    
    printWindow.document.write(htmlContent);
    printWindow.document.close();
    
    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    };
  };


// إضافة وظيفة طباعة تفاصيل الحساب
// إضافة وظيفة طباعة تفاصيل الحساب
const printAccountDetails = () => {
    const printWindow = window.open('', '', 'height=600,width=800');
    
    // حساب المستحقات المالية
    const requiredAmount = selectedClient.RequiredPayment !== undefined ? Number(selectedClient.RequiredPayment) : 0;
    const totalDeposits = selectedClient.TotalDeposits || 0;
    const totalWithdrawals = selectedClient.TotalWithdrawals || 0;
    const netPaid = totalDeposits - totalWithdrawals;
    const difference = netPaid - requiredAmount;
    const isOverpaid = difference > 0;
    const remainingDue = Math.abs(difference);
    
    printWindow.document.write(`
        <!DOCTYPE html>
        <html dir="rtl">
            <head>
                <title>تفاصيل حساب العميل</title>
                <meta charset="UTF-8">
                <style>
                    @media print {
                        body { visibility: visible; }
                    }
                    body {
                        font-family: Arial, sans-serif;
                        padding: 20px;
                        direction: rtl;
                        visibility: visible;
                        color: #333;
                    }
                    .header {
                        text-align: center;
                        margin-bottom: 20px;
                        padding-bottom: 15px;
                        border-bottom: 1px solid #eee;
                    }
                    .title {
                        font-size: 24px;
                        font-weight: bold;
                        margin-bottom: 10px;
                        color: #333;
                    }
                    .subtitle {
                        color: #666;
                        margin-bottom: 5px;
                    }
                    .client-info {
                        background-color: #f8f9fa;
                        border-radius: 8px;
                        padding: 15px;
                        margin-bottom: 20px;
                        border: 1px solid #eee;
                    }
                    .client-name {
                        font-size: 18px;
                        font-weight: bold;
                        margin-bottom: 10px;
                        color: #333;
                    }
                    .info-row {
                        display: flex;
                        margin-bottom: 5px;
                    }
                    .info-label {
                        width: 120px;
                        font-weight: bold;
                        color: #555;
                    }
                    .info-value {
                        flex: 1;
                    }
                    
                    /* قسم إبراز الرصيد النشط */
                    .active-balance-highlight {
                        border: 2px solid #0366d6;
                        background-color: #e6f0ff;
                        border-radius: 8px;
                        padding: 20px;
                        margin-bottom: 20px;
                        text-align: center;
                        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                    }
                    .active-balance-title {
                        font-size: 16px;
                        color: #0366d6;
                        margin-bottom: 10px;
                        font-weight: bold;
                        text-align: center;
                    }
                    .active-balance-value {
                        font-size: 28px;
                        font-weight: bold;
                        color: #0366d6;
                        text-align: center;
                    }
                    
                    .balance-cards {
                        display: flex;
                        flex-wrap: wrap;
                        gap: 15px;
                        margin-bottom: 20px;
                    }
                    .card {
                        flex: 1;
                        min-width: 200px;
                        padding: 15px;
                        border-radius: 8px;
                        border: 1px solid #eee;
                    }
                    .card-title {
                        font-size: 14px;
                        color: #555;
                        margin-bottom: 5px;
                    }
                    .card-value {
                        font-size: 18px;
                        font-weight: bold;
                    }
                    .inactive-balance {
                        background-color: #f8f9fa;
                    }
                    .deposits {
                        background-color: #e6f7e6;
                        border-color: #c3e6cb;
                    }
                    .deposits .card-title {
                        color: #28a745;
                    }
                    .deposits .card-value {
                        color: #28a745;
                    }
                    .withdrawals {
                        background-color: #f8d7da;
                        border-color: #f5c6cb;
                    }
                    .withdrawals .card-title {
                        color: #dc3545;
                    }
                    .withdrawals .card-value {
                        color: #dc3545;
                    }
                    .payment-status {
                        padding: 10px;
                        border-radius: 5px;
                        margin-top: 15px;
                        font-weight: bold;
                        text-align: center;
                    }
                    .payment-required {
                        background-color: #fff3cd;
                        border: 1px solid #ffeeba;
                        color: #856404;
                    }
                    .payment-pending {
                        background-color: #f8d7da;
                        border: 1px solid #f5c6cb;
                        color: #721c24;
                    }
                    .payment-complete {
                        background-color: #d4edda;
                        border: 1px solid #c3e6cb;
                        color: #155724;
                    }
                    .payment-overpaid {
                        background-color: #cce5ff;
                        border: 1px solid #b8daff;
                        color: #004085;
                    }
                    .transactions-table {
                        width: 100%;
                        border-collapse: collapse;
                        margin-top: 20px;
                    }
                    .transactions-table th, .transactions-table td {
                        border: 1px solid #ddd;
                        padding: 8px;
                        text-align: right;
                    }
                    .transactions-table th {
                        background-color: #f2f2f2;
                        font-weight: bold;
                    }
                    .transactions-table tr:nth-child(even) {
                        background-color: #f8f9fa;
                    }
                    .inactive-row {
                        background-color: #f8f9fa;
                        color: #777;
                    }
                    .withdrawal {
                        color: #dc3545;
                    }
                    .deposit {
                        color: #28a745;
                    }
                    .transaction-type {
                        display: inline-block;
                        padding: 2px 8px;
                        border-radius: 12px;
                        font-size: 12px;
                    }
                    .deposit-type {
                        background-color: #e6f7e6;
                        color: #28a745;
                    }
                    .withdrawal-type {
                        background-color: #f8d7da;
                        color: #dc3545;
                    }
                    .status-active {
                        color: #28a745;
                    }
                    .status-inactive {
                        color: #777;
                    }
                    
                    /* تحسين إبراز الرصيد في جدول المعاملات */
                    .active-balance-cell {
                        background-color: #e6f0ff;
                        font-weight: bold;
                        color: #0366d6;
                    }
                </style>
            </head>
            <body>
                <div class="header">
                    <div class="title">تفاصيل حساب العميل</div>
                    <div class="subtitle">تاريخ التقرير: ${new Date().toLocaleDateString('ar-EG')}</div>
                </div>
                
                <div class="client-info">
                    <div class="client-name">${selectedClient.NameArabic}</div>
                    <div class="info-row">
                        <div class="info-label">الرقم القومي:</div>
                        <div class="info-value">${selectedClient.NationalID || "-"}</div>
                    </div>

                    <div class="info-row">
                        <div class="info-label">المندوب:</div>
                        <div class="info-value">${selectedClient.DelegateName || "-"}</div>
                    </div>
                    <div class="info-row">
                        <div class="info-label">رقم الهاتف:</div>
                        <div class="info-value">${formatPhoneNumber(selectedClient.PhoneNumbers)}</div>
                    </div>
                    <div class="info-row">
                        <div class="info-label">الشركة:</div>
                        <div class="info-value">${selectedClient.CompanyName || "-"}</div>
                    </div>
                </div>
                
                <!-- قسم إبراز الرصيد النشط -->
                <div class="active-balance-highlight">
                    <div class="active-balance-title">الرصيد النشط</div>
                    <div class="active-balance-value">${selectedClient.CurrentBalance?.toLocaleString() || 0} ج.م</div>
                </div>
                
                <div class="balance-cards">
                    <div class="card inactive-balance">
                        <div class="card-title">الرصيد الخامل</div>
                        <div class="card-value">${selectedClient.InactiveBalance?.toLocaleString() || 0} ج.م</div>
                    </div>
                    <div class="card">
                        <div class="card-title">إجمالي الرصيد</div>
                        <div class="card-value">${selectedClient.TotalBalance?.toLocaleString() || 0} ج.م</div>
                    </div>
                </div>
                
                <div class="balance-cards">
                    <div class="card deposits">
                        <div class="card-title">إجمالي الإيداعات النشطة</div>
                        <div class="card-value">${selectedClient.TotalDeposits?.toLocaleString() || 0} ج.م</div>
                    </div>
                    <div class="card withdrawals">
                        <div class="card-title">إجمالي السحوبات النشطة</div>
                        <div class="card-value">${selectedClient.TotalWithdrawals?.toLocaleString() || 0} ج.م</div>
                    </div>
                </div>
                
                <!-- قسم حالة المستحقات -->
                <div class="${requiredAmount <= 0 ? 'payment-status payment-required' : 
                             !isOverpaid && remainingDue > 0 ? 'payment-status payment-pending' : 
                             isOverpaid ? 'payment-status payment-overpaid' : 'payment-status payment-complete'}">
                    ${requiredAmount <= 0 ? 'يلزم تحديد المبلغ المطلوب' : 
                      isOverpaid ? `يوجد مبلغ زائد يمكن سحبه: ${remainingDue?.toLocaleString() || 0} ج.م` : 
                      remainingDue > 0 ? `متبقي على العميل: ${remainingDue?.toLocaleString() || 0} ج.م` : 'تم سداد كامل المستحقات'}
                </div>
                
                <h3>سجل المعاملات</h3>
                <table class="transactions-table">
                    <thead>
                        <tr>
                            <th>التاريخ</th>
                            <th>نوع المعاملة</th>
                            <th>المبلغ</th>
                            <th>الرصيد</th>
                            <th>الملاحظات</th>
                            <th>الحالة</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${selectedClient.transactions.map(transaction => `
                            <tr class="${!transaction.IsActive ? 'inactive-row' : ''}">
                                <td>${new Date(transaction.TransactionDate).toLocaleDateString('ar-EG')}</td>
                                <td>
                                    <span class="transaction-type ${transaction.TransactionType === 'إيداع' ? 'deposit-type' : 'withdrawal-type'}">
                                        ${transaction.TransactionType}
                                    </span>
                                </td>
                                <td class="${transaction.TransactionType === 'إيداع' ? 'deposit' : 'withdrawal'}">
                                    ${transaction.Amount?.toLocaleString()} ج.م
                                </td>
                                <td class="${transaction.IsActive ? 'active-balance-cell' : ''}">
                                    ${transaction.IsActive === false 
                                        ? "غير محتسب" 
                                        : (transaction.ActiveBalance !== null && transaction.ActiveBalance !== undefined)
                                            ? `${transaction.ActiveBalance?.toLocaleString()} ج.م`
                                            : `${transaction.Balance?.toLocaleString()} ج.م`}
                                </td>
                                <td>${transaction.Notes || '-'}</td>
                                <td class="${transaction.IsActive ? 'status-active' : 'status-inactive'}">
                                    ${transaction.IsActive ? "نشط" : "خامل"}
                                </td>
                            </tr>
                        `).join('')}
                    </tbody>
                </table>
            </body>
        </html>
    `);
    
    printWindow.document.close();
    printWindow.focus();
    
    // تأخير قصير قبل الطباعة للتأكد من تحميل الصفحة بالكامل
    setTimeout(() => {
        printWindow.print();
        printWindow.close();
    }, 500);
};



   // مكون الرسم البياني
   const TransactionChart = ({ data }) => {
       if (!data || data.length === 0) return null;
       
       // الحد الأقصى للقيمة لتحديد ارتفاع الأعمدة
       const maxValue = Math.max(
           ...data.map(d => Math.max(d.deposits, d.withdrawals))
       );
       
       return (
           <div className="bg-white rounded-lg p-4 shadow-md">
               <h3 className="text-lg font-semibold mb-4">رسم بياني للمعاملات</h3>
               <div className="flex items-end h-40 gap-1">
                   {data.map((item, index) => (
                       <div key={index} className="flex flex-col items-center">
                           <div className="flex flex-col gap-1 items-center">
                               <div 
                                   className="w-10 bg-green-500 rounded-t-sm"
                                   style={{ 
                                       height: item.deposits > 0 ? `${(item.deposits / maxValue) * 120}px` : '0px',
                                       minHeight: item.deposits > 0 ? '2px' : '0px'
                                   }}
                                   title={`إيداعات: ${item.deposits?.toLocaleString()} ج.م`}
                               ></div>
                               <div 
                                   className="w-10 bg-red-500 rounded-t-sm"
                                   style={{ 
                                       height: item.withdrawals > 0 ? `${(item.withdrawals / maxValue) * 120}px` : '0px', 
                                       minHeight: item.withdrawals > 0 ? '2px' : '0px'
                                   }}
                                   title={`سحوبات: ${item.withdrawals?.toLocaleString()} ج.م`}
                               ></div>
                           </div>
                           <div className="text-xs text-gray-600 mt-1 -rotate-45 origin-top-left w-12 text-right overflow-hidden whitespace-nowrap">
                               {item.date}
                           </div>
                       </div>
                   ))}
               </div>
               <div className="flex justify-center mt-4 gap-4 pt-2 border-t">
                   <div className="flex items-center gap-1">
                       <div className="w-3 h-3 bg-green-500 rounded"></div>
                       <span className="text-xs">إيداعات</span>
                   </div>
                   <div className="flex items-center gap-1">
                       <div className="w-3 h-3 bg-red-500 rounded"></div>
                       <span className="text-xs">سحوبات</span>
                   </div>
               </div>
           </div>
       );
   };



// مكونات موبايل لحسابات العملاء - لا تؤثر على عرض الكمبيوتر
const openEditTransactionForMobile = (transaction) => {
    if (!EDIT_ENABLED) {
        showToast('ميزة تعديل المعاملات تحت التطوير حالياً', 'warning');
        return;
    }
    setEditingTransaction(transaction);
    setTransactionForm({
        PassportID: transaction.PassportID,
        TransactionType: transaction.TransactionType,
        Amount: transaction.Amount,
        Notes: transaction.Notes,
        TransactionDate: new Date(transaction.TransactionDate).toISOString().slice(0, 16)
    });

    if (transaction.PaymentMethodID && transaction.PaymentMethodType) {
        const currentMethod = paymentMethods.find(
            m => m.id === transaction.PaymentMethodID && m.type === transaction.PaymentMethodType
        );
        if (currentMethod) setSelectedPaymentMethod(currentMethod);
    }

    setIsEditMode(true);
    setShowTransactionForm(true);
};

const MobileInfoBox = ({ label, value, icon: Icon }) => (
    <div className="bg-gray-50 rounded-2xl px-3 py-2 border border-gray-100 min-h-[64px] flex flex-col justify-center">
        <div className="text-[11px] text-gray-500 flex items-center gap-1 mb-1">
            {Icon && <Icon size={13} className="text-gray-400" />}
            {label}
        </div>
        <div className="text-sm font-bold text-gray-900 break-words leading-6">{value || '-'}</div>
    </div>
);

const MobileTransactionCard = ({ transaction, index }) => {
    const isDeposit = transaction.TransactionType === 'إيداع';
    const phoneText = formatPhoneNumber(transaction.PhoneNumbers);
    return (
        <div className={`md:hidden bg-white rounded-3xl shadow-sm border overflow-hidden ${transaction.IsActive === false ? 'border-gray-200 opacity-80' : 'border-gray-100'}`}>
            <div className={`h-1.5 ${isDeposit ? 'bg-green-500' : 'bg-red-500'}`}></div>
            <div className="p-4">
                <div className="flex items-start justify-between gap-3 mb-3">
                    <div className="min-w-0 flex-1">
                        <div className="flex items-center gap-2 mb-2">
                            <span className="bg-blue-100 text-blue-800 px-2.5 py-1 rounded-full text-xs font-bold">
                                #{((currentPage - 1) * itemsPerPage) + index + 1}
                            </span>
                            <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-bold ${isDeposit ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                                {isDeposit ? <TrendingUp size={13} /> : <TrendingDown size={13} />}
                                {transaction.TransactionType}
                            </span>
                            <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-bold ${transaction.IsActive !== false ? 'bg-emerald-50 text-emerald-700' : 'bg-gray-100 text-gray-600'}`}>
                                {transaction.IsActive !== false ? 'نشط' : 'غير نشط'}
                            </span>
                        </div>
                        <h4 className="text-lg font-extrabold text-gray-900 truncate">{transaction.ClientName || 'عميل بدون اسم'}</h4>
                        <div className="text-xs text-gray-500 mt-1 flex items-center gap-1">
                            <Calendar size={13} />
                            {new Date(transaction.TransactionDate).toLocaleDateString('ar-EG', { year: 'numeric', month: '2-digit', day: '2-digit' })}
                        </div>
                    </div>
                    <div className="text-left shrink-0">
                        <div className={`text-xl font-extrabold ${isDeposit ? 'text-green-600' : 'text-red-600'}`}>
                            {transaction.Amount?.toLocaleString()} ج.م
                        </div>
                        <div className="text-[11px] text-gray-500 mt-1">المبلغ</div>
                    </div>
                </div>

                <div className="grid grid-cols-2 gap-2 mb-3">
                    <MobileInfoBox label="الرصيد" value={transaction.IsActive === false ? 'غير محتسب' : `${transaction.Balance?.toLocaleString() || 0} ج.م`} icon={Wallet} />
                    <MobileInfoBox label="الشركة" value={transaction.CompanyName || 'غير محدد'} icon={Building} />
                    <MobileInfoBox label="المندوب" value={transaction.DelegateName || 'غير محدد'} icon={Briefcase} />
                    <MobileInfoBox label="رقم الهاتف" value={phoneText} icon={Phone} />
                    <MobileInfoBox label="الرقم القومي" value={transaction.NationalID || '-'} icon={Clipboard} />
                    <MobileInfoBox label="طريقة الدفع" value={transaction.PaymentMethodType === 'bank' ? (transaction.PaymentMethodName || 'حساب بنكي') : 'غير محدد'} icon={BankIcon} />
                </div>

                {transaction.Notes && (
                    <div className="bg-amber-50 text-amber-800 border border-amber-100 rounded-2xl p-3 text-sm mb-3">
                        <span className="font-bold">ملاحظات: </span>{transaction.Notes}
                    </div>
                )}

                <div className="grid grid-cols-3 gap-2 pt-3 border-t border-gray-100">
                    {canDo('معاينة الحساب') && (
                        <button
                            onClick={() => {
                                if (!transaction.PassportID) {
                                    showToast('⚠️ خطأ: معرف العميل غير متوفر', 'error');
                                    return;
                                }
                                fetchClientDetails(transaction.PassportID);
                            }}
                            className="bg-blue-50 text-blue-700 rounded-2xl py-2.5 text-sm font-bold flex items-center justify-center gap-1"
                        >
                            <Eye size={16} /> عرض
                        </button>
                    )}
                    {canDo('تعديل المعاملة') && (
                        <button
                            onClick={() => openEditTransactionForMobile(transaction)}
                            className="bg-yellow-50 text-yellow-700 rounded-2xl py-2.5 text-sm font-bold flex items-center justify-center gap-1"
                        >
                            <Edit size={16} /> تعديل
                        </button>
                    )}
                    {canDo('حذف المعاملة') && (
                        <button
                            onClick={() => handleDeleteTransaction(transaction.TransactionID)}
                            className="bg-red-50 text-red-700 rounded-2xl py-2.5 text-sm font-bold flex items-center justify-center gap-1"
                        >
                            <Trash2 size={16} /> حذف
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

const MobileClientHistoryCard = ({ transaction }) => {
    const isDeposit = transaction.TransactionType === 'إيداع';
    return (
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-3">
            <div className="flex items-start justify-between gap-3">
                <div>
                    <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-bold ${isDeposit ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                        {isDeposit ? <TrendingUp size={13} /> : <TrendingDown size={13} />}
                        {transaction.TransactionType}
                    </span>
                    <div className="text-xs text-gray-500 mt-2 flex items-center gap-1">
                        <Calendar size={13} />
                        {new Date(transaction.TransactionDate).toLocaleDateString('ar-EG')}
                    </div>
                </div>
                <div className="text-left">
                    <div className={`text-lg font-extrabold ${isDeposit ? 'text-green-600' : 'text-red-600'}`}>
                        {transaction.Amount?.toLocaleString()} ج.م
                    </div>
                    <div className="text-xs text-gray-500 mt-1">
                        الرصيد: {transaction.IsActive === false ? 'غير محتسب' : `${transaction.Balance?.toLocaleString() || 0} ج.م`}
                    </div>
                </div>
            </div>
            <div className="mt-3 grid grid-cols-1 gap-2 text-sm">
                <div className="bg-gray-50 rounded-xl px-3 py-2">
                    <span className="text-gray-500">طريقة الدفع: </span>
                    <span className="font-bold text-gray-900">{transaction.PaymentMethodType === 'bank' ? (transaction.PaymentMethodName || 'حساب بنكي') : '-'}</span>
                </div>
                {transaction.Notes && (
                    <div className="bg-amber-50 rounded-xl px-3 py-2 text-amber-800">
                        <span className="font-bold">ملاحظات: </span>{transaction.Notes}
                    </div>
                )}
            </div>
        </div>
    );
};

   const resetAllFormData = () => {
    console.log("🧹 مسح جميع بيانات النموذج...");
    
    setTransactionForm({
        PassportID: '',
        TransactionType: 'إيداع',
        Amount: '',
        Notes: '',
        TransactionDate: new Date().toISOString().slice(0, 16),
        PaymentMethodID: null,
        PaymentMethodType: null
    });
    
    setSelectedPaymentMethod(null);
    setSelectedClient(null);
    setIsEditMode(false);
    setEditingTransaction(null);
};

   return (
       <div className="min-h-screen bg-gray-50 py-2 sm:py-4 client-accounts-page overflow-x-hidden" dir="rtl">
          <div className="w-full max-w-[98%] max-md:max-w-full mx-auto px-2 sm:px-3">
{/* شريط الأدوات/العنوان */}
<div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-3 sm:mb-4 gap-2">
    <div className="flex items-center gap-2">
        <Link
            to="/"
            className="bg-gray-600 text-white px-3 py-2 rounded-lg flex items-center gap-1 hover:bg-gray-700 transition-colors text-sm"
        >
            <ArrowRight size={18} />
            <span className="hidden sm:inline">العودة للرئيسية</span>
        </Link>
    </div>
    <h1 className="text-xl sm:text-2xl font-bold text-gray-900 flex items-center gap-2 max-md:w-full max-md:justify-center">
        <Wallet size={22} className="text-blue-600" />
        حسابات العملاء
    </h1>
</div>

{/* زر مستقل للموبايل لضمان ظهور إدارة المديونيات بعيدًا عن ازدحام شريط الأدوات */}
{canDo('إدارة المبالغ المطلوبة') && (
    <div className="md:hidden mb-3">
        <button
            type="button"
            onClick={() => setShowDebtManager(true)}
            className="w-full min-h-[50px] bg-gradient-to-l from-rose-700 to-red-600 text-white px-4 py-3 rounded-2xl shadow-lg flex items-center justify-center gap-2 font-black active:scale-[0.99] transition-transform"
            title="تسجيل ومتابعة مديونيات السفرات النشطة والمؤرشفة"
        >
            <Wallet size={20} />
            المديونيات والتحصيلات
        </button>
    </div>
)}

               {/* لوحة الإحصائيات */}
              <div className="grid grid-cols-3 gap-2 sm:gap-5 mb-4 sm:mb-5">
               <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl sm:rounded-xl shadow-lg p-3 sm:p-4 text-white">
                        <div className="flex justify-between items-center">
                            <div>
                                <p className="text-[11px] sm:text-sm opacity-80">عدد المعاملات النشطة</p>
                                <h3 className="text-base sm:text-2xl font-bold mt-1 sm:mt-2">
                                    {stats.TotalTransactions}
                                </h3>
                            </div>
                            <FileText className="h-8 w-8 sm:h-12 sm:w-12 opacity-20" />
                        </div>
                    </div>

                    <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-2xl sm:rounded-xl shadow-lg p-3 sm:p-4 text-white">
                        <div className="flex justify-between items-center">
                            <div>
                                <p className="text-[11px] sm:text-sm opacity-80">إجمالي الإيداعات </p>
                                <h3 className="text-base sm:text-2xl font-bold mt-1 sm:mt-2">
                                    {stats.TotalDeposits?.toLocaleString()} ج.م
                                </h3>
                            </div>
                            <TrendingUp className="h-8 w-8 sm:h-12 sm:w-12 opacity-20" />
                        </div>
                    </div>

                  <div className="bg-gradient-to-br from-red-500 to-red-600 rounded-2xl sm:rounded-xl shadow-lg p-3 sm:p-4 text-white">
                      <div className="flex justify-between items-center">
                          <div>
                              <p className="text-[11px] sm:text-sm opacity-80">إجمالي السحوبات</p>
                              <h3 className="text-base sm:text-2xl font-bold mt-1 sm:mt-2">
                                  {stats.TotalWithdrawals?.toLocaleString()} ج.م
                              </h3>
                          </div>
                          <TrendingDown className="h-8 w-8 sm:h-12 sm:w-12 opacity-20" />
                      </div>
                  </div>
              </div>

              {/* الرسم البياني للمعاملات */}
              {showStats && chartData && chartData.length > 0 && (
                  <div className="mb-6">
                      <TransactionChart data={chartData} />
                  </div>
              )}

         {/* شريط الأدوات */}
<div className="bg-white rounded-xl shadow-md p-3 mb-5">
    <div className="flex flex-col gap-3">
        <div className="grid grid-cols-2 sm:flex sm:items-center gap-2 sm:gap-4">
            {/* إزالة زر معاملة جديدة من هنا */}
            {/* <button
                onClick={() => {
                    setIsEditMode(false);
                    setShowTransactionForm(true);
                }}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg 
                         flex items-center gap-2 hover:bg-blue-700 transition-colors"
            >
                <Plus size={20} />
                معاملة جديدة
            </button> */}
            
            <button
                onClick={() => setFilterVisible(!filterVisible)}
                className="bg-gray-100 text-gray-700 px-3 py-2 rounded-lg flex items-center justify-center gap-1 hover:bg-gray-200 transition-colors text-sm"
            >
                <Filter size={17} />
                تصفية
            </button>



            
  {canDo('إدارة المبالغ المطلوبة') && (
    <button
        onClick={() => setShowRequiredPaymentManager(true)}
        className="bg-purple-600 text-white px-3 py-2 rounded-lg flex items-center justify-center gap-1 hover:bg-purple-700 transition-colors text-sm"
    >
        <DollarSign size={17} />
        <span className="hidden md:inline">المبالغ المطلوبة القديمة</span>
        <span className="md:hidden">قديم</span>
    </button>
  )}

  {canDo('إدارة المبالغ المطلوبة') && (
    <button
        onClick={() => setShowDebtManager(true)}
        className="hidden md:flex bg-rose-600 text-white px-3 py-2 rounded-lg items-center justify-center gap-1 hover:bg-rose-700 transition-colors text-sm"
        title="تسجيل ومتابعة مديونيات السفرات النشطة والمؤرشفة"
    >
        <Wallet size={17} />
        <span className="hidden md:inline">المديونيات والتحصيلات</span>
        <span className="md:hidden">المديونيات</span>
    </button>
  )}

 





    <button
        onClick={exportReport}
        className="bg-orange-600 hover:bg-orange-700 text-white px-3 py-2 rounded-lg flex items-center justify-center gap-1 transition-colors text-sm"
    >
        <FileSpreadsheet size={17} />
        <span className="hidden sm:inline">تصدير متقدم</span>
        <span className="sm:hidden">تصدير</span>
    </button>
    <button
  onClick={handlePrint}
  className="bg-purple-600 text-white px-3 py-2 rounded-lg flex items-center justify-center gap-1 hover:bg-purple-700 transition-colors text-sm"
>
  <Printer size={17} />
  <span className="hidden sm:inline">طباعة محسنة</span>
  <span className="sm:hidden">طباعة</span>
</button>
        </div>

        <div className="rounded-xl border border-blue-100 bg-blue-50/60 p-3">
            <div className="flex items-center justify-between gap-2 mb-2">
                <label htmlFor="searchInput" className="text-sm font-bold text-blue-900 flex items-center gap-2">
                    <Search size={17} className="text-blue-600" />
                    بحث في المعاملات المالية
                </label>
                {searchQuery && (
                    <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded-full">
                        {recentTransactions.length} نتيجة
                    </span>
                )}
            </div>
            <div className="relative w-full">
                <Search className="absolute right-3 top-1/2 -translate-y-1/2 text-blue-400" size={20} />
                <input
                    id="searchInput"
                    type="text"
                    placeholder="ابحث داخل المعاملات: رقم الملف، اسم العميل، الرقم القومي، رقم الجواز، الشركة، المندوب، المبلغ، الملاحظات..."
                    value={searchQuery}
                    onChange={(e) => {
                        const value = e.target.value;
                        setSearchQuery(value);

                        if (transactionSearchTimerRef.current) {
                            clearTimeout(transactionSearchTimerRef.current);
                        }

                        transactionSearchTimerRef.current = setTimeout(() => {
                            handleTransactionSearch(value);
                        }, 500);
                    }}
                    disabled={!canDo('البحث عن معاملات')}
                    className={`w-full pl-10 pr-12 py-2 border border-blue-200 bg-white rounded-lg 
                            focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                      !canDo('البحث عن معاملات') ? 'bg-gray-100 cursor-not-allowed opacity-60' : ''
                    }`}
                />
                {isTransactionSearching ? (
                    <div className="absolute left-3 top-1/2 -translate-y-1/2">
                        <div className="animate-spin rounded-full h-5 w-5 border-2 border-blue-600 border-t-transparent"></div>
                    </div>
                ) : (
                    <button
                        onClick={() => {
                            if (transactionSearchTimerRef.current) {
                                clearTimeout(transactionSearchTimerRef.current);
                            }
                            setSearchQuery('');
                            fetchRecentTransactions(showActiveOnly);
                        }}
                        className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                        title="إعادة تحميل المعاملات"
                    >
                        <RefreshCw size={18} />
                    </button>
                )}
            </div>
            <div className="mt-2 flex flex-wrap gap-1 text-[11px] text-blue-700">
                <span className="bg-white border border-blue-100 rounded-full px-2 py-0.5">بحث معاملات فقط</span>
                <span className="bg-white border border-blue-100 rounded-full px-2 py-0.5">لا يفتح حساب عميل</span>
                <span className="bg-white border border-blue-100 rounded-full px-2 py-0.5">يعرض سجل الإيداعات والسحوبات</span>
            </div>
        </div>
    </div>




{/* قسم معاينة العملاء */}
<div className="bg-white rounded-xl shadow-md p-3 mb-4 border border-gray-100">
    <div className="flex items-center justify-between mb-4">
        <div>
            <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                <User size={18} className="text-emerald-600" />
                بحث ومعاينة حساب عميل
            </h3>
            <p className="text-xs text-gray-500 mt-1">هذا البحث لا يفلتر جدول المعاملات، لكنه يفتح حساب العميل مباشرة.</p>
        </div>
    </div>
    
    <div className="flex flex-col md:flex-row gap-4">
        <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">
                 البحث عن عميل محدد
            </label>
            <div className="relative">
                <input
                    type="text"
                    placeholder="ابحث عن عميل برقم الملف، الاسم، الرقم القومي، الهاتف أو رقم الجواز..."
                    value={clientSearchQuery}
                    onChange={(e) => {
                        setClientSearchQuery(e.target.value);
                        handleClientSearch(e.target.value);
                    }}
                    disabled={!canDo('البحث عن عميل')}
                    className={`w-full border border-gray-300 rounded-lg px-4 py-2 
                            focus:ring-2 focus:ring-blue-500 focus:outline-none ${
                      !canDo('البحث عن عميل') ? 'bg-gray-100 cursor-not-allowed opacity-60' : ''
                    }`}
                />
                {isClientSearching && (
                    <div className="absolute left-3 top-1/2 -translate-y-1/2">
                        <div className="animate-spin rounded-full h-5 w-5 
                                    border-2 border-blue-600 border-t-transparent">
                        </div>
                    </div>
                )}
            </div>
            
            {clientSearchResults.length > 0 && (
                <div className="mt-2 border rounded-lg shadow-lg max-h-40 
                            overflow-y-auto bg-white divide-y divide-gray-100">
                    {clientSearchResults.map(client => (
                        <div
                            key={client.PassportID}
                            className="p-3 hover:bg-blue-50 cursor-pointer transition-colors duration-200"
                            onClick={() => {
                                if (client.PassportID) {
                                    fetchClientDetails(client.PassportID);
                                    setClientSearchQuery('');
                                    setClientSearchResults([]);
                                } else {
                                    showToast('معرف العميل غير متوفر', 'error');
                                }
                            }}
                        >
                            <div className="flex justify-between items-start">
                                <div>
                                    <div className="font-medium text-gray-900 flex items-center gap-1">
                                        <User size={14} className="text-blue-500" />
                                        {client.NameArabic}
                                    </div>
                                    <div className="text-xs text-gray-500 mt-1">
                                        الرقم القومي: {client.NationalID || '-'}
                                    </div>
                                    <div className="text-xs text-gray-500">
                                        رقم الجواز: {client.PassportNumber || '-'}
                                    </div>
                                </div>
                                <div className="text-right">
                                    <div className={`text-xs font-medium 
                                        ${client.CurrentBalance >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                                        الرصيد: {client.CurrentBalance?.toLocaleString() || 0} ج.م
                                    </div>
                                    {Array.isArray(client.PhoneNumbers) && client.PhoneNumbers[0] && (
                                        <div className="text-xs text-gray-500 mt-1">
                                            هاتف: {client.PhoneNumbers[0]}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    </div>
</div>




                  {/* قسم الفلاتر */}
                  {filterVisible && (
                      <div className="mt-4 p-4 border-t border-gray-200">
                          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                              <div>
                                  <label className="block text-sm font-medium text-gray-700 mb-1">
                                      من تاريخ
                                  </label>
                                  <input
                                      type="date"
                                      value={filters.dateFrom}
                                      onChange={(e) => setFilters({...filters, dateFrom: e.target.value})}
                                      className="w-full border border-gray-300 rounded-lg px-3 py-2"
                                  />
                              </div>
                              <div>
                                  <label className="block text-sm font-medium text-gray-700 mb-1">
                                      إلى تاريخ
                                  </label>
                                  <input
                                      type="date"
                                      value={filters.dateTo}
                                      onChange={(e) => setFilters({...filters, dateTo: e.target.value})}
                                      className="w-full border border-gray-300 rounded-lg px-3 py-2"
                                  />
                              </div>
                              <div>
                                  <label className="block text-sm font-medium text-gray-700 mb-1">
                                      نوع المعاملة
                                  </label>
                                  <select
                                      value={filters.transactionType}
                                      onChange={(e) => setFilters({...filters, transactionType: e.target.value})}
                                      className="w-full border border-gray-300 rounded-lg px-3 py-2"
                                  >
                                      <option value="">الكل</option>
                                      <option value="إيداع">إيداع</option>
                                      <option value="سحب">سحب</option>
                                  </select>
                              </div>
                              <div>
                                  <label className="block text-sm font-medium text-gray-700 mb-1">
                                      المبلغ
                                  </label>
                                  <div className="flex flex-col sm:flex-row gap-2">
                                      <input
                                          type="number"
                                          placeholder="من"
                                          value={filters.minAmount}
                                          onChange={(e) => setFilters({...filters, minAmount: e.target.value})}
                                          className="w-1/2 border border-gray-300 rounded-lg px-3 py-2"
                                      />
                                      <input
                                          type="number"
                                          placeholder="إلى"
                                          value={filters.maxAmount}
                                          onChange={(e) => setFilters({...filters, maxAmount: e.target.value})}
                                          className="w-1/2 border border-gray-300 rounded-lg px-3 py-2"
                                      />
                                  </div>
                              </div>
                          </div>
                          <div className="mt-4 flex justify-end gap-4">
                              <button
                                  onClick={resetFilters}
                                  className="bg-gray-100 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-200"
                              >
                                  إعادة تعيين
                              </button>
                              <button
                                  onClick={applyFilters}
                                  className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
                              >
                                  تطبيق الفلترة
                              </button>
                          </div>
                      </div>
                  )}
              </div>

              

              <div className="bg-green-50 border border-green-200 rounded-lg p-3 mb-4">
    <div className="flex items-center gap-2">
        <Info size={16} className="text-green-600" />
        <p className="text-sm text-green-800">
            يتم عرض جميع المعاملات مع نظام صفحات للتنقل السهل. استخدم البحث للعثور على معاملات محددة.
        </p>
    </div>
</div>

{/* جدول المعاملات المحسن - بدون رقم المعاملة */}
<div className="bg-white rounded-3xl sm:rounded-xl shadow-lg overflow-hidden border border-gray-100 mx-0 sm:mx-2 my-3">
<div className="px-6 py-4 bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-gray-200">
    <div className="flex justify-between items-center">
        <h3 className="text-2xl font-bold text-gray-800 text-right">جدول المعاملات</h3>
        <div className="text-sm text-gray-600 bg-white px-3 py-1 rounded-full border">
            <span className="font-semibold">إجمالي المعاملات: {recentTransactions.length}</span>
        </div>
    </div>
</div>
    


    <div className="md:hidden bg-gray-50 p-3 space-y-3">
        {getPaginatedTransactions().map((transaction, index) => (
            <MobileTransactionCard key={transaction.TransactionID} transaction={transaction} index={index} />
        ))}
        {recentTransactions.length === 0 && (
            <div className="bg-white rounded-3xl p-8 text-center border border-gray-100 shadow-sm">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <AlertCircle size={32} className="text-gray-400" />
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">لا توجد معاملات</h4>
                <p className="text-sm text-gray-600 mb-4">اختر عميلًا من قسم حسابات العملاء لإضافة معاملة جديدة.</p>
                <button
                    onClick={() => setShowTransactionForm(true)}
                    className="bg-blue-600 text-white px-5 py-3 rounded-2xl font-bold"
                >
                    إضافة معاملة جديدة
                </button>
            </div>
        )}
    </div>

    <div className="hidden md:block overflow-x-auto -mx-1">
        <table className="w-full divide-y divide-gray-200 text-sm" id="transactions-table" style={{minWidth: "900px"}}>
        <thead className="bg-gray-50">
    <tr>
        <th className="px-2 py-3 text-center text-xs font-bold text-gray-700 uppercase tracking-wider">
            #
        </th>
        <th className="px-2 py-3 text-right text-xs font-bold text-gray-700 uppercase tracking-wider">
            التاريخ
        </th>
                    <th className="px-2 py-3 text-right text-xs font-bold text-gray-700 uppercase tracking-wider">
                        العميل
                    </th>
                    <th className="px-2 py-3 text-right text-xs font-bold text-gray-700 uppercase tracking-wider">
                        الرقم القومي
                    </th>
                    <th className="px-2 py-3 text-right text-xs font-bold text-gray-700 uppercase tracking-wider">
                        الشركة
                    </th>
                    <th className="px-2 py-3 text-right text-xs font-bold text-gray-700 uppercase tracking-wider">
                        المندوب
                    </th>
                    <th className="px-2 py-3 text-right text-xs font-bold text-gray-700 uppercase tracking-wider">
                        رقم الهاتف
                    </th>
                    <th className="px-2 py-3 text-right text-xs font-bold text-gray-700 uppercase tracking-wider">
                        نوع المعاملة
                    </th>
                    <th className="px-2 py-3 text-right text-xs font-bold text-gray-700 uppercase tracking-wider">
                        المبلغ
                    </th>
                    <th className="px-2 py-3 text-right text-xs font-bold text-gray-700 uppercase tracking-wider">
                        الرصيد
                    </th>
                    <th className="px-2 py-3 text-center text-xs font-bold text-gray-700 uppercase tracking-wider">
                        الحالة
                    </th>
                    <th className="px-2 py-3 text-right text-xs font-bold text-gray-700 uppercase tracking-wider">
                        طريقة الدفع
                    </th>
                    <th className="px-2 py-3 text-right text-xs font-bold text-gray-700 uppercase tracking-wider">
                        أضيف بواسطة
                    </th>
                    <th className="px-2 py-3 text-center text-xs font-bold text-gray-700 uppercase tracking-wider">
                        الإجراءات
                    </th>
                </tr>
            </thead>
            
            <tbody className="bg-white divide-y divide-gray-200">
    {getPaginatedTransactions().map((transaction, index) => (
        <tr 
            key={transaction.TransactionID} 
            className={`
                hover:bg-blue-50 transition-all duration-200 ease-in-out
                ${transaction.IsActive === false ? 'bg-gray-50 opacity-75' : ''}
                ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50/30'}
            `}
        >
            {/* رقم الصف المتسلسل */}
            <td className="px-2 py-3 whitespace-nowrap text-sm text-gray-900 font-semibold">
                <div className="flex items-center justify-center">
                    <span className="bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full text-xs font-bold min-w-[32px] text-center">
                        {((currentPage - 1) * itemsPerPage) + index + 1}
                    </span>
                </div>
            </td>

                    {/* إضافة عمود التاريخ بعد رقم الصف المتسلسل */}
<td className="px-2 py-3 whitespace-nowrap text-sm text-gray-700">
    <div className="flex items-center">
        <Calendar size={13} className="ml-1 text-gray-500 hidden 2xl:inline" />
        <span className="font-medium">
            {new Date(transaction.TransactionDate).toLocaleDateString('ar-EG', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            })}
        </span>
    </div>
</td>
    
                     {/* اسم العميل */}
                     <td className="px-2 py-3 text-sm font-bold text-gray-900 min-w-[8rem]">
                            <div className="flex flex-col">
                                <div className="flex items-center">
                                    <User size={14} className="ml-1.5 text-gray-500 shrink-0 hidden 2xl:inline" />
                                    <span className={`text-sm ${transaction.ClientIsActive === false ? 'text-gray-600' : ''}`}>
                                        {transaction.ClientName}
                                    </span>
                                </div>
                                {/* مؤشر الأرشفة */}
                                {transaction.ClientIsActive === false && (
                                    <div className="mt-1">
                                        <div className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 border border-yellow-200">
                                            <AlertCircle size={12} className="ml-1" />
                                            عميل مؤرشف
                                        </div>
                                    </div>
                                )}
                            </div>
                        </td>
                        
                        {/* الرقم القومي */}
                        <td className="px-2 py-3 whitespace-nowrap text-sm text-gray-700 font-mono font-semibold">
                            {transaction.NationalID}
                        </td>
                        
                        {/* الشركة */}
                        <td className="px-2 py-3 text-sm text-gray-700 font-medium">
                            <span className={`${transaction.CompanyName ? 'text-gray-900 font-semibold' : 'text-gray-400'}`}>
                                {transaction.CompanyName || 'غير محدد'}
                            </span>
                        </td>
                        
                        {/* المندوب */}
                        <td className="px-2 py-3 text-sm text-gray-700 font-medium">
                            <span className={`${transaction.DelegateName ? 'text-gray-900 font-semibold' : 'text-gray-400'}`}>
                                {transaction.DelegateName || 'غير محدد'}
                            </span>
                        </td>
                        
                        {/* رقم الهاتف */}
                        <td className="px-2 py-3 text-sm text-gray-700">
                            <div className="space-y-1">
                                {formatPhoneNumber(transaction.PhoneNumbers).split(' ، ').map((phone, phoneIndex) => (
                                    phone !== '-' && (
                                        <div key={phoneIndex} className="flex items-center gap-1 group whitespace-nowrap">
                                            <Phone size={13} className="text-gray-500 shrink-0 hidden 2xl:inline" />
                                            <span className="font-mono text-[13px] font-medium" dir="ltr">{phone}</span>
                                            <button 
                                                onClick={() => copyToClipboard(phone)}
                                                className="opacity-0 group-hover:opacity-100 text-blue-600 hover:text-blue-800 transition-all duration-200 p-1 rounded"
                                                title="نسخ رقم الهاتف"
                                            >
                                                <Copy size={14} />
                                            </button>
                                        </div>
                                    )
                                ))}
                                {formatPhoneNumber(transaction.PhoneNumbers) === '-' && (
                                    <span className="text-gray-400 text-xs">غير متوفر</span>
                                )}
                            </div>
                        </td>
                        
                        {/* نوع المعاملة */}
                        <td className="px-2 py-3 whitespace-nowrap">
                            <span className={`
                                inline-flex items-center px-2.5 py-1 rounded-full text-xs font-bold whitespace-nowrap
                                ${transaction.TransactionType === 'إيداع' ? 
                                'bg-green-100 text-green-800 border border-green-200' : 
                                'bg-red-100 text-red-800 border border-red-200'}
                            `}>
                                {transaction.TransactionType === 'إيداع' ? (
                                    <TrendingUp size={13} className="ml-1" />
                                ) : (
                                    <TrendingDown size={13} className="ml-1" />
                                )}
                                {transaction.TransactionType}
                            </span>
                        </td>
                        
                        {/* المبلغ */}
                        <td className="px-2 py-3 whitespace-nowrap text-sm font-bold">
                            <span className={`
                                ${transaction.TransactionType === 'إيداع' ? 'text-green-600' : 'text-red-600'}
                                flex items-center text-sm
                            `}>
                                <DollarSign size={13} className="ml-0.5 hidden 2xl:inline" />
                                {transaction.Amount?.toLocaleString()} ج.م
                            </span>
                        </td>
                        
                        {/* الرصيد */}
                    <td className="px-2 py-3 whitespace-nowrap text-sm font-bold text-gray-900">
                        <div className="flex items-center">
                            <Wallet size={13} className="ml-1 text-gray-500 hidden 2xl:inline" />
                            <span className="text-sm">
                                {transaction.IsActive === false
                                    ? <span className="text-gray-500 italic">غير محتسب</span>
                                    : `${transaction.Balance?.toLocaleString() || 0} ج.م`
                                }
                            </span>
                        </div>
                    </td>
                        
                        {/* الحالة */}
                        <td className="px-2 py-3 text-center">
                            <span className={`
                                inline-flex items-center px-2.5 py-1 rounded-full text-xs font-bold whitespace-nowrap
                                ${transaction.IsActive !== false ? 
                                'bg-green-100 text-green-800 border border-green-200' : 
                                'bg-gray-100 text-gray-600 border border-gray-200'}
                            `}>
                                <div className={`w-2 h-2 rounded-full ml-1.5 ${
                                    transaction.IsActive !== false ? 'bg-green-500' : 'bg-gray-500'
                                }`}></div>
                                {transaction.IsActive !== false ? 'نشط' : 'غير نشط'}
                            </span>
                        </td>
                        
                        {/* طريقة الدفع */}
                        <td className="px-2 py-3 text-center">
                            {transaction.PaymentMethodType === 'bank' ? (
                                <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-bold whitespace-nowrap bg-blue-100 text-blue-800 border border-blue-200">
                                    <BankIcon size={13} className="ml-1" />
                                    {transaction.PaymentMethodName || 'حساب بنكي'}
                                </span>
                            ) : (
                                <span className="text-xs text-gray-400 font-medium">غير محدد</span>
                            )}
                        </td>
                        
                        {/* أضيف بواسطة */}
                        <td className="px-2 py-3 text-xs text-gray-700">
                            <div className="flex items-center gap-1">
                                <User size={13} className="text-gray-400 shrink-0" />
                                <span className="font-medium">
                                    {transaction.CreatedByFullName || transaction.CreatedBy || '-'}
                                </span>
                            </div>
                        </td>

                        {/* الإجراءات */}
                        <td className="px-2 py-3">
                            <div className="flex gap-0.5 justify-center">
                                {canDo('معاينة الحساب') && (
                                <button
                                    onClick={() => {
                                        console.log("🚀 PassportID عند الضغط:", transaction.PassportID);
                                        if (!transaction.PassportID) {
                                            console.error("⚠️ خطأ: PassportID غير موجود!");
                                            showToast("⚠️ خطأ: معرف العميل غير متوفر", "error");
                                            return;
                                        }
                                        fetchClientDetails(transaction.PassportID);
                                    }}
                                    className="text-blue-600 hover:text-blue-800 transition-all duration-200 p-1.5 rounded-lg hover:bg-blue-50 group"
                                    title="معاينة الحساب"
                                >
                                    <Eye size={17} className="group-hover:scale-110 transition-transform" />
                                </button>
                                )}
                                
                                {canDo('تعديل المعاملة') && (
                                <button
                                    onClick={() => {
                                        if (!EDIT_ENABLED) {
                                            showToast('ميزة تعديل المعاملات تحت التطوير حالياً', 'warning');
                                            return;
                                        }
                                        
                                        setEditingTransaction(transaction);
                                        setTransactionForm({
                                            PassportID: transaction.PassportID,
                                            TransactionType: transaction.TransactionType,
                                            Amount: transaction.Amount,
                                            Notes: transaction.Notes,
                                            TransactionDate: new Date(transaction.TransactionDate)
                                                .toISOString().slice(0, 16)
                                        });
                                        
                                        if (transaction.PaymentMethodID && transaction.PaymentMethodType) {
                                            const currentMethod = paymentMethods.find(
                                                m => m.id === transaction.PaymentMethodID && 
                                                     m.type === transaction.PaymentMethodType
                                            );
                                            if (currentMethod) {
                                                setSelectedPaymentMethod(currentMethod);
                                            }
                                        }
                                        
                                        setIsEditMode(true);
                                        setShowTransactionForm(true);
                                    }}
                                    className={`transition-all duration-200 p-1.5 rounded-lg group ${
                                        EDIT_ENABLED 
                                            ? 'text-yellow-600 hover:text-yellow-800 hover:bg-yellow-50' 
                                            : 'text-gray-400 cursor-not-allowed'
                                    }`}
                                    title={EDIT_ENABLED ? "تعديل" : "تحت التطوير"}
                                >
                                    <Edit size={17} className={EDIT_ENABLED ? "group-hover:scale-110 transition-transform" : ""} />
                                </button>
                                )}
                                
                                {canDo('حذف المعاملة') && (
                                <button
                                    onClick={() => handleDeleteTransaction(transaction.TransactionID)}
                                    className="text-red-600 hover:text-red-800 transition-all duration-200 p-1.5 rounded-lg hover:bg-red-50 group"
                                    title="حذف"
                                >
                                    <Trash2 size={17} className="group-hover:scale-110 transition-transform" />
                                </button>
                                )}
                            </div>
                        </td>
                    </tr>
                ))}
                
                {/* حالة عدم وجود بيانات */}
                {recentTransactions.length === 0 && (
                    <tr>
                      <td colSpan="14" className="px-8 py-16 text-center">
                            <div className="flex flex-col items-center justify-center space-y-6">
                                <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center">
                                    <AlertCircle size={40} className="text-gray-400" />
                                </div>
                                <div className="space-y-3">
                                    <h4 className="text-2xl font-bold text-gray-900">لا توجد معاملات</h4>
                                    <p className="text-lg text-gray-600 max-w-md">
                                        لم يتم العثور على أي معاملات لعرضها. قم باختيار عميل من قسم "معاينة حساب عميل" لإضافة معاملة جديدة.
                                    </p>
                                </div>
                                <button 
                                    className="mt-6 px-6 py-3 bg-blue-600 text-white text-lg font-semibold rounded-lg hover:bg-blue-700 transition-colors"
                                    onClick={() => setShowTransactionForm(true)}
                                >
                                    إضافة معاملة جديدة
                                </button>
                            </div>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    </div>
    {recentTransactions.length > 0 && <PaginationControls />}
</div>




              {/* نافذة إضافة/تعديل معاملة */}
{/* نافذة إضافة/تعديل معاملة */}
{showTransactionForm && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end sm:items-center justify-center z-50 overflow-hidden sm:overflow-y-auto sm:py-8">
    <div className="bg-white rounded-t-3xl sm:rounded-xl p-4 sm:p-6 w-full max-w-3xl max-h-[94vh] overflow-hidden animate-fadeIn">
      <div className="border-b pb-4 mb-6">
        <div className="flex justify-between items-center">
          <h3 className="text-lg sm:text-xl font-bold text-gray-900 flex items-center gap-2 flex-wrap">
            {isEditMode ? (
              <>
                <Edit size={24} className="text-yellow-500" />
                تعديل المعاملة
              </>
            ) : (
              <>
                <Plus size={24} className="text-blue-500" />
                إضافة معاملة جديدة
              </>
            )}
          </h3>
          <button
            onClick={() => {
              setShowTransactionForm(false);
              setIsEditMode(false);
              setEditingTransaction(null);
            }}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={24} />
          </button>
        </div>
        <p className="text-sm text-gray-500 mt-1">
          {isEditMode ? 'قم بتعديل بيانات المعاملة' : 'قم بإدخال بيانات المعاملة الجديدة'}
        </p>
      </div>

      <div className="max-h-[calc(94vh-145px)] sm:max-h-[calc(100vh-200px)] overflow-y-auto px-1 pb-28 sm:pb-0">
        {/* عرض بيانات العميل المحدد بدلاً من مربع البحث */}
        {!isEditMode && selectedClient && (
          <div className="mb-6 p-4 bg-blue-50 rounded-lg">
            <div className="flex justify-between items-start">
              <div>
                <div className="font-medium flex items-center gap-2">
                  <Info size={16} className="text-blue-600" />
                  معلومات العميل:
                </div>
                <div className="text-sm mt-1 flex items-center gap-2">
                  <User size={14} className="text-gray-600" />
                  الاسم: {selectedClient.NameArabic}
                </div>
                <div className="text-sm text-gray-500 flex items-center gap-2">
                  <Clipboard size={14} className="text-gray-600" />
                  الرقم القومي: {selectedClient.NationalID || "-"}
                </div>
                <div className="text-sm text-gray-500 flex items-center gap-2">
                  <FileText size={14} className="text-gray-600" />
                  رقم الجواز: {selectedClient.PassportNumber || "-"}
                </div>
                <div className="text-sm text-gray-500 flex items-center gap-2">
                  <Briefcase size={14} className="text-gray-600" />
                  المندوب: {selectedClient.DelegateName || "-"}
                </div>
                {selectedClient.CompanyName && (
                  <div className="text-sm text-gray-500 flex items-center gap-2">
                    <Building size={14} className="text-gray-600" />
                    الشركة: {selectedClient.CompanyName}
                  </div>
                )}
                {formatPhoneNumber(selectedClient.PhoneNumbers) !== '-' && (
                  <div className="text-sm text-gray-500 flex items-center gap-2">
                    <Phone size={14} className="text-gray-600" />
                    رقم الهاتف: {formatPhoneNumber(selectedClient.PhoneNumbers)}
                  </div>
                )}

                <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-2">
                  <div className="rounded-lg border border-gray-200 bg-white px-3 py-2">
                    <div className="text-xs font-bold text-gray-600 flex items-center gap-1 mb-1">
                      <Building size={13} className="text-gray-500" />
                      الشركات السابقة
                    </div>
                    {getPreviousCompanyList(selectedClient).length > 0 ? (
                      <div className="flex flex-wrap gap-1">
                        {getPreviousCompanyList(selectedClient).map((company, idx) => (
                          <span key={idx} className="text-xs bg-gray-100 text-gray-700 px-2 py-0.5 rounded-full border">
                            {company}
                          </span>
                        ))}
                      </div>
                    ) : (
                      <div className="text-xs text-gray-400">لا توجد شركات سابقة مسجلة</div>
                    )}
                  </div>

                  <div className={`rounded-lg border px-3 py-2 ${hasClientTraveled(selectedClient) ? 'border-green-200 bg-green-50' : 'border-amber-200 bg-amber-50'}`}>
                    <div className="text-xs font-bold text-gray-700 flex items-center gap-1 mb-1">
                      <Calendar size={13} className={hasClientTraveled(selectedClient) ? 'text-green-600' : 'text-amber-600'} />
                      حالة السفر
                    </div>
                    {hasClientTraveled(selectedClient) ? (
                      <div className="text-xs text-green-700 font-bold">مسافر - تاريخ السفر: {formatDisplayDate(selectedClient.TravelDate)}</div>
                    ) : (
                      <div className="text-xs text-amber-700 font-bold">غير مسافر - لا يوجد تاريخ سفر مسجل</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* إذا لم يكن هناك عميل محدد، أظهر رسالة */}
        {!isEditMode && !selectedClient && (
          <div className="mb-6 p-4 bg-yellow-50 rounded-lg text-center">
            <p className="text-yellow-700">
              العميل محدد مسبقاً من صفحة معاينة الحساب
            </p>
          </div>
        )}

        <form onSubmit={isEditMode ? handleEditTransaction : handleAddTransaction}>
          <div className="space-y-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="relative">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  نوع المعاملة *
                </label>
                <div className="relative">
                  <select
                    value={transactionForm.TransactionType}
                    onChange={(e) => setTransactionForm(prev => ({
                      ...prev,
                      TransactionType: e.target.value
                    }))}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2.5 pr-10
                             focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    required
                  >
                    <option value="إيداع">إيداع</option>
                    <option value="سحب">سحب</option>
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    {transactionForm.TransactionType === 'إيداع' ? (
                      <TrendingUp size={18} className="text-green-500" />
                    ) : (
                      <TrendingDown size={18} className="text-red-500" />
                    )}
                  </div>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  المبلغ *
                </label>
                <div className="relative">
                  <input
                    type="number"
                    step="0.01"
                    value={transactionForm.Amount}
                    onChange={(e) => setTransactionForm(prev => ({
                      ...prev,
                      Amount: e.target.value ? parseFloat(e.target.value) : ''
                    }))}
                    className={`w-full border border-gray-300 rounded-lg px-3 py-2.5 pl-16
                            focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                            ${transactionForm.TransactionType === 'إيداع' ? 'text-green-600' : 'text-red-600'}`}
                    required
                    min="0"
                  />
                  <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 flex items-center">
                    <DollarSign size={16} className="mr-1" />
                    ج.م
                  </span>
                </div>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1 flex items-center gap-1">
                <Calendar size={16} />
                تاريخ ووقت المعاملة
              </label>
              <input
                type="datetime-local"
                value={transactionForm.TransactionDate}
                onChange={(e) => setTransactionForm(prev => ({
                  ...prev,
                  TransactionDate: e.target.value
                }))}
                className="w-full border border-gray-300 rounded-lg px-3 py-2.5
                         focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                ملاحظات
              </label>
              <textarea
                value={transactionForm.Notes}
                onChange={(e) => setTransactionForm(prev => ({
                  ...prev,
                  Notes: e.target.value
                }))}
                className="w-full border border-gray-300 rounded-lg px-3 py-2.5 h-24 
                         resize-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="أضف أي ملاحظات إضافية هنا..."
              />
            </div>

                {/* قسم اختيار طريقة الدفع */}
<div className="mb-4">
  <label className="block text-sm font-medium text-gray-700 mb-1">
    طريقة الدفع* (اختر الحساب البنكي)
  </label>
  {!selectedPaymentMethod && (
    <div className="mb-3 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
      <p className="text-yellow-800 text-sm font-medium">
        ⚠️ يجب اختيار حساب بنكي لإتمام المعاملة
      </p>
    </div>
  )}
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    {/* الحسابات البنكية فقط */}
    {paymentMethods.map(method => (
      <div 
        key={`bank-${method.id}`}
        onClick={() => setSelectedPaymentMethod(method)}
        className={`border-2 rounded-lg p-4 flex justify-between items-center cursor-pointer transition-all
        ${selectedPaymentMethod?.id === method.id ? 'border-blue-500 bg-blue-50 shadow-md' : 'border-gray-300 hover:bg-gray-50 hover:border-gray-400'}`}
      >
        <div className="flex items-center">
          <div className={`w-10 h-10 rounded-full flex items-center justify-center mr-3 
            ${selectedPaymentMethod?.id === method.id ? 'bg-blue-100 text-blue-600' : 'bg-gray-100 text-gray-500'}`}>
            <BankIcon size={20} />
          </div>
          <div>
            <p className="font-medium">{method.Name}</p>
            <p className="text-xs text-gray-500">رقم الحساب: {method.AccountNumber || '-'}</p>
            <p className="text-sm text-gray-500">الرصيد: {method.Balance?.toLocaleString() || 0} ج.م</p>
          </div>
        </div>
        {selectedPaymentMethod?.id === method.id && (
          <div className="bg-blue-500 text-white p-1 rounded-full">
            <Check size={16} />
          </div>
        )}
      </div>
    ))}

    {paymentMethods.length === 0 && (
      <div className="col-span-full bg-red-50 p-4 rounded-lg border border-red-200 text-red-800">
        <div className="flex items-center">
          <AlertCircle size={16} className="mr-2" />
          <p className="font-medium">لا توجد حسابات بنكية متاحة!</p>
        </div>
        <p className="text-sm mt-1">يرجى إضافة حساب بنكي أولاً من صفحة إدارة البنوك لتتمكن من إجراء المعاملات.</p>
      </div>
    )}
    {paymentMethods.length > 0 && !selectedPaymentMethod && (
      <div className="col-span-full bg-blue-50 p-4 rounded-lg border border-blue-200 text-blue-800">
        <div className="flex items-center">
          <Info size={16} className="mr-2" />
          <p className="font-medium">انقر على أحد الحسابات البنكية أعلاه لاختياره</p>
        </div>
      </div>
    )}
  </div>
</div>
          </div>

          <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-3 mt-6 sm:mt-8 pt-4 border-t sticky bottom-0 bg-white pb-2">
          <button
    type="button"
    onClick={() => {
        // مسح جميع البيانات عند الإغلاق
        setShowTransactionForm(false);
        setIsEditMode(false);
        setEditingTransaction(null);
        setSelectedPaymentMethod(null);
        setSelectedClient(null);
        
        // إعادة تعيين نموذج المعاملة بالكامل
        setTransactionForm({
            PassportID: '',
            TransactionType: 'إيداع',
            Amount: '',
            Notes: '',
            TransactionDate: new Date().toISOString().slice(0, 16),
            PaymentMethodID: null,
            PaymentMethodType: null
        });
    }}
    className="px-6 py-2.5 border border-gray-300 rounded-lg 
            text-gray-700 hover:bg-gray-50 transition-colors"
    disabled={loading}
>
    إلغاء
</button>
            <button
              type="submit"
              className={`px-6 py-2.5 text-white rounded-lg 
                      transition-colors flex items-center gap-2
                      ${isEditMode ? 'bg-yellow-600 hover:bg-yellow-700' : 'bg-blue-600 hover:bg-blue-700'}`}
              disabled={loading}
            >
              {loading ? (
                <>
                  <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></div>
                  <span>جاري الحفظ...</span>
                </>
              ) : (
                <>
                  <Save size={18} />
                  {isEditMode ? 'حفظ التعديلات' : 'حفظ المعاملة'}
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
)}

             {/* نافذة معاينة الحساب */}
             {showAccountDetails && selectedClient && (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end sm:items-center justify-center z-50 overflow-hidden sm:overflow-y-auto sm:py-8">
                      <div className="bg-white rounded-t-3xl sm:rounded-xl p-4 sm:p-6 w-full max-w-6xl h-[94vh] max-h-[94vh] overflow-hidden animate-fadeIn flex flex-col">
{/* رأس نافذة معاينة الحساب */}
<div className="flex justify-between items-start mb-4 sm:mb-6 gap-3 sticky top-0 bg-white z-10 pb-3 border-b sm:border-b-0">
    <div>
        <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2">
            <User size={22} className="text-blue-600" />
            تفاصيل حساب: {selectedClient.NameArabic}
            {/* مؤشر الأرشفة في العنوان */}
            {selectedClient.ClientIsActive === false && (
                <div className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800 border border-yellow-200 mr-3">
                    <AlertCircle size={14} className="ml-1" />
                    عميل مؤرشف
                </div>
            )}
        </h3>
        <div className="mt-1 text-sm text-gray-500 space-y-1">
            <div className="flex items-center gap-2">
                <Clipboard size={16} className="text-gray-400" />
                <p>الرقم القومي: {selectedClient.NationalID || "-"}</p>
            </div>

            <div className="flex items-center gap-2">
                <Briefcase size={16} className="text-gray-400" />
                <p>المندوب: {selectedClient.DelegateName || "-"}</p>
            </div>
            <div className="flex items-center gap-2">
                <Phone size={16} className="text-gray-400" />
                <p>رقم الهاتف: {formatPhoneNumber(selectedClient.PhoneNumbers)}</p>
                {formatPhoneNumber(selectedClient.PhoneNumbers) !== '-' && (
                    <button 
                        onClick={() => copyToClipboard(formatPhoneNumber(selectedClient.PhoneNumbers))}
                        className="text-blue-500 hover:text-blue-700 p-1 rounded-full"
                        title="نسخ رقم الهاتف"
                    >
                        <Copy size={14} />
                    </button>
                )}
            </div>
            {selectedClient.CompanyName && (
                <div className="flex items-center gap-2">
                    <Building size={16} className="text-gray-400" />
                    <p>الشركة: {selectedClient.CompanyName}</p>
                </div>
            )}
            <div className="flex items-center gap-2">
                <Calendar size={16} className={hasClientTraveled(selectedClient) ? 'text-green-500' : 'text-amber-500'} />
                <p className={hasClientTraveled(selectedClient) ? 'text-green-700 font-medium' : 'text-amber-700 font-medium'}>
                    {hasClientTraveled(selectedClient)
                        ? `مسافر - تاريخ السفر: ${formatDisplayDate(selectedClient.TravelDate)}`
                        : 'غير مسافر - لا يوجد تاريخ سفر مسجل'}
                </p>
            </div>
            {/* الشركات السابقة */}
            {getPreviousCompanyList(selectedClient).length > 0 && (
                <div className="mt-1">
                    <div className="flex items-start gap-2">
                        <Building size={16} className="text-gray-300 mt-0.5 flex-shrink-0" />
                        <div>
                            <p className="text-xs text-gray-400 font-medium mb-1">الشركات السابقة:</p>
                            <div className="flex flex-wrap gap-1">
                                {getPreviousCompanyList(selectedClient).map((company, idx) => (
                                    <span key={idx} className="text-xs bg-gray-100 text-gray-500 px-2 py-0.5 rounded-full border border-gray-200">
                                        {company}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    </div>
    <button
        onClick={() => setShowAccountDetails(false)}
        className="text-gray-400 hover:text-gray-600 transition-colors"
    >
        <X size={24} />
    </button>
</div>

<div className="flex-1 overflow-y-auto pr-1 pb-4">
                            {/* ملخص الحساب */}
                            <AccountSummary client={selectedClient} />

                        {/* أزرار الإجراءات */}
                        <div className="grid grid-cols-2 sm:flex sm:justify-end mb-4 gap-2 sm:gap-3">
                         
                        {canDo('إضافة إيداع') && (
                        <button
                            onClick={() => {
                                resetAllFormData();
                                setTimeout(() => {
                                    setSelectedClient(selectedClient);
                                    setTransactionForm(prev => ({
                                        ...prev,
                                        PassportID: selectedClient.PassportID,
                                        TransactionType: 'إيداع'
                                    }));
                                    setShowAccountDetails(false);
                                    setShowTransactionForm(true);
                                }, 100);
                            }}
                            disabled={selectedClient.ClientIsActive === false}
                            className={`px-4 py-2 rounded-lg flex items-center gap-2 transition ${
                                selectedClient.ClientIsActive === false
                                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                    : 'bg-green-600 text-white hover:bg-green-700'
                            }`}
                        >
                            <Plus size={18} />
                            إضافة إيداع
                        </button>
                        )}

                        {canDo('إضافة سحب') && (
                        <button
                            onClick={() => {
                                resetAllFormData();
                                setTimeout(() => {
                                    setSelectedClient(selectedClient);
                                    setTransactionForm(prev => ({
                                        ...prev,
                                        PassportID: selectedClient.PassportID,
                                        TransactionType: 'سحب'
                                    }));
                                    setShowAccountDetails(false);
                                    setShowTransactionForm(true);
                                }, 100);
                            }}
                            disabled={selectedClient.ClientIsActive === false}
                            className={`px-4 py-2 rounded-lg flex items-center gap-2 transition ${
                                selectedClient.ClientIsActive === false
                                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                    : 'bg-red-600 text-white hover:bg-red-700'
                            }`}
                        >
                            <TrendingDown size={18} />
                            إضافة سحب
                        </button>
                        )}

                            {canDo('تعديل المبلغ المطلوب') && (
                            <button
                                onClick={() => {
                                    setPaymentForm({
                                    RequiredPayment: selectedClient.RequiredPayment !== undefined ? selectedClient.RequiredPayment.toString() : '',
                                    Notes: selectedClient.Notes || ''
                                    });
                                    setShowPaymentForm(true);
                                }}
                                className="bg-yellow-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-yellow-700 transition"
                                >
                                <DollarSign size={18} />
                                تعديل المبلغ المطلوب
                            </button>
                            )}


                            <button
                                onClick={printAccountDetails}
                                className="bg-purple-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-purple-700 transition">
                                <Printer size={18} />
                                طباعة
                            </button>
                        


                        </div>




                                {/* بدلاً من ذلك، نضع عنوان بسيط */}
                                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4 gap-2">
                                    <h3 className="text-lg font-semibold flex items-center gap-2">
                                        <FileText size={18} className="text-blue-600" />
                                        سجل المعاملات
                                    </h3>
                                    <span className="text-xs bg-gray-100 text-gray-700 px-3 py-1 rounded-full">
                                        إجمالي المعاملات: {selectedClient.transactions?.length || 0}
                                    </span>
                                </div>


                          {/* جدول المعاملات */}
                          <div className="bg-white border rounded-xl overflow-hidden shadow-sm">

                            <div className="md:hidden max-h-[52vh] overflow-y-auto p-3 space-y-3 bg-gray-50">
                                {selectedClient.transactions && selectedClient.transactions.length > 0 ? (
                                    selectedClient.transactions.map((transaction) => (
                                        <MobileClientHistoryCard key={transaction.TransactionID} transaction={transaction} />
                                    ))
                                ) : (
                                    <div className="text-center p-8 text-gray-500">
                                        <AlertCircle size={36} className="text-gray-300 mx-auto mb-2" />
                                        <p>لا توجد معاملات لهذا العميل</p>
                                    </div>
                                )}
                            </div>

                            <div className="hidden md:block max-h-[52vh] overflow-auto">
                                <table className="min-w-[950px] w-full">
                                    <thead className="bg-gray-50 sticky top-0 z-10">
                                    <tr>
                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500">التاريخ</th>
                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500">نوع المعاملة</th>
                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500">المبلغ</th>
                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500">الرصيد</th>
                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500">ملاحظات</th>
                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500">طريقة الدفع</th>
                                    </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200">
                                    {selectedClient.transactions
                                            .map((transaction) => (
                                            <tr key={transaction.TransactionID} className={`hover:bg-gray-50 ${
                                                !transaction.IsActive ? 'bg-gray-50 opacity-75' : ''
                                            }`}>
                                            <td className="px-6 py-4 text-sm text-gray-900">
                                            {new Date(transaction.TransactionDate).toLocaleDateString('ar-EG')}
                                            </td>
                                            <td className="px-6 py-4">
                                            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
                                                ${transaction.TransactionType === 'إيداع' ? 
                                                'bg-green-100 text-green-800' : 
                                                'bg-red-100 text-red-800'}`}>
                                                {transaction.TransactionType === 'إيداع' ? (
                                                <TrendingUp size={14} className="mr-1" />
                                                ) : (
                                                <TrendingDown size={14} className="mr-1" />
                                                )}
                                                {transaction.TransactionType}
                                            </span>
                                            </td>
                                            <td className="px-6 py-4 text-sm font-medium">
                                            <span className={transaction.TransactionType === 'إيداع' ? 
                                                'text-green-600' : 'text-red-600'}>
                                                {transaction.Amount?.toLocaleString()} ج.م
                                            </span>
                                            </td>
                                            <td className="px-6 py-4 text-sm text-gray-900">
                                                {transaction.IsActive === false
                                                ? "غير محتسب"
                                                : (transaction.Balance !== null && transaction.Balance !== undefined)
                                                    ? `${transaction.Balance.toLocaleString()} ج.م`
                                                    : "0 ج.م"
                                                }
                                            </td>
                                            <td className="px-6 py-4 text-sm text-gray-500">
                                            {transaction.Notes || '-'}
                                            </td>
                                      <td className="px-6 py-4 text-sm text-gray-500">
                                        {transaction.PaymentMethodType === 'bank' ? (
                                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                            <BankIcon size={12} className="mr-1" />
                                            {transaction.PaymentMethodName || 'حساب بنكي'}
                                            </span>
                                        ) : (
                                            '-'
                                        )}
                                        </td>
                                        </tr>
                                    ))}
                                    {(!selectedClient.transactions || selectedClient.transactions.length === 0) && (
                                        <tr>
                                        <td colSpan="6" className="px-6 py-8 text-center text-gray-500">
                                            <div className="flex flex-col items-center py-6">
                                            <AlertCircle size={40} className="text-gray-300 mb-2" />
                                            <p>لا توجد معاملات لهذا العميل</p>
                                       
                                            </div>
                                        </td>
                                        </tr>
                                    )}
                                    </tbody>
                                </table>
                                </div>
                                </div>

                                <div className={`mt-4 rounded-xl border-2 p-4 ${hasClientTraveled(selectedClient) ? 'bg-green-50 border-green-200' : 'bg-amber-50 border-amber-200'}`}>
                                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                                        <div className="flex items-start gap-3">
                                            {hasClientTraveled(selectedClient) ? (
                                                <CheckCircle size={24} className="text-green-600 mt-0.5" />
                                            ) : (
                                                <AlertCircle size={24} className="text-amber-600 mt-0.5" />
                                            )}
                                            <div>
                                                <h4 className={`font-bold ${hasClientTraveled(selectedClient) ? 'text-green-800' : 'text-amber-800'}`}>
                                                    تحقق حالة السفر
                                                </h4>
                                                <p className={`text-sm mt-1 ${hasClientTraveled(selectedClient) ? 'text-green-700' : 'text-amber-700'}`}>
                                                    {hasClientTraveled(selectedClient)
                                                        ? `هذا العميل مسجل له تاريخ سفر: ${formatDisplayDate(selectedClient.TravelDate)}`
                                                        : 'هذا العميل لا يوجد له تاريخ سفر مسجل، لذلك يعتبر غير مسافر في الحسابات.'}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="text-xs bg-white/80 rounded-lg px-3 py-2 border">
                                            مصدر التحقق: حقل تاريخ السفر في ملف الجواز
                                        </div>
                                    </div>
                                </div>
                      </div>
                      </div>
                  </div>
              )}

                        {/* نافذة تعديل المبلغ المطلوب */}
                        {showPaymentForm && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end sm:items-center justify-center z-50">
                            <div className="bg-white rounded-t-3xl sm:rounded-lg p-4 sm:p-6 w-full max-w-md mx-0 sm:mx-4 max-h-[92vh] overflow-y-auto">
                            <div className="flex justify-between items-center mb-4">
                                <h2 className="text-xl font-bold flex items-center gap-2">
                                <DollarSign size={20} className="text-blue-600" />
                                تحديد المبلغ المطلوب للعميل
                                </h2>
                                <button
                                onClick={() => {
                                    setShowPaymentForm(false);
                                    resetPaymentForm();
                                }}
                                className="text-gray-500 hover:text-gray-700"
                                >
                                <X size={24} />
                                </button>
                            </div>
                            
                            <form className="space-y-4">
                                <div>
                                <label className="block text-sm font-medium mb-1">المبلغ المطلوب (ج.م)</label>
                                    <input
                                        type="number"
                                        value={paymentForm.RequiredPayment}
                                        onChange={(e) => {
                                            // التأكد من أن القيمة المدخلة رقمية صالحة
                                            const value = e.target.value;
                                            if (value === '' || !isNaN(parseFloat(value))) {
                                                setPaymentForm({...paymentForm, RequiredPayment: value});
                                            }
                                        }}
                                        className="w-full border rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                                        required
                                        placeholder="أدخل المبلغ المطلوب"
                                        step="0.01"
                                        min="0"
                                    />
                                </div>
                                
                                <div>
                                <label className="block text-sm font-medium mb-1">ملاحظات</label>
                                <textarea
                                    value={paymentForm.Notes}
                                    onChange={(e) => setPaymentForm({...paymentForm, Notes: e.target.value})}
                                    className="w-full border rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                                    rows="3"
                                    placeholder="إضافة ملاحظات (اختياري)"
                                ></textarea>
                                </div>

                                <div className="flex flex-col sm:flex-row sm:justify-between gap-2 mt-4">
                                    <button
                                        type="button"
                                        onClick={async () => {
                                            // جلب سجل التعديلات عند النقر على الزر
                                            const history = await fetchPaymentHistory(selectedClient.PassportID);
                                            setPaymentHistory(history);
                                            setShowPaymentHistory(true);
                                        }}
                                        className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
                                        disabled={isProcessing}
                                    >
                                        <FileText size={16} />
                                        عرض سجل التعديلات
                                    </button>
                                    
                                    <div className="flex gap-2">
                                        <button
                                            type="button"
                                            onClick={saveClientPayment}
                                            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
                                        >
                                            <Save size={16} />
                                            حفظ
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => {
                                            setShowPaymentForm(false);
                                            resetPaymentForm();
                                            }}
                                            className="border border-gray-300 hover:bg-gray-50 px-4 py-2 rounded-lg transition-colors"
                                        >
                                            إلغاء
                                        </button>
                                    </div>
                                </div>
                            </form>
                            </div>
                        </div>
                        )}

                        {/* نافذة سجل تعديلات المبلغ المطلوب */}
                        {showPaymentHistory && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end sm:items-center justify-center z-50">
                            <div className="bg-white rounded-t-3xl sm:rounded-lg p-4 sm:p-6 w-full max-w-3xl mx-0 sm:mx-4 max-h-[94vh] overflow-hidden">
                                <div className="flex justify-between items-center mb-4">
                                    <h2 className="text-xl font-bold flex items-center gap-2">
                                        <FileText size={20} className="text-purple-600" />
                                        سجل تعديلات المبلغ المطلوب
                                    </h2>
                                    <button
                                        onClick={() => setShowPaymentHistory(false)}
                                        className="text-gray-500 hover:text-gray-700"
                                    >
                                        <X size={24} />
                                    </button>
                                </div>
                                
                                <div className="max-h-[72vh] overflow-x-auto overflow-y-auto">
                                    {paymentHistory.length === 0 ? (
                                        <div className="text-center p-8 text-gray-500">
                                            <div className="flex flex-col items-center justify-center">
                                                <AlertCircle size={40} className="text-gray-300 mb-2" />
                                                <p>لا يوجد سجل تعديلات للمبلغ المطلوب</p>
                                            </div>
                                        </div>
                                    ) : (
                                        <table className="min-w-full bg-white border rounded-lg overflow-hidden">
                                            <thead className="bg-gray-50">
                                                <tr>
                                                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500">التاريخ</th>
                                                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500">المبلغ القديم</th>
                                                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500">المبلغ الجديد</th>
                                                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500">الملاحظات</th>
                                                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500">بواسطة</th>
                                                    <th className="px-6 py-3 text-center text-xs font-medium text-gray-500">الإجراءات</th>
                                                                                                    </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-200">
                                                {paymentHistory.map((record) => (
                                                    <tr key={record.HistoryID} className="hover:bg-gray-50">
                                                        <td className="px-6 py-4 text-sm text-gray-900">
                                                            {new Date(record.CreatedAt).toLocaleDateString('ar-EG', {
                                                                year: 'numeric',
                                                                month: 'long',
                                                                day: 'numeric',
                                                                hour: '2-digit',
                                                                minute: '2-digit'
                                                            })}
                                                        </td>
                                                        <td className="px-6 py-4 text-sm text-gray-500">
                                                            {record.OldAmount?.toLocaleString() || '0'} ج.م
                                                        </td>
                                                        <td className="px-6 py-4 text-sm font-medium text-blue-600">
                                                            {record.NewAmount?.toLocaleString()} ج.م
                                                        </td>
                                                        <td className="px-6 py-4 text-sm text-gray-500">
                                                            {record.Notes || '-'}
                                                        </td>
                                                        <td className="px-6 py-4 text-sm text-gray-500">
                                                            {record.CreatedBy}
                                                        </td>
                                                        <td className="px-6 py-4 text-center">
                                                            <button
                                                                onClick={() => deletePaymentHistoryRecord(record.HistoryID)}
                                                                className="text-red-600 hover:text-red-800 transition-colors"
                                                                title="حذف"
                                                                disabled={isProcessing}
                                                            >
                                                                <Trash2 size={18} />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                                
                                <div className="mt-4 flex justify-end">
                                    <button
                                        onClick={() => setShowPaymentHistory(false)}
                                        className="bg-gray-100 hover:bg-gray-200 text-gray-800 px-4 py-2 rounded-lg transition-colors"
                                    >
                                        إغلاق
                                    </button>
                                </div>
                            </div>
                        </div>
                        )}

              {/* رسالة التحميل */}
              {loading && (
                  <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
                      <div className="bg-white rounded-lg p-8 flex items-center gap-4">
                          <div className="animate-spin rounded-full h-8 w-8 border-4 border-blue-600 border-t-transparent">
                          </div>
                          <span className="text-gray-700">جاري التحميل...</span>
                      </div>
                  </div>
              )}

              {/* رسائل النجاح والخطأ */}
{toast && (
    <div className={`
        fixed bottom-4 right-4 z-50 
        p-4 rounded-lg shadow-lg 
        flex items-center gap-3
        animate-slide-up
        ${toast.type === 'success' ? 'bg-green-100 text-green-800' : 
          toast.type === 'warning' ? 'bg-yellow-100 text-yellow-800' : 
          'bg-red-100 text-red-800'}
    `}>
        {toast.type === 'success' ? <CheckCircle size={20} /> : 
         toast.type === 'warning' ? <AlertCircle size={20} /> : 
         <XCircle size={20} />}
        {toast.message}
        <button 
            onClick={() => setToast(null)} 
            className="ml-3 hover:opacity-75"
        >
            <X size={16} />
        </button>
    </div>
)}


                {showRequiredPaymentManager && (
                  <RequiredPaymentManager
                      isOpen={showRequiredPaymentManager}
                      onClose={() => setShowRequiredPaymentManager(false)}
                      showToast={showToast}
                  />
              )}

                {showDebtManager && (
                    <DebtManager
                        isOpen={showDebtManager}
                        onClose={() => setShowDebtManager(false)}
                        showToast={showToast}
                    />
                )}











          </div>

                {/* أضف CSS الإضافي للرسوم المتحركة */}
                <style dangerouslySetInnerHTML={{
                    __html: `
                    @keyframes fadeIn {
                        from { opacity: 0; transform: translateY(-20px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                    @keyframes slideUp {
                        from { opacity: 0; transform: translateY(20px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                    .animate-fadeIn {
                        animation: fadeIn 0.3s ease-out forwards;
                    }
                    .animate-slide-up {
                        animation: slideUp 0.3s ease-out forwards;
                    }
                    @media (max-width: 768px) {
                        .client-accounts-page input,
                        .client-accounts-page select,
                        .client-accounts-page textarea {
                            font-size: 16px !important;
                            min-height: 44px;
                        }
                        .client-accounts-page button {
                            touch-action: manipulation;
                        }
                        .client-accounts-page table {
                            font-size: 13px;
                        }
                    }
                    `
                }} />





                {/* نافذة التصدير المتقدم */}
{isExportModalOpen && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end sm:items-center justify-center z-50">
    <div className="bg-white w-full max-w-3xl rounded-t-3xl sm:rounded-xl shadow-2xl p-4 sm:p-6 m-0 sm:m-4 max-h-[94vh] sm:max-h-[90vh] overflow-y-auto">
      <h2 className="text-2xl font-bold mb-6 flex items-center">
        <Settings className="text-blue-600 ml-2" />
        خيارات التصدير المتقدمة - حسابات العملاء
      </h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* نوع التصدير */}
        <div>
          <h3 className="text-lg font-medium mb-3">نوع التصدير</h3>
          <div className="space-y-2">
            <label className="flex items-center">
              <input
                type="radio"
                value="excel"
                checked={exportOptions.format === 'excel'}
                onChange={(e) => setExportOptions({...exportOptions, format: e.target.value})}
                className="ml-2"
              />
              <FileSpreadsheet size={18} className="ml-2 text-green-600" />
              ملف Excel متقدم (.xlsx) - مُوصى به
            </label>
            
            <label className="flex items-center">
              <input
                type="radio"
                value="csv"
                checked={exportOptions.format === 'csv'}
                onChange={(e) => setExportOptions({...exportOptions, format: e.target.value})}
                className="ml-2"
              />
              <FileText size={18} className="ml-2 text-blue-600" />
              ملف CSV (.csv)
            </label>
     
            <label className="flex items-center">
              <input
                type="radio"
                value="pdf"
                checked={exportOptions.format === 'pdf'}
                onChange={(e) => setExportOptions({...exportOptions, format: e.target.value})}
                className="ml-2"
              />
              <FileText size={18} className="ml-2 text-red-600" />
              ملف PDF
            </label>
          </div>
        </div>
        
{/* نطاق البيانات */}
<div>
  <h3 className="text-lg font-medium mb-3">نطاق البيانات</h3>
  <div className="space-y-2">
    <label className="flex items-center">
      <input
        type="radio"
        value="current-page"
        checked={exportOptions.dateRange === 'current-page'}
        onChange={(e) => setExportOptions({...exportOptions, dateRange: e.target.value})}
        className="ml-2"
      />
      المعاملات المعروضة في الصفحة الحالية ({getPaginatedTransactions().length} معاملة)
    </label>
    <label className="flex items-center">
      <input
        type="radio"
        value="filtered"
        checked={exportOptions.dateRange === 'filtered'}
        onChange={(e) => setExportOptions({...exportOptions, dateRange: e.target.value})}
        className="ml-2"
      />
      جميع المعاملات المعروضة حالياً ({recentTransactions.length} معاملة)
    </label>
    <label className="flex items-center">
      <input
        type="radio"
        value="all"
        checked={exportOptions.dateRange === 'all'}
        onChange={(e) => setExportOptions({...exportOptions, dateRange: e.target.value})}
        className="ml-2"
      />
      جميع المعاملات في قاعدة البيانات (كامل)
    </label>
    <label className="flex items-center">
      <input
        type="radio"
        value="custom"
        checked={exportOptions.dateRange === 'custom'}
        onChange={(e) => setExportOptions({...exportOptions, dateRange: e.target.value})}
        className="ml-2"
      />
      فترة مخصصة
    </label>
  </div>
          
          {/* التاريخ المخصص */}
          {exportOptions.dateRange === 'custom' && (
            <div className="mt-3 space-y-2">
              <div>
                <label className="block text-sm text-gray-600 mb-1">من تاريخ</label>
                <input
                  type="date"
                  value={exportOptions.customStartDate}
                  onChange={(e) => setExportOptions({...exportOptions, customStartDate: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">إلى تاريخ</label>
                <input
                  type="date"
                  value={exportOptions.customEndDate}
                  onChange={(e) => setExportOptions({...exportOptions, customEndDate: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
          )}
        </div>
        
        {/* فلتر أنواع المعاملات */}
        <div>
          <h3 className="text-lg font-medium mb-3">أنواع المعاملات</h3>
          <div className="space-y-2">
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={exportOptions.selectedTypes.includes('إيداع')}
                onChange={(e) => {
                  if (e.target.checked) {
                    setExportOptions({
                      ...exportOptions,
                      selectedTypes: [...exportOptions.selectedTypes, 'إيداع']
                    });
                  } else {
                    setExportOptions({
                      ...exportOptions,
                      selectedTypes: exportOptions.selectedTypes.filter(t => t !== 'إيداع')
                    });
                  }
                }}
                className="ml-2"
              />
              <TrendingUp size={16} className="ml-1 text-green-600" />
              الإيداعات
            </label>
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={exportOptions.selectedTypes.includes('سحب')}
                onChange={(e) => {
                  if (e.target.checked) {
                    setExportOptions({
                      ...exportOptions,
                      selectedTypes: [...exportOptions.selectedTypes, 'سحب']
                    });
                  } else {
                    setExportOptions({
                      ...exportOptions,
                      selectedTypes: exportOptions.selectedTypes.filter(t => t !== 'سحب')
                    });
                  }
                }}
                className="ml-2"
              />
              <TrendingDown size={16} className="ml-1 text-red-600" />
              السحوبات
            </label>
          </div>
        </div>
        
        {/* خيارات إضافية */}
        <div>
          <h3 className="text-lg font-medium mb-3">خيارات إضافية</h3>
          <div className="space-y-2">
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={exportOptions.includeSummary}
                onChange={(e) => setExportOptions({...exportOptions, includeSummary: e.target.checked})}
                className="ml-2"
              />
              تضمين الملخص المالي
            </label>
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={exportOptions.includeFilters}
                onChange={(e) => setExportOptions({...exportOptions, includeFilters: e.target.checked})}
                className="ml-2"
              />
              تضمين معلومات الفلاتر
            </label>
          </div>
        </div>
      </div>
      
      {/* معاينة البيانات */}
      <div className="mt-6 p-4 bg-gray-50 rounded-lg">
        <h4 className="font-medium text-gray-700 mb-2">معاينة التصدير:</h4>
        <div className="text-sm text-gray-600">
          <p>عدد المعاملات: {getExportData().length}</p>
          <p>النوع: {exportOptions.format === 'excel' ? 'Excel متقدم' : exportOptions.format === 'csv' ? 'CSV بسيط' : 'PDF'}</p>
          <p>الفترة: {
  exportOptions.dateRange === 'current-page' ? 'الصفحة الحالية' :
  exportOptions.dateRange === 'all' ? 'جميع الفترات' :
  exportOptions.dateRange === 'filtered' ? 'البيانات المعروضة' :
  'فترة مخصصة'
}</p>
        </div>
      </div>
      
      <div className="flex justify-end gap-3 mt-6">
        <button
          onClick={() => setIsExportModalOpen(false)}
          className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
        >
          إلغاء
        </button>
        <button
          onClick={executeExport}
          disabled={exportOptions.selectedTypes.length === 0}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2 disabled:opacity-50"
        >
          <Download size={18} />
          تصدير الآن
        </button>
      </div>
    </div>
  </div>
)}






      </div>
  );
};



const DebtManager = ({ isOpen, onClose, showToast }) => {
    const [activeTab, setActiveTab] = useState('list');
    const [loading, setLoading] = useState(false);
    const [debts, setDebts] = useState([]);
    const [summary, setSummary] = useState({});
    const [pagination, setPagination] = useState({ page: 1, totalPages: 1, total: 0 });
    const [filters, setFilters] = useState({ search: '', status: 'open', currency: 'all', dueType: 'all', settlement: 'all', companyId: 'all', delegateId: 'all' });
    const [clientSearch, setClientSearch] = useState('');
    const [clientResults, setClientResults] = useState([]);
    const [selectedTrip, setSelectedTrip] = useState(null);
    const [personData, setPersonData] = useState(null);
    const [banks, setBanks] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [delegates, setDelegates] = useState([]);
    const [paymentDebt, setPaymentDebt] = useState(null);
    const [administrativeDebt, setAdministrativeDebt] = useState(null);
    const [editDebt, setEditDebt] = useState(null);
    const [settlementPayment, setSettlementPayment] = useState(null);
    const [debtForm, setDebtForm] = useState({
        amount: '', currency: 'EGP', reason: '', dueType: 'بعد السفر', dueDate: '',
        collectionLocation: 'مصر', responsibleType: '', responsibleId: '', notes: ''
    });
    const [paymentForm, setPaymentForm] = useState({
        amount: '', currency: 'EGP', exchangeRate: '', paymentMethodType: 'bank',
        paymentMethodId: '', receivedByLabel: '', paymentDate: new Date().toISOString().slice(0, 10),
        referenceNumber: '', notes: ''
    });
    const [administrativeForm, setAdministrativeForm] = useState({
        amount: '', settlementDate: new Date().toISOString().slice(0, 10), notes: ''
    });
    const [editDebtForm, setEditDebtForm] = useState({
        amount: '', reason: '', dueType: 'بعد السفر', dueDate: '', collectionLocation: 'مصر', notes: ''
    });
    const [settlementForm, setSettlementForm] = useState({
        paymentMethodType: 'treasury', paymentMethodId: '', settlementDate: new Date().toISOString().slice(0, 10), notes: ''
    });

    const getCurrentUser = () => {
        try {
            return JSON.parse(localStorage.getItem('user'))?.Username || 'System';
        } catch (_) {
            return 'System';
        }
    };

    const currencyText = (currency) => currency === 'SAR' ? 'ر.س' : 'ج.م';
    const formatAmount = (value, currency) => `${Number(value || 0).toLocaleString()} ${currencyText(currency)}`;

    const loadLookups = async () => {
        const requests = [
            fetch(`${API_BASE}/companies`).then(r => r.ok ? r.json() : []).catch(() => []),
            fetch(`${config.PASSPORT_API_URL}/api/delegates`).then(r => r.ok ? r.json() : []).catch(() => []),
            axios.get(`${config.BANKS_API_URL}/api/banks/payment-methods`).then(r => r.data).catch(() => null)
        ];
        const [companyData, delegateData, bankData] = await Promise.all(requests);
        setCompanies(Array.isArray(companyData) ? companyData : companyData?.data || []);
        setDelegates(Array.isArray(delegateData) ? delegateData : delegateData?.delegates || delegateData?.data || []);
        setBanks((bankData?.paymentMethods || []).filter(item => item.type === 'bank'));
    };

    const loadDebts = async (page = 1) => {
        try {
            setLoading(true);
            const params = new URLSearchParams({ ...filters, page: String(page), limit: '50' });
            const response = await fetch(`${API_BASE}/debts?${params.toString()}`);
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'تعذر تحميل المديونيات');
            setDebts(data.debts || []);
            setSummary(data.summary || {});
            setPagination(data.pagination || { page, totalPages: 1, total: 0 });
        } catch (error) {
            showToast(error.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!isOpen) return;
        let cancelled = false;
        const initialize = async () => {
            try {
                setLoading(true);
                await loadLookups();
                let totalCreated = 0;
                let remaining = 0;
                for (let batch = 0; batch < 20; batch++) {
                    const migrationResponse = await fetch(`${API_BASE}/debts/migrate-legacy`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ batchSize: 100, MigratedBy: getCurrentUser() })
                    });
                    if (!migrationResponse.ok) break;
                    const migrationData = await migrationResponse.json();
                    totalCreated += Number(migrationData.created || 0);
                    remaining = Number(migrationData.remaining || 0);
                    if (remaining <= 0 || Number(migrationData.processed || 0) === 0) break;
                }
                if (!cancelled && totalCreated > 0) {
                    showToast(`تم ترحيل ${totalCreated} مبلغ قديم إلى نظام المديونيات بدون تكرار`, 'success');
                }
                if (!cancelled && remaining > 0) {
                    showToast(`تم ترحيل جزء من المبالغ القديمة، والمتبقي ${remaining} سجل سيُستكمل عند فتح الصفحة مرة أخرى`, 'warning');
                }
            } catch (migrationError) {
                console.warn('تعذر ترحيل المبالغ القديمة تلقائيًا:', migrationError);
            } finally {
                if (!cancelled) {
                    await loadDebts(1);
                    setLoading(false);
                }
            }
        };
        initialize();
        return () => { cancelled = true; };
    }, [isOpen]);

    if (!isOpen) return null;

    const searchForClients = async () => {
        if (clientSearch.trim().length < 2) {
            showToast('اكتب حرفين على الأقل للبحث', 'warning');
            return;
        }
        try {
            setLoading(true);
            const response = await fetch(`${API_BASE}/debts/clients/search?search=${encodeURIComponent(clientSearch.trim())}`);
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'فشل البحث');
            setClientResults(data || []);
        } catch (error) {
            showToast(error.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    const resetDebtForm = () => {
        setSelectedTrip(null);
        setClientSearch('');
        setClientResults([]);
        setDebtForm({
            amount: '', currency: 'EGP', reason: '', dueType: 'بعد السفر', dueDate: '',
            collectionLocation: 'مصر', responsibleType: '', responsibleId: '', notes: ''
        });
    };

    const createDebt = async () => {
        if (!selectedTrip) return showToast('اختر السفرة التي نشأت عنها المديونية', 'error');
        if (!debtForm.amount || Number(debtForm.amount) <= 0) return showToast('أدخل مبلغًا صحيحًا', 'error');
        if (!debtForm.reason.trim()) return showToast('اكتب سبب المديونية', 'error');
        try {
            setLoading(true);
            const response = await fetch(`${API_BASE}/debts`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    PassportID: selectedTrip.PassportID,
                    Amount: Number(debtForm.amount),
                    CurrencyCode: 'EGP',
                    Reason: debtForm.reason,
                    DueType: debtForm.dueType,
                    DueDate: debtForm.dueDate || null,
                    CollectionLocation: debtForm.collectionLocation || null,
                    ResponsibleType: debtForm.responsibleType || null,
                    ResponsibleID: debtForm.responsibleId || null,
                    Notes: debtForm.notes || null,
                    CreatedBy: getCurrentUser()
                })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'فشل تسجيل المديونية');
            showToast(`${data.message} - ${data.debtNumber}`, 'success');
            resetDebtForm();
            setActiveTab('list');
            await loadDebts(1);
        } catch (error) {
            showToast(error.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    const loadPerson = async (passportId) => {
        try {
            setLoading(true);
            const response = await fetch(`${API_BASE}/debts/person-summary/${passportId}`);
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'تعذر فتح الحساب الدائم');
            setPersonData(data);
            setActiveTab('person');
        } catch (error) {
            showToast(error.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    const beginEditDebt = (debt) => {
        setEditDebt(debt);
        setEditDebtForm({
            amount: String(Number(debt.OriginalAmount || 0)),
            reason: debt.Reason || '',
            dueType: debt.DueType || 'بعد السفر',
            dueDate: debt.DueDate ? new Date(debt.DueDate).toISOString().slice(0, 10) : '',
            collectionLocation: debt.CollectionLocation || 'مصر',
            notes: debt.Notes || ''
        });
    };

    const submitEditDebt = async () => {
        if (!editDebt) return;
        const amount = Number(editDebtForm.amount);
        if (!Number.isFinite(amount) || amount <= 0) return showToast('أدخل مبلغ مديونية صحيحًا', 'error');
        if (!editDebtForm.reason.trim()) return showToast('اكتب سبب المديونية', 'error');
        try {
            setLoading(true);
            const response = await fetch(`${API_BASE}/debts/${editDebt.DebtID}/edit`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    Amount: amount,
                    Reason: editDebtForm.reason.trim(),
                    DueType: editDebtForm.dueType,
                    DueDate: editDebtForm.dueDate || null,
                    CollectionLocation: editDebtForm.collectionLocation || null,
                    Notes: editDebtForm.notes || null,
                    UpdatedBy: getCurrentUser()
                })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'تعذر تعديل المديونية');
            showToast(data.message, 'success');
            const passportId = editDebt.PassportID;
            setEditDebt(null);
            await loadDebts(pagination.page || 1);
            if (activeTab === 'person' && passportId) await loadPerson(passportId);
        } catch (error) {
            showToast(error.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    const deleteDebt = async (debt) => {
        const hasMovements = Number(debt.PaidAmount || 0) > 0 || Number(debt.AdministrativeSettledAmount || 0) > 0;
        if (hasMovements) {
            return showToast('هذه المديونية عليها دفعات أو تسويات. ألغِ الحركات المرتبطة أولًا ثم احذفها.', 'warning');
        }
        const reason = window.prompt('اكتب سبب حذف المديونية:', 'أضيفت المديونية بالخطأ');
        if (!reason?.trim()) return;
        if (!window.confirm(`سيتم حذف المديونية ${debt.DebtNumber || ''} من القوائم. هل أنت متأكد؟`)) return;
        try {
            setLoading(true);
            const response = await fetch(`${API_BASE}/debts/${debt.DebtID}/delete`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-User-Name': getCurrentUser() },
                body: JSON.stringify({ Reason: reason.trim(), DeletedBy: getCurrentUser() })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'تعذر حذف المديونية');
            showToast(data.message, 'success');
            await loadDebts(pagination.page || 1);
            if (activeTab === 'person' && debt.PassportID) await loadPerson(debt.PassportID);
        } catch (error) {
            showToast(error.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    const beginPayment = (debt) => {
        setPaymentDebt(debt);
        setPaymentForm({
            amount: '', currency: 'EGP', exchangeRate: '',
            paymentMethodType: 'bank', paymentMethodId: '', receivedByLabel: '',
            paymentDate: new Date().toISOString().slice(0, 10), referenceNumber: '', notes: ''
        });
    };

    const submitPayment = async () => {
        if (!paymentDebt) return;
        if (!paymentForm.amount || Number(paymentForm.amount) <= 0) return showToast('أدخل مبلغ الدفعة', 'error');
        if (paymentDebt.OriginalCurrency !== 'EGP' && (!paymentForm.exchangeRate || Number(paymentForm.exchangeRate) <= 0)) {
            return showToast('هذه مديونية قديمة بعملة مختلفة؛ أدخل سعر الريال بالجنيه وقت السداد', 'error');
        }
        if (paymentForm.paymentMethodType === 'bank' && !paymentForm.paymentMethodId) return showToast('اختر الحساب البنكي', 'error');
        if (paymentForm.paymentMethodType === 'other' && !paymentForm.receivedByLabel.trim()) return showToast('اكتب أين أو لدى من تم استلام المبلغ', 'error');
        try {
            setLoading(true);
            const response = await fetch(`${API_BASE}/debts/${paymentDebt.DebtID}/payments`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    Amount: Number(paymentForm.amount),
                    CurrencyCode: 'EGP',
                    ExchangeRate: Number(paymentForm.exchangeRate || 1),
                    PaymentMethodType: paymentForm.paymentMethodType,
                    PaymentMethodID: paymentForm.paymentMethodType === 'bank' ? paymentForm.paymentMethodId : null,
                    ReceivedByLabel: paymentForm.paymentMethodType === 'manager'
                        ? 'المدير المسؤول'
                        : paymentForm.paymentMethodType === 'other'
                            ? paymentForm.receivedByLabel.trim()
                            : null,
                    PaymentDate: paymentForm.paymentDate,
                    ReferenceNumber: paymentForm.referenceNumber || null,
                    Notes: paymentForm.notes || null,
                    CreatedBy: getCurrentUser()
                })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'تعذر تسجيل الدفعة');
            showToast(data.message, 'success');
            const passportId = paymentDebt.PassportID;
            setPaymentDebt(null);
            await loadDebts(pagination.page || 1);
            if (activeTab === 'person' && passportId) await loadPerson(passportId);
        } catch (error) {
            showToast(error.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    const beginAdministrativeSettlement = (debt) => {
        setAdministrativeDebt(debt);
        setAdministrativeForm({
            amount: String(Number(debt.OutstandingAmount || 0)),
            settlementDate: new Date().toISOString().slice(0, 10),
            notes: ''
        });
    };

    const submitAdministrativeSettlement = async () => {
        if (!administrativeDebt) return;
        const amount = Number(administrativeForm.amount);
        if (!Number.isFinite(amount) || amount <= 0) return showToast('أدخل مبلغ التسوية', 'error');
        if (amount - Number(administrativeDebt.OutstandingAmount || 0) > 0.01) return showToast('مبلغ التسوية أكبر من المبلغ المتبقي', 'error');
        if (!administrativeForm.notes.trim()) return showToast('اكتب سبب التسوية أو أمر صاحب المكتب', 'error');
        if (!window.confirm('هذه تسوية إدارية بدون دفع فعلي، ولن تُضاف كإيداع في البنك أو حساب العميل. هل تريد الاستمرار؟')) return;
        try {
            setLoading(true);
            const response = await fetch(`${API_BASE}/debts/${administrativeDebt.DebtID}/administrative-settlement`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    Amount: amount,
                    SettlementDate: administrativeForm.settlementDate,
                    Notes: administrativeForm.notes.trim(),
                    CreatedBy: getCurrentUser()
                })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'تعذر تنفيذ التسوية الإدارية');
            showToast(data.message, 'success');
            const passportId = administrativeDebt.PassportID;
            setAdministrativeDebt(null);
            await loadDebts(pagination.page || 1);
            if (activeTab === 'person' && passportId) await loadPerson(passportId);
        } catch (error) {
            showToast(error.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    const fetchAllFilteredDebts = async () => {
        const allRows = [];
        let page = 1;
        let totalPages = 1;
        do {
            const params = new URLSearchParams({ ...filters, page: String(page), limit: '500' });
            const response = await fetch(`${API_BASE}/debts?${params.toString()}`);
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'تعذر تجهيز التقرير');
            allRows.push(...(data.debts || []));
            totalPages = Math.max(Number(data.pagination?.totalPages || 1), 1);
            page += 1;
        } while (page <= totalPages && page <= 100);
        return allRows;
    };

    const exportDebtsExcel = async () => {
        try {
            setLoading(true);
            const rows = await fetchAllFilteredDebts();
            if (!rows.length) return showToast('لا توجد بيانات مطابقة للتصدير', 'warning');
            const data = rows.map((debt, index) => ({
                'م': index + 1,
                'رقم المديونية': debt.DebtNumber || '',
                'اسم العميل': debt.NameArabic || '',
                'رقم الهاتف': debt.MainPhone || '',
                'الرقم القومي': debt.NationalID || '',
                'رقم الملف': debt.OfficeSerial || debt.PassportID || '',
                'حالة السفرة': debt.TripIsActive ? 'نشطة' : 'مؤرشفة',
                'أصل المديونية ج.م': Number(debt.OriginalAmount || 0),
                'المدفوع فعليًا ج.م': Number(debt.PaidAmount || 0),
                'تسوية إدارية ج.م': Number(debt.AdministrativeSettledAmount || 0),
                'المتبقي ج.م': Number(debt.OutstandingAmount || 0),
                'الحالة': debt.Status || (Number(debt.OutstandingAmount || 0) <= 0 ? 'مسددة' : 'مفتوحة'),
                'سبب المديونية': debt.Reason || '',
                'موعد السداد': debt.DueType || '',
                'تاريخ الاستحقاق': debt.DueDate ? new Date(debt.DueDate).toLocaleDateString('ar-EG') : '',
                'الشركة': debt.CompanyName || '',
                'المندوب': debt.DelegateName || ''
            }));
            const sheet = XLSX.utils.json_to_sheet(data);
            sheet['!cols'] = [5, 18, 25, 16, 18, 14, 14, 18, 18, 18, 16, 16, 30, 18, 16, 22, 20].map(wch => ({ wch }));
            const book = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(book, sheet, 'المديونيات والتحصيلات');
            const selectedCompany = filters.companyId !== 'all'
                ? companies.find(company => String(company.CompanyID) === String(filters.companyId))?.CompanyName
                : null;
            const selectedDelegate = filters.delegateId !== 'all'
                ? delegates.find(delegate => String(delegate.DelegateID) === String(filters.delegateId))?.DelegateName
                : null;

            const companySuffix = selectedCompany ? `_${selectedCompany.replace(/[\\/:*?"<>|]/g, '_')}` : '';
            const delegateSuffix = selectedDelegate ? `_${selectedDelegate.replace(/[\\/:*?"<>|]/g, '_')}` : '';
            XLSX.writeFile(book, `المديونيات_والتحصيلات${companySuffix}${delegateSuffix}_${new Date().toISOString().slice(0, 10)}.xlsx`);
            showToast(`تم تصدير ${rows.length} سجل`, 'success');
        } catch (error) {
            showToast(error.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    const escapeDebtHtml = (value) => String(value ?? '')
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#039;');

    const printDebtsReport = async () => {
        const printWindow = window.open('', '_blank');
        if (!printWindow) return showToast('اسمح بالنوافذ المنبثقة لاستخدام الطباعة', 'warning');
        printWindow.document.write('<div dir="rtl" style="font-family:Arial;padding:30px">جاري تجهيز التقرير...</div>');
        try {
            setLoading(true);
            const rows = await fetchAllFilteredDebts();
            const bodyRows = rows.map((debt, index) => `
                <tr>
                    <td>${index + 1}</td>
                    <td>${escapeDebtHtml(debt.NameArabic)}</td>
                    <td>${escapeDebtHtml(debt.MainPhone || '-')}</td>
                    <td>${escapeDebtHtml(debt.OfficeSerial || debt.PassportID)}</td>
                    <td>${escapeDebtHtml(debt.CompanyName || '-')}</td>
                    <td>${escapeDebtHtml(debt.DelegateName || '-')}</td>
                    <td>${Number(debt.OriginalAmount || 0).toLocaleString()}</td>
                    <td>${Number(debt.PaidAmount || 0).toLocaleString()}</td>
                    <td>${Number(debt.AdministrativeSettledAmount || 0).toLocaleString()}</td>
                    <td>${Number(debt.OutstandingAmount || 0).toLocaleString()}</td>
                    <td>${escapeDebtHtml(debt.Status || (Number(debt.OutstandingAmount || 0) <= 0 ? 'مسددة' : 'مفتوحة'))}</td>
                    <td>${escapeDebtHtml(debt.Reason || '-')}</td>
                </tr>`).join('');
            const selectedCompany = filters.companyId !== 'all'
                ? companies.find(company => String(company.CompanyID) === String(filters.companyId))?.CompanyName
                : null;
            const selectedDelegate = filters.delegateId !== 'all'
                ? delegates.find(delegate => String(delegate.DelegateID) === String(filters.delegateId))?.DelegateName
                : null;
            printWindow.document.open();
            printWindow.document.write(`<!doctype html><html lang="ar" dir="rtl"><head><meta charset="utf-8"><title>تقرير المديونيات والتحصيلات</title><style>
                body{font-family:Arial,Tahoma,sans-serif;padding:22px;color:#111}h1{font-size:22px;margin:0 0 8px}.meta{font-size:12px;color:#555;margin-bottom:16px}
                table{width:100%;border-collapse:collapse;font-size:11px}th,td{border:1px solid #999;padding:6px;text-align:right;vertical-align:top}th{background:#f1f5f9}
                @media print{body{padding:0}@page{size:landscape;margin:10mm}}
            </style></head><body><h1>تقرير المديونيات والتحصيلات${selectedCompany ? ` — شركة ${escapeDebtHtml(selectedCompany)}` : ''}${selectedDelegate ? ` — مندوب ${escapeDebtHtml(selectedDelegate)}` : ''}</h1><div class="meta">تاريخ الطباعة: ${new Date().toLocaleString('ar-EG')} — عدد السجلات: ${rows.length}</div>
            <table><thead><tr><th>م</th><th>العميل</th><th>الهاتف</th><th>الملف</th><th>الشركة</th><th>المندوب</th><th>أصل الدين</th><th>المدفوع</th><th>تسوية إدارية</th><th>المتبقي</th><th>الحالة</th><th>السبب</th></tr></thead><tbody>${bodyRows || '<tr><td colspan="12">لا توجد بيانات</td></tr>'}</tbody></table>
            <script>window.onload=()=>{window.print();}</script></body></html>`);
            printWindow.document.close();
        } catch (error) {
            printWindow.close();
            showToast(error.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    const submitSettlement = async () => {
        if (!settlementPayment) return;
        if (settlementForm.paymentMethodType === 'bank' && !settlementForm.paymentMethodId) return showToast('اختر الحساب البنكي', 'error');
        try {
            setLoading(true);
            const response = await fetch(`${API_BASE}/debt-payments/${settlementPayment.DebtPaymentID}/settle`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    PaymentMethodType: settlementForm.paymentMethodType,
                    PaymentMethodID: settlementForm.paymentMethodType === 'bank' ? settlementForm.paymentMethodId : null,
                    SettlementDate: settlementForm.settlementDate,
                    Notes: settlementForm.notes || null,
                    SettledBy: getCurrentUser()
                })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'تعذر التسوية');
            showToast(data.message, 'success');
            const passportId = settlementPayment.PassportID;
            setSettlementPayment(null);
            await loadDebts(pagination.page || 1);
            if (passportId) await loadPerson(passportId);
        } catch (error) {
            showToast(error.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    const reversePayment = async (payment) => {
        const reason = window.prompt('اكتب سبب إلغاء الدفعة. لن يتم حذفها، بل سيتم إنشاء أثر عكسي:');
        if (!reason?.trim()) return;
        if (!window.confirm('سيتم إعادة مبلغ الدفعة إلى المديونية وإلغاء القيد المالي المرتبط. هل أنت متأكد؟')) return;
        try {
            setLoading(true);
            const response = await fetch(`${API_BASE}/debt-payments/${payment.DebtPaymentID}/reverse`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Reason: reason.trim(), ReversedBy: getCurrentUser() })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'تعذر إلغاء الدفعة');
            showToast(data.message, 'success');
            await loadDebts(pagination.page || 1);
            if (payment.PassportID) await loadPerson(payment.PassportID);
        } catch (error) {
            showToast(error.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    const renderSummaryCards = () => (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            <div className="rounded-2xl bg-rose-50 border border-rose-100 p-3">
                <div className="text-xs text-rose-600 font-bold">إجمالي المتبقي</div>
                <div className="text-xl font-black text-rose-800 mt-1">{formatAmount(summary.OutstandingEGP, 'EGP')}</div>
            </div>
            <div className="rounded-2xl bg-blue-50 border border-blue-100 p-3">
                <div className="text-xs text-blue-600 font-bold">مديونيات مفتوحة</div>
                <div className="text-xl font-black text-blue-800 mt-1">{Number(summary.OpenDebtCount || 0).toLocaleString()}</div>
            </div>
            <div className="rounded-2xl bg-green-50 border border-green-100 p-3">
                <div className="text-xs text-green-600 font-bold">مغلقة أو مسددة</div>
                <div className="text-xl font-black text-green-800 mt-1">{Number(summary.ClosedDebtCount || 0).toLocaleString()}</div>
            </div>
            <div className="rounded-2xl bg-amber-50 border border-amber-100 p-3">
                <div className="text-xs text-amber-700 font-bold">تسويات إدارية بدون دفع</div>
                <div className="text-xl font-black text-amber-800 mt-1">{formatAmount(summary.AdministrativeSettledEGP, 'EGP')}</div>
            </div>
        </div>
    );

    const renderDebtList = () => (
        <div className="space-y-4">
            {renderSummaryCards()}
            <div className="bg-gray-50 border border-gray-200 rounded-2xl p-3 grid grid-cols-1 md:grid-cols-8 gap-2">
                <input
                    value={filters.search}
                    onChange={(e) => setFilters({ ...filters, search: e.target.value })}
                    onKeyDown={(e) => e.key === 'Enter' && loadDebts(1)}
                    placeholder="اسم، هاتف، رقم قومي، رقم ملف، رقم مديونية..."
                    className="md:col-span-2 border rounded-xl px-3 py-2"
                />
                <select value={filters.status} onChange={(e) => setFilters({ ...filters, status: e.target.value })} className="border rounded-xl px-3 py-2">
                    <option value="open">غير مسددة</option>
                    <option value="paid">مسددة</option>
                    <option value="overdue">متأخرة</option>
                    <option value="all">الكل</option>
                </select>
                <select value={filters.currency} onChange={(e) => setFilters({ ...filters, currency: e.target.value })} className="border rounded-xl px-3 py-2">
                    <option value="all">كل العملات</option>
                    <option value="EGP">جنيه مصري</option>
                    <option value="SAR">ريال سعودي</option>
                </select>
                <select value={filters.settlement} onChange={(e) => setFilters({ ...filters, settlement: e.target.value })} className="border rounded-xl px-3 py-2">
                    <option value="all">كل التسويات</option>
                    <option value="pending">بانتظار التسوية</option>
                </select>
                <select value={filters.companyId} onChange={(e) => setFilters({ ...filters, companyId: e.target.value })} className="border rounded-xl px-3 py-2">
                    <option value="all">كل الشركات</option>
                    {companies.map(company => <option key={company.CompanyID} value={company.CompanyID}>{company.CompanyName}</option>)}
                </select>
                <select value={filters.delegateId} onChange={(e) => setFilters({ ...filters, delegateId: e.target.value })} className="border rounded-xl px-3 py-2">
                    <option value="all">كل المندوبين</option>
                    {delegates.map(delegate => <option key={delegate.DelegateID} value={delegate.DelegateID}>{delegate.DelegateName}</option>)}
                </select>
                <button onClick={() => loadDebts(1)} className="bg-blue-600 text-white rounded-xl px-3 py-2 font-bold flex items-center justify-center gap-2">
                    <Search size={17} /> بحث
                </button>
            </div>

            {debts.length === 0 ? (
                <div className="text-center py-14 text-gray-500 border-2 border-dashed rounded-2xl">لا توجد مديونيات مطابقة</div>
            ) : (
                <div className="grid grid-cols-1 xl:grid-cols-2 gap-3">
                    {debts.map(debt => (
                        <div key={debt.DebtID} className={`border-2 rounded-2xl p-4 ${Number(debt.OutstandingAmount) > 0 ? 'border-rose-100 bg-white' : 'border-green-100 bg-green-50/30'}`}>
                            <div className="flex items-start justify-between gap-3">
                                <div>
                                    <div className="font-black text-gray-900">{debt.NameArabic}</div>
                                    <div className="text-xs text-gray-500 mt-1">{debt.DebtNumber} • ملف السفرة: {debt.OfficeSerial || debt.PassportID}</div>
                                    <div className="text-xs text-indigo-700 font-bold mt-1">الشركة: {debt.CompanyName || 'غير محددة'}</div>
                                    <div className="text-xs text-violet-700 font-bold mt-1">المندوب: {debt.DelegateName || 'غير محدد'}</div>
                                    <div className="text-xs text-sky-700 font-bold mt-1">الهاتف: {debt.MainPhone || 'غير مسجل'}</div>
                                    <div className="text-xs font-bold mt-1 text-slate-700">الحالة: {debt.Status || '-'}</div>
                                    <div className="text-xs mt-1">
                                        <span className={`px-2 py-1 rounded-full font-bold ${debt.TripIsActive ? 'bg-green-100 text-green-700' : 'bg-gray-200 text-gray-700'}`}>
                                            {debt.TripIsActive ? 'سفرة نشطة' : 'سفرة مؤرشفة'}
                                        </span>
                                    </div>
                                </div>
                                <div className="text-left">
                                    <div className="text-xs text-gray-500">المتبقي</div>
                                    <div className={`text-xl font-black ${Number(debt.OutstandingAmount) > 0 ? 'text-rose-700' : 'text-green-700'}`}>
                                        {formatAmount(debt.OutstandingAmount, debt.OriginalCurrency)}
                                    </div>
                                </div>
                            </div>
                            <div className="grid grid-cols-2 gap-2 mt-4 text-sm">
                                <div className="bg-gray-50 rounded-xl p-2"><span className="text-gray-500">أصل الدين:</span> <b>{formatAmount(debt.OriginalAmount, debt.OriginalCurrency)}</b></div>
                                <div className="bg-gray-50 rounded-xl p-2"><span className="text-gray-500">المدفوع فعليًا:</span> <b>{formatAmount(debt.PaidAmount, debt.OriginalCurrency)}</b></div>
                                {Number(debt.AdministrativeSettledAmount || 0) > 0 && <div className="bg-amber-50 border border-amber-100 rounded-xl p-2 col-span-2"><span className="text-amber-700">تسوية إدارية بدون دفع:</span> <b>{formatAmount(debt.AdministrativeSettledAmount, debt.OriginalCurrency)}</b></div>}
                                <div className="bg-gray-50 rounded-xl p-2 col-span-2"><span className="text-gray-500">السبب:</span> <b>{debt.Reason}</b></div>
                                <div className="bg-gray-50 rounded-xl p-2"><span className="text-gray-500">موعد السداد:</span> <b>{debt.DueType || '-'}</b></div>
                                <div className="bg-gray-50 rounded-xl p-2"><span className="text-gray-500">تاريخ الاستحقاق:</span> <b>{debt.DueDate ? new Date(debt.DueDate).toLocaleDateString('ar-EG') : '-'}</b></div>
                            </div>
                            {Number(debt.PendingSettlementAmount || 0) > 0 && (
                                <div className="mt-3 bg-violet-50 border border-violet-200 text-violet-800 rounded-xl px-3 py-2 text-sm font-bold">
                                    تم تحصيل {formatAmount(debt.PendingSettlementAmount, debt.OriginalCurrency)} عند جهة خارجية ولم يصل للخزينة أو البنك بعد.
                                </div>
                            )}
                            <div className="flex flex-wrap gap-2 mt-4">
                                {Number(debt.OutstandingAmount) > 0 && (
                                    <button onClick={() => beginPayment(debt)} className="bg-green-600 text-white rounded-xl px-4 py-2 font-bold flex items-center gap-2">
                                        <CreditCard size={16} /> تحصيل دفعة
                                    </button>
                                )}
                                {Number(debt.OutstandingAmount) > 0 && (
                                    <button onClick={() => beginAdministrativeSettlement(debt)} className="bg-amber-600 text-white rounded-xl px-4 py-2 font-bold flex items-center gap-2">
                                        <CheckCircle size={16} /> تسوية إدارية
                                    </button>
                                )}
                                <button onClick={() => loadPerson(debt.PassportID)} className="bg-blue-600 text-white rounded-xl px-4 py-2 font-bold flex items-center gap-2">
                                    <Eye size={16} /> الحساب الدائم
                                </button>
                                <button onClick={() => beginEditDebt(debt)} className="bg-slate-600 text-white rounded-xl px-4 py-2 font-bold flex items-center gap-2">
                                    <Edit size={16} /> تعديل
                                </button>
                                <button onClick={() => deleteDebt(debt)} className="bg-red-50 text-red-700 border border-red-200 rounded-xl px-4 py-2 font-bold flex items-center gap-2">
                                    <Trash2 size={16} /> حذف
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {pagination.totalPages > 1 && (
                <div className="flex justify-center items-center gap-3">
                    <button disabled={pagination.page <= 1} onClick={() => loadDebts(pagination.page - 1)} className="border rounded-lg px-4 py-2 disabled:opacity-40">السابق</button>
                    <span className="text-sm font-bold">{pagination.page} / {pagination.totalPages}</span>
                    <button disabled={pagination.page >= pagination.totalPages} onClick={() => loadDebts(pagination.page + 1)} className="border rounded-lg px-4 py-2 disabled:opacity-40">التالي</button>
                </div>
            )}
        </div>
    );

    const renderCreateDebt = () => (
        <div className="max-w-5xl mx-auto space-y-4">
            <div className="bg-amber-50 border border-amber-200 rounded-2xl p-4 text-amber-900">
                <div className="font-black flex items-center gap-2"><AlertCircle size={20} /> اختر السفرة التي نشأ عنها الدين</div>
                <div className="text-sm mt-1">حتى لو كانت السفرة مؤرشفة، ستبقى المديونية عليها وتظهر في الحساب الدائم للشخص، ولن تنتقل للسفرة الجديدة.</div>
            </div>
            <div className="bg-white border rounded-2xl p-4">
                <label className="block font-bold mb-2">البحث عن العميل أو السفرة</label>
                <div className="flex gap-2">
                    <input value={clientSearch} onChange={(e) => setClientSearch(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && searchForClients()} className="flex-1 border rounded-xl px-3 py-2" placeholder="الاسم، رقم الهاتف، الرقم القومي، رقم الجواز أو رقم الملف" />
                    <button onClick={searchForClients} className="bg-blue-600 text-white rounded-xl px-5 py-2 font-bold">بحث</button>
                </div>
                {clientResults.length > 0 && (
                    <div className="mt-3 max-h-72 overflow-y-auto border rounded-xl divide-y">
                        {clientResults.map(item => (
                            <button key={item.PassportID} onClick={() => setSelectedTrip(item)} className={`w-full text-right p-3 hover:bg-blue-50 ${selectedTrip?.PassportID === item.PassportID ? 'bg-blue-50 ring-2 ring-blue-200' : ''}`}>
                                <div className="flex justify-between gap-3">
                                    <div>
                                        <div className="font-black">{item.NameArabic}</div>
                                        <div className="text-xs text-gray-500">رقم الملف: {item.OfficeSerial || item.PassportID} • الجواز: {item.PassportNumber || '-'} • الهاتف: {item.PhoneNumbers || '-'} • الشركة: {item.CompanyName || '-'} • المندوب: {item.DelegateName || '-'}</div>
                                    </div>
                                    <span className={`text-xs font-bold px-2 py-1 rounded-full h-fit ${item.IsActive ? 'bg-green-100 text-green-700' : 'bg-gray-200 text-gray-700'}`}>{item.IsActive ? 'نشطة' : 'مؤرشفة'}</span>
                                </div>
                            </button>
                        ))}
                    </div>
                )}
            </div>

            {selectedTrip && (
                <div className="bg-blue-50 border border-blue-200 rounded-2xl p-4">
                    <div className="font-black text-blue-900">السفرة المختارة: {selectedTrip.NameArabic} — ملف {selectedTrip.OfficeSerial || selectedTrip.PassportID}</div>
                    <div className="text-sm text-blue-700 mt-1">سيتم ربط المديونية بهذه السفرة تحديدًا.</div>
                </div>
            )}

            <div className="bg-white border rounded-2xl p-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label className="block text-sm font-bold mb-1">المبلغ</label>
                    <input type="number" min="0" step="0.01" value={debtForm.amount} onChange={(e) => setDebtForm({ ...debtForm, amount: e.target.value })} className="w-full border rounded-xl px-3 py-2" />
                </div>
                <div>
                    <label className="block text-sm font-bold mb-1">عملة أصل المديونية</label>
                    <div className="w-full border rounded-xl px-3 py-2 bg-gray-50 font-bold text-gray-700">جنيه مصري — ثابت</div>
                </div>
                <div className="md:col-span-2">
                    <label className="block text-sm font-bold mb-1">سبب المديونية</label>
                    <input value={debtForm.reason} onChange={(e) => setDebtForm({ ...debtForm, reason: e.target.value })} className="w-full border rounded-xl px-3 py-2" placeholder="مثال: باقي رسوم السفر والتأشيرة" />
                </div>
                <div>
                    <label className="block text-sm font-bold mb-1">موعد السداد</label>
                    <select value={debtForm.dueType} onChange={(e) => setDebtForm({ ...debtForm, dueType: e.target.value })} className="w-full border rounded-xl px-3 py-2">
                        <option>بعد السفر</option>
                        <option>عند استلام أول راتب</option>
                        <option>عند العودة</option>
                        <option>تاريخ محدد</option>
                        <option>بدون تاريخ محدد</option>
                    </select>
                </div>
                <div>
                    <label className="block text-sm font-bold mb-1">تاريخ الاستحقاق — اختياري</label>
                    <input type="date" value={debtForm.dueDate} onChange={(e) => setDebtForm({ ...debtForm, dueDate: e.target.value })} className="w-full border rounded-xl px-3 py-2" />
                </div>
                <div>
                    <label className="block text-sm font-bold mb-1">مكان التحصيل المتوقع</label>
                    <select value={debtForm.collectionLocation} onChange={(e) => setDebtForm({ ...debtForm, collectionLocation: e.target.value })} className="w-full border rounded-xl px-3 py-2">
                        <option value="مصر">مصر</option>
                        <option value="السعودية">السعودية</option>
                        <option value="غير محدد">غير محدد</option>
                    </select>
                </div>
                <div>
                    <label className="block text-sm font-bold mb-1">المسؤول المتوقع عن التحصيل</label>
                    <select value={debtForm.responsibleType} onChange={(e) => setDebtForm({ ...debtForm, responsibleType: e.target.value, responsibleId: '' })} className="w-full border rounded-xl px-3 py-2">
                        <option value="">غير محدد</option>
                        <option value="office">المكتب</option>
                        <option value="delegate">مندوب</option>
                        <option value="company">شركة</option>
                    </select>
                </div>
                {debtForm.responsibleType === 'delegate' && (
                    <div>
                        <label className="block text-sm font-bold mb-1">المندوب</label>
                        <select value={debtForm.responsibleId} onChange={(e) => setDebtForm({ ...debtForm, responsibleId: e.target.value })} className="w-full border rounded-xl px-3 py-2">
                            <option value="">اختر المندوب</option>
                            {delegates.map(item => <option key={item.DelegateID} value={item.DelegateID}>{item.DelegateName}</option>)}
                        </select>
                    </div>
                )}
                {debtForm.responsibleType === 'company' && (
                    <div>
                        <label className="block text-sm font-bold mb-1">الشركة</label>
                        <select value={debtForm.responsibleId} onChange={(e) => setDebtForm({ ...debtForm, responsibleId: e.target.value })} className="w-full border rounded-xl px-3 py-2">
                            <option value="">اختر الشركة</option>
                            {companies.map(item => <option key={item.CompanyID} value={item.CompanyID}>{item.CompanyName}</option>)}
                        </select>
                    </div>
                )}
                <div className="md:col-span-2">
                    <label className="block text-sm font-bold mb-1">ملاحظات</label>
                    <textarea rows={3} value={debtForm.notes} onChange={(e) => setDebtForm({ ...debtForm, notes: e.target.value })} className="w-full border rounded-xl px-3 py-2" />
                </div>
                <div className="md:col-span-2 flex justify-end">
                    <button onClick={createDebt} disabled={loading} className="bg-rose-600 text-white rounded-xl px-6 py-3 font-black flex items-center gap-2 disabled:opacity-50"><Save size={18} /> تسجيل المديونية</button>
                </div>
            </div>
        </div>
    );

    const renderPerson = () => {
        if (!personData) return <div className="text-center py-10">لم يتم اختيار حساب</div>;
        const personSummary = personData.summary || {};
        return (
            <div className="space-y-4">
                <div className="bg-gradient-to-l from-slate-800 to-slate-700 text-white rounded-2xl p-5">
                    <div className="flex justify-between gap-3 flex-wrap">
                        <div>
                            <h3 className="text-xl font-black">{personData.person?.NameArabic}</h3>
                            <div className="text-sm text-white/70 mt-1">الرقم القومي: {personData.person?.NationalID || '-'} • رقم الحساب الدائم: {personData.person?.ClientMasterID}</div>
                        </div>
                        <button onClick={() => setActiveTab('list')} className="bg-white/10 hover:bg-white/20 rounded-xl px-4 py-2">العودة للقائمة</button>
                    </div>
                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mt-4">
                        <div className="bg-white/10 rounded-xl p-3"><div className="text-xs text-white/70">إجمالي جنيه</div><b>{formatAmount(personSummary.OutstandingEGP, 'EGP')}</b></div>
                        <div className="bg-white/10 rounded-xl p-3"><div className="text-xs text-white/70">إجمالي ريال</div><b>{formatAmount(personSummary.OutstandingSAR, 'SAR')}</b></div>
                        <div className="bg-white/10 rounded-xl p-3"><div className="text-xs text-white/70">سفرات سابقة جنيه</div><b>{formatAmount(personSummary.PreviousTripsOutstandingEGP, 'EGP')}</b></div>
                        <div className="bg-white/10 rounded-xl p-3"><div className="text-xs text-white/70">سفرات سابقة ريال</div><b>{formatAmount(personSummary.PreviousTripsOutstandingSAR, 'SAR')}</b></div>
                    </div>
                </div>

                <div className="bg-white border rounded-2xl p-4">
                    <h4 className="font-black mb-3">كل سفرات الشخص</h4>
                    <div className="flex flex-wrap gap-2">
                        {(personData.trips || []).map(trip => (
                            <span key={trip.PassportID} className={`px-3 py-2 rounded-xl border text-sm font-bold ${trip.IsActive ? 'bg-green-50 border-green-200 text-green-700' : 'bg-gray-50 border-gray-200 text-gray-700'}`}>
                                ملف {trip.OfficeSerial || trip.PassportID} — {trip.IsActive ? 'نشطة' : 'مؤرشفة'}
                            </span>
                        ))}
                    </div>
                </div>

                <div className="bg-white border rounded-2xl overflow-hidden">
                    <div className="p-4 border-b font-black">المديونيات</div>
                    <div className="divide-y">
                        {(personData.debts || []).map(debt => (
                            <div key={debt.DebtID} className="p-4 flex flex-col lg:flex-row lg:items-center justify-between gap-3">
                                <div>
                                    <div className="font-black">{debt.DebtNumber} — ملف {debt.OfficeSerial || debt.PassportID}</div>
                                    <div className="text-sm text-gray-500 mt-1">{debt.Reason} • {debt.TripIsActive ? 'سفرة نشطة' : 'سفرة مؤرشفة'} • الشركة: {debt.CompanyName || '-'}</div>
                                </div>
                                <div className="flex items-center gap-2 flex-wrap">
                                    <span className="font-black text-rose-700">متبقي: {formatAmount(debt.OutstandingAmount, debt.OriginalCurrency)}</span>
                                    {Number(debt.OutstandingAmount) > 0 && <button onClick={() => beginPayment(debt)} className="bg-green-600 text-white rounded-lg px-3 py-2 font-bold">تحصيل</button>}
                                    {Number(debt.OutstandingAmount) > 0 && <button onClick={() => beginAdministrativeSettlement(debt)} className="bg-amber-600 text-white rounded-lg px-3 py-2 font-bold">تسوية إدارية</button>}
                                    <button onClick={() => beginEditDebt(debt)} className="bg-slate-600 text-white rounded-lg px-3 py-2 font-bold">تعديل</button>
                                    <button onClick={() => deleteDebt(debt)} className="bg-red-50 text-red-700 border border-red-200 rounded-lg px-3 py-2 font-bold">حذف</button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="bg-white border rounded-2xl overflow-hidden">
                    <div className="p-4 border-b font-black">دفعات المديونيات والتسويات</div>
                    <div className="divide-y">
                        {(personData.payments || []).length === 0 && <div className="p-6 text-center text-gray-500">لا توجد دفعات</div>}
                        {(personData.payments || []).map(payment => (
                            <div key={payment.DebtPaymentID} className={`p-4 ${payment.IsReversed ? 'opacity-60 bg-gray-50' : ''}`}>
                                <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-3">
                                    <div>
                                        <div className="font-black">{formatAmount(payment.Amount, payment.CurrencyCode)} — {payment.DebtNumber}</div>
                                        <div className="text-sm text-gray-500 mt-1">يعادل {formatAmount(payment.EquivalentDebtCurrency, payment.OriginalCurrency)} • {new Date(payment.PaymentDate).toLocaleDateString('ar-EG')}</div>
                                        <div className="text-xs mt-1">جهة الاستلام: {payment.ReceivedAtDisplay || payment.ReceivedByLabel || payment.ReceivedByType || payment.PaymentMethodType} • الحالة: {payment.IsReversed ? 'ملغاة' : payment.SettlementStatus}</div>
                                    </div>
                                    {!payment.IsReversed && (
                                        <div className="flex gap-2 flex-wrap">
                                            {payment.SettlementStatus === 'بانتظار التسوية' && (
                                                <button onClick={() => { setSettlementPayment(payment); setSettlementForm({ paymentMethodType: 'treasury', paymentMethodId: '', settlementDate: new Date().toISOString().slice(0, 10), notes: '' }); }} className="bg-violet-600 text-white rounded-lg px-3 py-2 font-bold">تسوية للخزينة/البنك</button>
                                            )}
                                            <button onClick={() => reversePayment(payment)} className="bg-red-50 text-red-700 border border-red-200 rounded-lg px-3 py-2 font-bold">إلغاء بقيد عكسي</button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {(personData.adjustments || []).length > 0 && (
                    <div className="bg-white border rounded-2xl overflow-hidden">
                        <div className="p-4 border-b font-black text-amber-800">التسويات الإدارية بدون دفع</div>
                        <div className="divide-y">
                            {(personData.adjustments || []).map(item => (
                                <div key={item.DebtAdjustmentID} className="p-4">
                                    <div className="font-black">{formatAmount(item.Amount, item.OriginalCurrency)} — {item.DebtNumber}</div>
                                    <div className="text-sm text-gray-600 mt-1">{item.Notes}</div>
                                    <div className="text-xs text-gray-500 mt-1">{new Date(item.AdjustmentDate).toLocaleDateString('ar-EG')} • بواسطة {item.CreatedBy || '-'}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className="fixed inset-0 z-[80] bg-black/60 flex items-center justify-center p-2 sm:p-4" dir="rtl">
            <div className="bg-gray-50 w-full max-w-7xl h-[96vh] rounded-3xl shadow-2xl overflow-hidden flex flex-col">
                <div className="bg-gradient-to-l from-rose-700 to-red-700 text-white px-5 py-4 flex items-center justify-between gap-3">
                    <div>
                        <h2 className="text-xl font-black flex items-center gap-2"><Wallet size={22} /> المديونيات والتحصيلات</h2>
                        <p className="text-sm text-white/80 mt-1">الحساب دائم للشخص، بينما كل مديونية تبقى مرتبطة بالسفرة التي نشأت عنها.</p>
                    </div>
                    <button onClick={onClose} className="bg-white/15 hover:bg-white/25 rounded-full p-2"><X size={22} /></button>
                </div>

                <div className="bg-white border-b px-3 py-2 flex items-center justify-between gap-3 overflow-x-auto">
                    <div className="flex gap-2">
                        <button onClick={() => { setActiveTab('list'); loadDebts(1); }} className={`px-4 py-2 rounded-xl font-bold whitespace-nowrap ${activeTab === 'list' ? 'bg-rose-100 text-rose-700' : 'text-gray-600 hover:bg-gray-100'}`}>كل المديونيات</button>
                        <button onClick={() => { resetDebtForm(); setActiveTab('create'); }} className={`px-4 py-2 rounded-xl font-bold whitespace-nowrap ${activeTab === 'create' ? 'bg-rose-100 text-rose-700' : 'text-gray-600 hover:bg-gray-100'}`}>تسجيل مبلغ مستحق</button>
                        {activeTab === 'person' && <span className="px-4 py-2 rounded-xl font-bold bg-slate-100 text-slate-700 whitespace-nowrap">الحساب الدائم للشخص</span>}
                    </div>
                    <div className="flex gap-2">
                        <button onClick={exportDebtsExcel} className="bg-emerald-600 text-white px-4 py-2 rounded-xl font-bold whitespace-nowrap flex items-center gap-2"><FileSpreadsheet size={17} /> Excel</button>
                        <button onClick={printDebtsReport} className="bg-slate-700 text-white px-4 py-2 rounded-xl font-bold whitespace-nowrap flex items-center gap-2"><Printer size={17} /> طباعة</button>
                    </div>
                </div>

                <div className="flex-1 overflow-y-auto p-3 sm:p-5">
                    {activeTab === 'list' && renderDebtList()}
                    {activeTab === 'create' && renderCreateDebt()}
                    {activeTab === 'person' && renderPerson()}
                </div>

                {loading && (
                    <div className="absolute inset-0 z-[95] bg-black/20 flex items-center justify-center pointer-events-none">
                        <div className="bg-white rounded-2xl shadow-xl px-6 py-4 flex items-center gap-3"><RefreshCw className="animate-spin text-rose-600" size={22} /><b>جاري التنفيذ...</b></div>
                    </div>
                )}
            </div>

            {editDebt && (
                <div className="fixed inset-0 z-[90] bg-black/60 flex items-center justify-center p-3">
                    <div className="bg-white rounded-3xl w-full max-w-2xl p-5 max-h-[90vh] overflow-y-auto">
                        <div className="flex justify-between items-start gap-3 mb-4">
                            <div>
                                <h3 className="text-xl font-black text-slate-800">تعديل المديونية</h3>
                                <p className="text-sm text-gray-500 mt-1">{editDebt.DebtNumber} — {editDebt.NameArabic || editDebt.ClientName || 'عميل غير محدد'} — شركة {editDebt.CompanyName || 'غير محددة'}</p>
                            </div>
                            <button onClick={() => setEditDebt(null)}><X size={22} /></button>
                        </div>
                        <div className="bg-blue-50 border border-blue-200 rounded-xl p-3 text-sm text-blue-900 mb-4">
                            يمكن تعديل أصل المبلغ والبيانات، لكن لا يمكن تخفيض أصل المديونية عن إجمالي ما تم دفعه أو تسويته بالفعل.
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            <div><label className="block text-sm font-bold mb-1">أصل المديونية بالجنيه</label><input type="number" min="0" step="0.01" value={editDebtForm.amount} onChange={(e) => setEditDebtForm({ ...editDebtForm, amount: e.target.value })} className="w-full border rounded-xl px-3 py-2" /></div>
                            <div><label className="block text-sm font-bold mb-1">موعد السداد</label><select value={editDebtForm.dueType} onChange={(e) => setEditDebtForm({ ...editDebtForm, dueType: e.target.value })} className="w-full border rounded-xl px-3 py-2"><option value="بعد السفر">بعد السفر</option><option value="عند العودة">عند العودة</option><option value="عند استلام أول راتب">عند استلام أول راتب</option><option value="تاريخ محدد">تاريخ محدد</option><option value="بدون تاريخ محدد">بدون تاريخ محدد</option></select></div>
                            <div><label className="block text-sm font-bold mb-1">تاريخ الاستحقاق</label><input type="date" value={editDebtForm.dueDate} onChange={(e) => setEditDebtForm({ ...editDebtForm, dueDate: e.target.value })} className="w-full border rounded-xl px-3 py-2" /></div>
                            <div><label className="block text-sm font-bold mb-1">مكان التحصيل</label><input value={editDebtForm.collectionLocation} onChange={(e) => setEditDebtForm({ ...editDebtForm, collectionLocation: e.target.value })} className="w-full border rounded-xl px-3 py-2" /></div>
                            <div className="md:col-span-2"><label className="block text-sm font-bold mb-1">سبب المديونية</label><input value={editDebtForm.reason} onChange={(e) => setEditDebtForm({ ...editDebtForm, reason: e.target.value })} className="w-full border rounded-xl px-3 py-2" /></div>
                            <div className="md:col-span-2"><label className="block text-sm font-bold mb-1">ملاحظات</label><textarea rows={3} value={editDebtForm.notes} onChange={(e) => setEditDebtForm({ ...editDebtForm, notes: e.target.value })} className="w-full border rounded-xl px-3 py-2" /></div>
                        </div>
                        <div className="flex justify-end gap-2 mt-5"><button onClick={() => setEditDebt(null)} className="border rounded-xl px-5 py-2">إلغاء</button><button onClick={submitEditDebt} className="bg-slate-700 text-white rounded-xl px-6 py-2 font-black">حفظ التعديل</button></div>
                    </div>
                </div>
            )}

            {paymentDebt && (
                <div className="fixed inset-0 z-[90] bg-black/60 flex items-center justify-center p-3">
                    <div className="bg-white rounded-3xl w-full max-w-2xl max-h-[92vh] overflow-y-auto p-5">
                        <div className="flex justify-between items-start gap-3 mb-4">
                            <div><h3 className="text-xl font-black">تحصيل دفعة</h3><p className="text-sm text-gray-500 mt-1">{paymentDebt.DebtNumber} — المتبقي {formatAmount(paymentDebt.OutstandingAmount, paymentDebt.OriginalCurrency)}</p></div>
                            <button onClick={() => setPaymentDebt(null)}><X size={22} /></button>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div><label className="block text-sm font-bold mb-1">المبلغ المدفوع</label><input type="number" min="0" step="0.01" value={paymentForm.amount} onChange={(e) => setPaymentForm({ ...paymentForm, amount: e.target.value })} className="w-full border rounded-xl px-3 py-2" /></div>
                            <div><label className="block text-sm font-bold mb-1">عملة الدفع</label><div className="w-full border rounded-xl px-3 py-2 bg-gray-50 font-bold">جنيه مصري — ثابت</div></div>
                            {paymentDebt.OriginalCurrency !== 'EGP' && <div className="md:col-span-2"><label className="block text-sm font-bold mb-1">سعر 1 ريال بالجنيه لهذه المديونية القديمة</label><input type="number" min="0" step="0.000001" value={paymentForm.exchangeRate} onChange={(e) => setPaymentForm({ ...paymentForm, exchangeRate: e.target.value })} className="w-full border rounded-xl px-3 py-2" placeholder="مثال: 13.25" /></div>}
                            <div className="md:col-span-2"><label className="block text-sm font-bold mb-1">أين استُلم المبلغ؟</label><select value={paymentForm.paymentMethodType} onChange={(e) => setPaymentForm({ ...paymentForm, paymentMethodType: e.target.value, paymentMethodId: '', receivedByLabel: '' })} className="w-full border rounded-xl px-3 py-2"><option value="bank">حساب بنكي</option><option value="manager">عند المدير المسؤول</option><option value="other">جهة أخرى</option></select></div>
                            {paymentForm.paymentMethodType === 'bank' && <div className="md:col-span-2"><label className="block text-sm font-bold mb-1">الحساب البنكي</label><select value={paymentForm.paymentMethodId} onChange={(e) => setPaymentForm({ ...paymentForm, paymentMethodId: e.target.value })} className="w-full border rounded-xl px-3 py-2"><option value="">اختر الحساب المسجل</option>{banks.map(item => <option key={item.id || item.AccountID} value={item.id || item.AccountID}>{item.name || item.Name}</option>)}</select></div>}
                            {paymentForm.paymentMethodType === 'other' && <div className="md:col-span-2"><label className="block text-sm font-bold mb-1">اكتب جهة أو شخص الاستلام</label><input value={paymentForm.receivedByLabel} onChange={(e) => setPaymentForm({ ...paymentForm, receivedByLabel: e.target.value })} className="w-full border rounded-xl px-3 py-2" placeholder="مثال: عند الأستاذ فلان / فرع كذا" /></div>}
                            <div><label className="block text-sm font-bold mb-1">تاريخ الدفع</label><input type="date" value={paymentForm.paymentDate} onChange={(e) => setPaymentForm({ ...paymentForm, paymentDate: e.target.value })} className="w-full border rounded-xl px-3 py-2" /></div>
                            <div><label className="block text-sm font-bold mb-1">رقم إيصال/مرجع</label><input value={paymentForm.referenceNumber} onChange={(e) => setPaymentForm({ ...paymentForm, referenceNumber: e.target.value })} className="w-full border rounded-xl px-3 py-2" /></div>
                            <div className="md:col-span-2"><label className="block text-sm font-bold mb-1">ملاحظات</label><textarea rows={3} value={paymentForm.notes} onChange={(e) => setPaymentForm({ ...paymentForm, notes: e.target.value })} className="w-full border rounded-xl px-3 py-2" /></div>
                        </div>
                        <div className="flex justify-end gap-2 mt-5"><button onClick={() => setPaymentDebt(null)} className="border rounded-xl px-5 py-2">إلغاء</button><button onClick={submitPayment} className="bg-green-600 text-white rounded-xl px-6 py-2 font-black">تأكيد التحصيل</button></div>
                    </div>
                </div>
            )}

            {administrativeDebt && (
                <div className="fixed inset-0 z-[91] bg-black/60 flex items-center justify-center p-3">
                    <div className="bg-white rounded-3xl w-full max-w-lg p-5">
                        <div className="flex justify-between items-start gap-3 mb-4">
                            <div><h3 className="text-xl font-black text-amber-800">تسوية إدارية بدون دفع</h3><p className="text-sm text-gray-500 mt-1">{administrativeDebt.DebtNumber} — المتبقي {formatAmount(administrativeDebt.OutstandingAmount, administrativeDebt.OriginalCurrency)}</p></div>
                            <button onClick={() => setAdministrativeDebt(null)}><X size={22} /></button>
                        </div>
                        <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 text-sm text-amber-900 mb-4">تُستخدم عند الإعفاء أو الإغلاق بأمر صاحب المكتب. لن تُسجل كدفعة ولن تدخل حسابًا بنكيًا.</div>
                        <div className="space-y-3">
                            <div><label className="block text-sm font-bold mb-1">مبلغ التسوية</label><input type="number" min="0" step="0.01" max={Number(administrativeDebt.OutstandingAmount || 0)} value={administrativeForm.amount} onChange={(e) => setAdministrativeForm({ ...administrativeForm, amount: e.target.value })} className="w-full border rounded-xl px-3 py-2" /></div>
                            <div><label className="block text-sm font-bold mb-1">تاريخ التسوية</label><input type="date" value={administrativeForm.settlementDate} onChange={(e) => setAdministrativeForm({ ...administrativeForm, settlementDate: e.target.value })} className="w-full border rounded-xl px-3 py-2" /></div>
                            <div><label className="block text-sm font-bold mb-1">سبب التسوية / الملاحظة <span className="text-red-600">*</span></label><textarea rows={4} value={administrativeForm.notes} onChange={(e) => setAdministrativeForm({ ...administrativeForm, notes: e.target.value })} className="w-full border rounded-xl px-3 py-2" placeholder="مثال: تمت التسوية بأمر صاحب المكتب بتاريخ..." /></div>
                        </div>
                        <div className="flex justify-end gap-2 mt-5"><button onClick={() => setAdministrativeDebt(null)} className="border rounded-xl px-5 py-2">إلغاء</button><button onClick={submitAdministrativeSettlement} className="bg-amber-600 text-white rounded-xl px-6 py-2 font-black">تأكيد التسوية الإدارية</button></div>
                    </div>
                </div>
            )}

            {settlementPayment && (
                <div className="fixed inset-0 z-[92] bg-black/60 flex items-center justify-center p-3">
                    <div className="bg-white rounded-3xl w-full max-w-lg p-5">
                        <div className="flex justify-between items-center mb-4"><h3 className="text-xl font-black">تسوية مبلغ مستلم خارج المكتب</h3><button onClick={() => setSettlementPayment(null)}><X size={22} /></button></div>
                        <div className="bg-violet-50 border border-violet-200 rounded-xl p-3 mb-4 text-sm">المبلغ الذي سيُدخل إلى الخزينة أو البنك: <b>{formatAmount(settlementPayment.EquivalentEGP, 'EGP')}</b></div>
                        <div className="space-y-3">
                            <div><label className="block text-sm font-bold mb-1">جهة التسوية</label><select value={settlementForm.paymentMethodType} onChange={(e) => setSettlementForm({ ...settlementForm, paymentMethodType: e.target.value, paymentMethodId: '' })} className="w-full border rounded-xl px-3 py-2"><option value="treasury">خزينة المكتب</option><option value="bank">حساب بنكي</option></select></div>
                            {settlementForm.paymentMethodType === 'bank' && <div><label className="block text-sm font-bold mb-1">الحساب البنكي</label><select value={settlementForm.paymentMethodId} onChange={(e) => setSettlementForm({ ...settlementForm, paymentMethodId: e.target.value })} className="w-full border rounded-xl px-3 py-2"><option value="">اختر الحساب</option>{banks.map(item => <option key={item.id || item.AccountID} value={item.id || item.AccountID}>{item.name || item.Name}</option>)}</select></div>}
                            <div><label className="block text-sm font-bold mb-1">تاريخ التسوية</label><input type="date" value={settlementForm.settlementDate} onChange={(e) => setSettlementForm({ ...settlementForm, settlementDate: e.target.value })} className="w-full border rounded-xl px-3 py-2" /></div>
                            <div><label className="block text-sm font-bold mb-1">ملاحظات</label><textarea rows={3} value={settlementForm.notes} onChange={(e) => setSettlementForm({ ...settlementForm, notes: e.target.value })} className="w-full border rounded-xl px-3 py-2" /></div>
                        </div>
                        <div className="flex justify-end gap-2 mt-5"><button onClick={() => setSettlementPayment(null)} className="border rounded-xl px-5 py-2">إلغاء</button><button onClick={submitSettlement} className="bg-violet-600 text-white rounded-xl px-6 py-2 font-black">تأكيد التسوية</button></div>
                    </div>
                </div>
            )}
        </div>
    );
};



// أضف هذا المكون قبل السطر الأخير في الملف (قبل export default)
const RequiredPaymentManager = ({ isOpen, onClose, showToast }) => {
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('individual');
    
    // حالات البيانات
    const [clients, setClients] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [selectedClients, setSelectedClients] = useState([]);
    
    // حالات النموذج
    const [formData, setFormData] = useState({
        selectedClient: null,
        selectedCompany: '',
        amount: '',
        notes: '',
        searchTerm: ''
    });


    // إعدادات التنبيهات - أضف هذا
const [scheduleSettings, setScheduleSettings] = useState({
    isActive: false,
    reminderPeriodDays: 90, // 3 شهور = 90 يوم
    autoReminder: true,
    showPopupWarning: true,
    blockDeposits: false, // منع الإيداعات عند انتهاء المدة
    emailNotifications: false
});

const [overdueClients, setOverdueClients] = useState([]);


useEffect(() => {
    if (isOpen) {
        console.log('🚀 فتح نافذة إدارة المبالغ المطلوبة');
        const loadData = async () => {
            try {
                console.log('📊 بدء تحميل البيانات...');
                setLoading(true);
                
                await Promise.all([
                    loadClients(),
                    loadCompanies(),
                    loadScheduleSettings()
                ]);
                
                console.log('✅ تم تحميل جميع البيانات بنجاح');
            } catch (error) {
                console.error('❌ خطأ في تحميل البيانات:', error);
                showToast('فشل في تحميل البيانات', 'error');
            } finally {
                setLoading(false);
            }
        };
        loadData();
    }
}, [isOpen]);

// أضف useEffect جديد
useEffect(() => {
    if (activeTab === 'schedule' && scheduleSettings.isActive) {
        loadOverdueClients();
    }
}, [activeTab, scheduleSettings.reminderPeriodDays]);


const loadClients = async () => {
    try {
        console.log('📥 بدء تحميل العملاء النشطين...');
        setLoading(true);
        
        // استخدام endpoint العملاء النشطين فقط
        const response = await fetch(`${API_BASE}/active-clients`);
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        console.log('✅ تم تحميل العملاء النشطين:', data.length);
        setClients(data);
        
        if (data.length === 0) {
            console.warn('⚠️ لا توجد عملاء نشطين في النظام');
            showToast('لا توجد عملاء نشطين مسجلين في النظام', 'warning');
        }
    } catch (error) {
        console.error('❌ خطأ في جلب العملاء:', error);
        showToast('فشل في جلب بيانات العملاء: ' + error.message, 'error');
    } finally {
        setLoading(false);
    }
};


const ClientStatusBadge = ({ client }) => {
    if (!client.IsActive) {
        return (
            <div className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 border border-yellow-200">
                <AlertCircle size={12} className="mr-1" />
                عميل مؤرشف
            </div>
        );
    }
    return null;
};


const loadCompanies = async () => {
    try {
        console.log('🏢 بدء تحميل الشركات...');
        setLoading(true);
        
        const response = await fetch(`${API_BASE}/companies`);
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        console.log('✅ تم تحميل الشركات:', data.length);
        setCompanies(data);
        
        if (data.length === 0) {
            console.warn('⚠️ لا توجد شركات في النظام');
            showToast('لا توجد شركات مسجلة في النظام', 'warning');
        }
    } catch (error) {
        console.error('❌ خطأ في جلب الشركات:', error);
        showToast('فشل في جلب بيانات الشركات: ' + error.message, 'error');
    } finally {
        setLoading(false);
    }
};
    // البحث في العملاء
    const filteredClients = clients.filter(client => 
        client.NameArabic?.toLowerCase().includes(formData.searchTerm.toLowerCase()) ||
        client.NationalID?.includes(formData.searchTerm) ||
        client.CompanyName?.toLowerCase().includes(formData.searchTerm.toLowerCase())
    );

    // تحديد المبلغ لعميل واحد
const getCurrentUser = () => {
    try {
        const user = JSON.parse(localStorage.getItem('user'));
        return user?.Username || 'System';
    } catch { return 'System'; }
};

   const updateSingleClient = async () => {
    if (!formData.selectedClient || !formData.amount) {
        showToast('يرجى اختيار عميل وإدخال المبلغ', 'error');
        return;
    }

    try {
        setLoading(true);
        console.log('💰 بدء تحديث المبلغ المطلوب للعميل:', formData.selectedClient.PassportID);
        
        const response = await fetch(`${API_BASE}/clients/${formData.selectedClient.PassportID}/payment`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                RequiredPayment: parseFloat(formData.amount),
                Notes: formData.notes,
                UpdatedBy: getCurrentUser()
            })
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'فشل في تحديث المبلغ');
        }

        const responseData = await response.json();
        console.log('✅ تم تحديث المبلغ بنجاح:', responseData);
        
        showToast('تم تحديث المبلغ المطلوب بنجاح', 'success');
        resetForm();
        
        // تحديث قائمة العملاء
        await loadClients();
        
    } catch (error) {
        console.error('❌ خطأ في تحديث المبلغ:', error);
        showToast(error.message, 'error');
    } finally {
        setLoading(false);
    }
};

    // تحديد المبلغ لشركة كاملة
    const updateCompanyClients = async () => {
        if (!formData.selectedCompany || !formData.amount) {
            showToast('يرجى اختيار شركة وإدخال المبلغ', 'error');
            return;
        }

        const companyClients = clients.filter(c => c.CompanyName === formData.selectedCompany);
        
        if (!window.confirm(`هل أنت متأكد من تحديد المبلغ لجميع عملاء شركة "${formData.selectedCompany}"؟ (${companyClients.length} عميل)`)) {
            return;
        }

        try {
            setLoading(true);
            let successCount = 0;
            let failureCount = 0;

            // تحديث كل عميل في الشركة
            for (const client of companyClients) {
                try {
                    const response = await fetch(`${API_BASE}/clients/${client.PassportID}/payment`, {

                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            RequiredPayment: parseFloat(formData.amount),
                            Notes: formData.notes,
                            UpdatedBy: getCurrentUser()
                        })
                    });

                    if (response.ok) {
                        successCount++;
                    } else {
                        failureCount++;
                    }
                } catch (error) {
                    failureCount++;
                }
            }

            showToast(`تم تحديث ${successCount} عميل، فشل ${failureCount} عميل`, successCount > 0 ? 'success' : 'error');
            resetForm();
        } catch (error) {
            showToast(error.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    // تحديد المبلغ لعملاء مختارين
    const updateSelectedClients = async () => {
        if (selectedClients.length === 0 || !formData.amount) {
            showToast('يرجى اختيار عملاء وإدخال المبلغ', 'error');
            return;
        }

        if (!window.confirm(`هل أنت متأكد من تحديد المبلغ لـ ${selectedClients.length} عميل؟`)) {
            return;
        }

        try {
            setLoading(true);
            let successCount = 0;
            let failureCount = 0;

            // تحديث كل عميل محدد
            for (const client of selectedClients) {
                try {
                   const response = await fetch(`${API_BASE}/clients/${client.PassportID}/payment`, {

                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            RequiredPayment: parseFloat(formData.amount),
                            Notes: formData.notes,
                            UpdatedBy: getCurrentUser()
                        })
                    });

                    if (response.ok) {
                        successCount++;
                    } else {
                        failureCount++;
                    }
                } catch (error) {
                    failureCount++;
                }
            }

            showToast(`تم تحديث ${successCount} عميل، فشل ${failureCount} عميل`, successCount > 0 ? 'success' : 'error');
            setSelectedClients([]);
            resetForm();
        } catch (error) {
            showToast(error.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    const resetForm = () => {
        setFormData({
            selectedClient: null,
            selectedCompany: '',
            amount: '',
            notes: '',
            searchTerm: ''
        });
    };

    // دوال إدارة التنبيهات - أضف هذا
const loadScheduleSettings = async () => {
    try {
        const response = await fetch(`${API_BASE}/payment-reminders/settings`);
        if (response.ok) {
            const data = await response.json();
            setScheduleSettings({
                isActive: data.IsActive || false,
                reminderPeriodDays: data.ReminderPeriodDays || 90,
                autoReminder: data.AutoReminder || true,
                showPopupWarning: data.ShowPopupWarning || true,
                blockDeposits: data.BlockDeposits || false,
                emailNotifications: data.EmailNotifications || false
            });
        }
    } catch (error) {
        console.error('خطأ في جلب إعدادات التنبيهات:', error);
        // لا تظهر خطأ للمستخدم، فقط استخدم الإعدادات الافتراضية
    }
};

const saveScheduleSettings = async () => {
    try {
        setLoading(true);
        const response = await fetch(`${API_BASE}/payment-reminders/settings`, {

            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                ...scheduleSettings,
                updatedBy: getCurrentUser()
            })
        });

        if (response.ok) {
            showToast('تم حفظ إعدادات التنبيهات بنجاح', 'success');
        } else {
            throw new Error('فشل في حفظ إعدادات التنبيهات');
        }
    } catch (error) {
        showToast(error.message, 'error');
    } finally {
        setLoading(false);
    }
};

const loadOverdueClients = async () => {
    try {
        const response = await fetch(`${API_BASE}/clients/overdue-payments?days=${scheduleSettings.reminderPeriodDays}`);

        if (response.ok) {
            const data = await response.json();
            setOverdueClients(data);
        }
    } catch (error) {
        console.error('خطأ في جلب العملاء المتأخرين:', error);
    }
};

const updateClientPaymentDate = async (clientId) => {
    try {
       const response = await fetch(`${API_BASE}/clients/${clientId}/update-payment-date`, {

            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updatedBy: getCurrentUser() })
        });

        if (response.ok) {
            showToast('تم تحديث تاريخ المبلغ المطلوب', 'success');
            loadOverdueClients(); // تحديث القائمة
        } else {
            throw new Error('فشل في تحديث التاريخ');
        }
    } catch (error) {
        showToast(error.message, 'error');
    }
};


    const toggleClientSelection = (client) => {
        setSelectedClients(prev => {
            const isSelected = prev.some(c => c.PassportID === client.PassportID);
            if (isSelected) {
                return prev.filter(c => c.PassportID !== client.PassportID);
            } else {
                return [...prev, client];
            }
        });
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl w-full max-w-5xl mx-4 max-h-[90vh] overflow-hidden">
                {/* رأس النافذة */}
                <div className="bg-gradient-to-r from-purple-600 to-purple-700 text-white p-6">
                    <div className="flex justify-between items-center">
                        <h2 className="text-2xl font-bold flex items-center gap-3">
                            <DollarSign size={28} />
                            إدارة المبالغ المطلوبة - تحكم كامل
                        </h2>
                        <button onClick={onClose} className="text-white hover:text-gray-200">
                            <X size={24} />
                        </button>
                    </div>
                    <p className="mt-2 text-purple-100">
                        تحكم كامل في تحديد المبالغ المطلوبة للعملاء - فردي أو جماعي
                    </p>
                </div>

                {/* شريط التبويبات */}
                <div className="bg-gray-50 border-b flex">
                    <button
                        className={`py-3 px-6 font-medium ${activeTab === 'individual' 
                            ? 'bg-white text-purple-600 border-b-2 border-purple-600' 
                            : 'text-gray-600 hover:text-gray-800'}`}
                        onClick={() => setActiveTab('individual')}
                    >
                        <User size={16} className="inline mr-2" />
                        عميل واحد
                    </button>
                    <button
                        className={`py-3 px-6 font-medium ${activeTab === 'company' 
                            ? 'bg-white text-purple-600 border-b-2 border-purple-600' 
                            : 'text-gray-600 hover:text-gray-800'}`}
                        onClick={() => setActiveTab('company')}
                    >
                        <Building size={16} className="inline mr-2" />
                        شركة كاملة
                    </button>
                    <button
                        className={`py-3 px-6 font-medium ${activeTab === 'bulk' 
                            ? 'bg-white text-purple-600 border-b-2 border-purple-600' 
                            : 'text-gray-600 hover:text-gray-800'}`}
                        onClick={() => setActiveTab('bulk')}
                    >
                        <Package size={16} className="inline mr-2" />
                        عملاء مختارين
                    </button>
                    <button
    className={`py-3 px-6 font-medium ${activeTab === 'schedule' 
        ? 'bg-white text-purple-600 border-b-2 border-purple-600' 
        : 'text-gray-600 hover:text-gray-800'}`}
    onClick={() => setActiveTab('schedule')}
>
    <Clock size={16} className="inline mr-2" />
    إعدادات التنبيهات
</button>

                </div>

                <div className="p-6 overflow-y-auto max-h-[60vh]">
                    {/* تبويب العميل الواحد */}
                    {activeTab === 'individual' && (
                        <div className="space-y-6">
                               {/* مؤشر التحميل */}
        {loading && (
            <div className="text-center py-8">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-500 mx-auto mb-2"></div>
                <p className="text-gray-500">جاري تحميل البيانات...</p>
            </div>
        )}
                            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                                <h3 className="font-bold text-blue-800 mb-2">تحديد مبلغ لعميل واحد</h3>
                                <p className="text-sm text-blue-700">
                                    اختر عميل محدد وحدد له المبلغ المطلوب مع إمكانية إضافة ملاحظات
                                </p>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block text-sm font-medium mb-2">البحث عن العميل</label>
                                    <input
                                        type="text"
                                        value={formData.searchTerm}
                                        onChange={(e) => setFormData({...formData, searchTerm: e.target.value})}
                                        placeholder="ابحث بالاسم أو الرقم القومي..."
                                        className="w-full border rounded-lg p-3 focus:ring-2 focus:ring-purple-500"
                                    />
                                    
                                    {formData.searchTerm && (
                                        <div className="mt-2 max-h-40 overflow-y-auto border rounded-lg">
                                            {filteredClients.map(client => (
                                                <div
                                                    key={client.PassportID}
                                                    onClick={() => setFormData({
                                                        ...formData, 
                                                        selectedClient: client,
                                                        searchTerm: ''
                                                    })}
                                                    className="p-3 hover:bg-gray-50 cursor-pointer border-b last:border-b-0"
                                                >
                                                    <div className="font-medium">{client.NameArabic}</div>
                                                    <div className="text-sm text-gray-500">
                                                        {client.NationalID} - {client.CompanyName || 'بدون شركة'}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {formData.selectedClient && (
                                        <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg">
                                            <div className="font-medium text-green-800">
                                                العميل المختار: {formData.selectedClient.NameArabic}
                                            </div>
                                            <div className="text-sm text-green-700">
                                                {formData.selectedClient.NationalID}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-medium mb-2">المبلغ المطلوب (ج.م)</label>
                                        <input
                                            type="number"
                                            value={formData.amount}
                                            onChange={(e) => setFormData({...formData, amount: e.target.value})}
                                            placeholder="أدخل المبلغ"
                                            className="w-full border rounded-lg p-3 focus:ring-2 focus:ring-purple-500"
                                            step="0.01"
                                            min="0"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium mb-2">ملاحظات</label>
                                        <textarea
                                            value={formData.notes}
                                            onChange={(e) => setFormData({...formData, notes: e.target.value})}
                                            placeholder="أضف ملاحظات..."
                                            className="w-full border rounded-lg p-3 h-24 focus:ring-2 focus:ring-purple-500"
                                        />
                                    </div>

                                    <button
                                        onClick={updateSingleClient}
                                        disabled={!formData.selectedClient || !formData.amount || loading}
                                        className="w-full bg-purple-600 text-white py-3 rounded-lg font-medium hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        {loading ? 'جاري التحديث...' : 'تحديث المبلغ للعميل'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* تبويب الشركة */}
                    {activeTab === 'company' && (
                        <div className="space-y-6">
                            <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
                                <h3 className="font-bold text-orange-800 mb-2">تحديد مبلغ لشركة كاملة</h3>
                                <p className="text-sm text-orange-700">
                                    سيتم تطبيق نفس المبلغ على جميع عملاء الشركة المختارة
                                </p>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block text-sm font-medium mb-2">اختر الشركة</label>
                                    <select
                                        value={formData.selectedCompany}
                                        onChange={(e) => setFormData({...formData, selectedCompany: e.target.value})}
                                        className="w-full border rounded-lg p-3 focus:ring-2 focus:ring-purple-500"
                                    >
                                        <option value="">اختر شركة...</option>
                                        {companies.map(company => (
                                            <option key={company.CompanyName} value={company.CompanyName}>
                                                {company.CompanyName} ({clients.filter(c => c.CompanyName === company.CompanyName).length} عميل)
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-medium mb-2">المبلغ المطلوب (ج.م)</label>
                                        <input
                                            type="number"
                                            value={formData.amount}
                                            onChange={(e) => setFormData({...formData, amount: e.target.value})}
                                            placeholder="أدخل المبلغ"
                                            className="w-full border rounded-lg p-3 focus:ring-2 focus:ring-purple-500"
                                            step="0.01"
                                            min="0"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium mb-2">ملاحظات</label>
                                        <textarea
                                            value={formData.notes}
                                            onChange={(e) => setFormData({...formData, notes: e.target.value})}
                                            placeholder="أضف ملاحظات..."
                                            className="w-full border rounded-lg p-3 h-24 focus:ring-2 focus:ring-purple-500"
                                        />
                                    </div>

                                    <button
                                        onClick={updateCompanyClients}
                                        disabled={!formData.selectedCompany || !formData.amount || loading}
                                        className="w-full bg-orange-600 text-white py-3 rounded-lg font-medium hover:bg-orange-700 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        {loading ? 'جاري التحديث...' : 'تحديث المبلغ لكامل الشركة'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* تبويب العملاء المختارين */}
                    {activeTab === 'bulk' && (
                        <div className="space-y-6">
                            <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                                <h3 className="font-bold text-green-800 mb-2">تحديد مبلغ لعملاء مختارين</h3>
                                <p className="text-sm text-green-700">
                                    اختر عدة عملاء من القائمة وحدد لهم نفس المبلغ المطلوب
                                </p>
                            </div>

                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                                <div className="lg:col-span-2">
                                    <div className="flex justify-between items-center mb-3">
                                        <label className="block text-sm font-medium">قائمة العملاء</label>
                                        <span className="text-sm text-gray-500">
                                            محدد: {selectedClients.length} عميل
                                        </span>
                                    </div>
                                    
                                    <input
                                        type="text"
                                        value={formData.searchTerm}
                                        onChange={(e) => setFormData({...formData, searchTerm: e.target.value})}
                                        placeholder="البحث في العملاء..."
                                        className="w-full border rounded-lg p-2 mb-3 focus:ring-2 focus:ring-purple-500"
                                    />

                                    <div className="border rounded-lg max-h-64 overflow-y-auto">
                                        {filteredClients.map(client => (
                                            <div
                                                key={client.PassportID}
                                                className={`p-3 border-b last:border-b-0 cursor-pointer hover:bg-gray-50 ${
                                                    selectedClients.some(c => c.PassportID === client.PassportID) 
                                                        ? 'bg-purple-50 border-l-4 border-l-purple-600' 
                                                        : ''
                                                }`}
                                                onClick={() => toggleClientSelection(client)}
                                            >
                                                <div className="flex justify-between items-center">
                                                    <div>
                                                        <div className="font-medium">{client.NameArabic}</div>
                                                        <div className="text-sm text-gray-500">
                                                            {client.NationalID} - {client.CompanyName || 'بدون شركة'}
                                                        </div>
                                                    </div>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedClients.some(c => c.PassportID === client.PassportID)}
                                                        onChange={() => toggleClientSelection(client)}
                                                        className="w-5 h-5 text-purple-600"
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-medium mb-2">المبلغ المطلوب (ج.م)</label>
                                        <input
                                            type="number"
                                            value={formData.amount}
                                            onChange={(e) => setFormData({...formData, amount: e.target.value})}
                                            placeholder="أدخل المبلغ"
                                            className="w-full border rounded-lg p-3 focus:ring-2 focus:ring-purple-500"
                                            step="0.01"
                                            min="0"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium mb-2">ملاحظات</label>
                                        <textarea
                                            value={formData.notes}
                                            onChange={(e) => setFormData({...formData, notes: e.target.value})}
                                            placeholder="أضف ملاحظات..."
                                            className="w-full border rounded-lg p-3 h-24 focus:ring-2 focus:ring-purple-500"
                                        />
                                    </div>

                                    <div className="bg-gray-50 p-3 rounded-lg">
                                        <h4 className="font-medium mb-2">العملاء المختارين:</h4>
                                        {selectedClients.length === 0 ? (
                                            <p className="text-sm text-gray-500">لم يتم اختيار أي عميل</p>
                                        ) : (
                                            <div className="space-y-1">
                                                {selectedClients.slice(0, 3).map(client => (
                                                    <div key={client.PassportID} className="text-sm">
                                                        {client.NameArabic}
                                                    </div>
                                                ))}
                                                {selectedClients.length > 3 && (
                                                    <div className="text-sm text-gray-500">
                                                        و {selectedClients.length - 3} عميل آخر...
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>

                                    <button
                                        onClick={updateSelectedClients}
                                        disabled={selectedClients.length === 0 || !formData.amount || loading}
                                        className="w-full bg-green-600 text-white py-3 rounded-lg font-medium hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        {loading ? 'جاري التحديث...' : `تحديث المبلغ لـ ${selectedClients.length} عميل`}
                                    </button>
                                </div>
                            </div>
                        </div>
                 )}

                    {/* تبويب إعدادات التنبيهات - أضف هذا */}
                    {activeTab === 'schedule' && (
                        <div className="space-y-6">
                            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                                <h3 className="font-bold text-yellow-800 mb-2">إعدادات تنبيهات المبالغ المطلوبة</h3>
                                <p className="text-sm text-yellow-700">
                                    تحكم في متى يجب تنبيهك لتحديث المبالغ المطلوبة للعملاء وكيفية التعامل مع المبالغ القديمة
                                </p>
                            </div>

                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                                {/* إعدادات التنبيهات */}
                                <div className="space-y-4">
                                    <h4 className="font-semibold text-lg">إعدادات التنبيهات</h4>
                                    
                                    <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                                        <div>
                                            <span className="font-medium">تفعيل نظام التنبيهات</span>
                                            <p className="text-sm text-gray-600">تنبيهات عند انتهاء صلاحية المبلغ المطلوب</p>
                                        </div>
                                        <label className="relative inline-flex items-center cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={scheduleSettings.isActive}
                                                onChange={(e) => setScheduleSettings({...scheduleSettings, isActive: e.target.checked})}
                                                className="sr-only peer"
                                            />
                                            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-purple-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-purple-600"></div>
                                        </label>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium mb-2">
                                            فترة صلاحية المبلغ المطلوب (بالأيام)
                                        </label>
                                        <div className="flex gap-2 items-center">
                                            <input
                                                type="number"
                                                value={scheduleSettings.reminderPeriodDays}
                                                onChange={(e) => setScheduleSettings({
                                                    ...scheduleSettings, 
                                                    reminderPeriodDays: parseInt(e.target.value) || 90
                                                })}
                                                className="w-24 border rounded-lg p-2 focus:ring-2 focus:ring-purple-500"
                                                min="1"
                                            />
                                            <span className="text-sm text-gray-600">يوم</span>
                                            <span className="text-xs text-gray-500">
                                                (حوالي {Math.round(scheduleSettings.reminderPeriodDays / 30)} شهر)
                                            </span>
                                        </div>
                                        <p className="text-xs text-gray-500 mt-1">
                                            بعد هذه المدة سيتم اعتبار المبلغ المطلوب قديم ويحتاج تحديث
                                        </p>
                                    </div>

                                    <div className="space-y-3">
                                        <div className="flex items-center justify-between">
                                            <span className="text-sm font-medium">تنبيهات تلقائية</span>
                                            <input
                                                type="checkbox"
                                                checked={scheduleSettings.autoReminder}
                                                onChange={(e) => setScheduleSettings({...scheduleSettings, autoReminder: e.target.checked})}
                                                className="w-4 h-4 text-purple-600"
                                            />
                                        </div>

                                        <div className="flex items-center justify-between">
                                            <span className="text-sm font-medium">عرض تحذير منبثق</span>
                                            <input
                                                type="checkbox"
                                                checked={scheduleSettings.showPopupWarning}
                                                onChange={(e) => setScheduleSettings({...scheduleSettings, showPopupWarning: e.target.checked})}
                                                className="w-4 h-4 text-purple-600"
                                            />
                                        </div>

                                        <div className="flex items-center justify-between">
                                            <div>
                                                <span className="text-sm font-medium">منع الإيداعات للمبالغ المنتهية الصلاحية</span>
                                                <p className="text-xs text-gray-500">سيتم منع إضافة إيداعات إذا انتهت صلاحية المبلغ المطلوب</p>
                                            </div>
                                            <input
                                                type="checkbox"
                                                checked={scheduleSettings.blockDeposits}
                                                onChange={(e) => setScheduleSettings({...scheduleSettings, blockDeposits: e.target.checked})}
                                                className="w-4 h-4 text-purple-600"
                                            />
                                        </div>

                                        <div className="flex items-center justify-between">
                                            <span className="text-sm font-medium">تنبيهات عبر البريد الإلكتروني</span>
                                            <input
                                                type="checkbox"
                                                checked={scheduleSettings.emailNotifications}
                                                onChange={(e) => setScheduleSettings({...scheduleSettings, emailNotifications: e.target.checked})}
                                                className="w-4 h-4 text-purple-600"
                                            />
                                        </div>
                                    </div>

                                    <button
                                        onClick={saveScheduleSettings}
                                        disabled={loading}
                                        className="w-full bg-yellow-600 text-white py-2 rounded-lg font-medium hover:bg-yellow-700 disabled:opacity-50"
                                    >
                                        {loading ? 'جاري الحفظ...' : 'حفظ إعدادات التنبيهات'}
                                    </button>
                                </div>

                                {/* العملاء المنتهية صلاحية مبالغهم */}
                                <div className="space-y-4">
                                    <div className="flex justify-between items-center">
                                        <h4 className="font-semibold text-lg">العملاء المنتهية الصلاحية</h4>
                                        <button
                                            onClick={loadOverdueClients}
                                            className="text-purple-600 hover:text-purple-800 flex items-center gap-1"
                                        >
                                            <RefreshCw size={16} />
                                            تحديث
                                        </button>
                                    </div>

                                    {scheduleSettings.isActive ? (
                                        <div className="border rounded-lg max-h-80 overflow-y-auto">
                                            {overdueClients.length === 0 ? (
                                                <div className="p-6 text-center text-gray-500">
                                                    <CheckCircle size={48} className="mx-auto text-green-400 mb-2" />
                                                    <p>ممتاز! لا توجد مبالغ منتهية الصلاحية</p>
                                                </div>
                                            ) : (
                                                <div className="divide-y">
                                                    {overdueClients.map(client => (
                                                        <div key={client.PassportID} className="p-4 hover:bg-gray-50">
                                                            <div className="flex justify-between items-start">
                                                                <div>
                                                                    <div className="font-medium">{client.NameArabic}</div>
                                                                    <div className="text-sm text-gray-500">
                                                                        {client.NationalID} - {client.CompanyName || 'بدون شركة'}
                                                                    </div>
                                                                    <div className="text-sm text-red-600 mt-1">
                                                                        المبلغ المطلوب: {client.RequiredPayment?.toLocaleString()} ج.م
                                                                    </div>
                                                                    <div className="text-xs text-gray-500">
                                                                        آخر تحديث: {new Date(client.LastPaymentUpdateDate).toLocaleDateString('ar-EG')}
                                                                    </div>
                                                                    <div className="text-xs text-red-500">
                                                                        منتهي الصلاحية منذ {client.DaysOverdue} يوم
                                                                    </div>
                                                                </div>
                                                                <div className="flex flex-col gap-2">
                                                                    <button
                                                                        onClick={() => {
                                                                            setFormData({
                                                                                ...formData,
                                                                                selectedClient: client
                                                                            });
                                                                            setActiveTab('individual');
                                                                        }}
                                                                        className="text-xs bg-purple-600 text-white px-3 py-1 rounded hover:bg-purple-700"
                                                                    >
                                                                        تحديث المبلغ
                                                                    </button>
                                                                    <button
                                                                        onClick={() => updateClientPaymentDate(client.PassportID)}
                                                                        className="text-xs bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700"
                                                                    >
                                                                        تجديد التاريخ
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="border rounded-lg p-6 text-center text-gray-500">
                                            <AlertCircle size={48} className="mx-auto text-gray-300 mb-2" />
                                            <p>يجب تفعيل نظام التنبيهات أولاً</p>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* معلومات إضافية */}
                            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                                <h4 className="font-bold text-blue-800 mb-2">كيف يعمل النظام؟</h4>
                                <ul className="text-sm text-blue-700 space-y-1">
                                    <li>• سيتم تنبيهك عند محاولة إضافة إيداع لعميل انتهت صلاحية مبلغه المطلوب</li>
                                    <li>• يمكنك اختيار منع الإيداعات تماماً أو مجرد عرض تحذير</li>
                                    <li>• سيتم عرض قائمة بجميع العملاء المنتهية صلاحية مبالغهم</li>
                                    <li>• يمكنك تحديث المبلغ أو تجديد تاريخ آخر تحديث فقط</li>
                                </ul>
                            </div>
                        </div>
                    )}
                </div>

                {/* أزرار النافذة */}
                <div className="bg-gray-50 px-6 py-4 flex justify-between">
                    <button
                        onClick={resetForm}
                        className="text-gray-600 hover:text-gray-800"
                    >
                        مسح البيانات
                    </button>
                    <button
                        onClick={onClose}
                        className="bg-gray-600 text-white px-6 py-2 rounded-lg hover:bg-gray-700"
                    >
                        إغلاق
                    </button>
                </div>
            </div>
        </div>
    );
};



<style dangerouslySetInnerHTML={{
    __html: `
    @media (max-width: 640px) {
        table {
            font-size: 0.75rem !important;
        }
        th, td {
            padding: 0.4rem 0.35rem !important;
        }
        .rounded-full {
            padding: 0.15rem 0.5rem !important;
        }
    }
    
    @media (min-width: 1920px) {
        .max-w-\\[98\\%\\] {
            max-width: 90% !important;
        }
    }

    .table-container {
        margin-left: -0.25rem;
        margin-right: -0.25rem;
    }
    `
}} />




export default ClientAccounts;
